import React, { createContext, useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { format } from "date-fns";
import logoURL from "./TextoLogo64"; // Importa logoURL desde TextoLogo64.js
import TextoLogo64COLON from "./TextoLogo64COLON"; // Importa logoURL desde TextoLogo64.js
import logoTop from "./PruebaImgTopFactura"; // Importa logoURL desde TextoLogo64.js
import logoDown from "./PruebaImgDownFactura"; // Importa logoURL desde TextoLogo64.js
import QR from "./QrWsp.js"; // Importa logoURL desde TextoLogo64.js
import jwtDecode from "jwt-decode";

import { abrirFacturaHtml } from "./facturaAfipHtmlGenerator.js";
import { invalidarCacheUbicaciones, resolverEmisorImpresion } from "./emisorImpresion.js";
import { deliverPdf } from "./pdf_esqueletos/helpers/pdfDelivery.js";

import { useNavigate, useLocation } from "react-router-dom";

import { erpCookies } from "../utils/erpCookies.js";
import {
  persistLiveSession,
  clearLiveSession,
  clearPersistedSession,
  syncSessionToTenant,
  getTenantFromPathname,
} from "../utils/tenantSession.js";

import jsPDF from "jspdf";
import "jspdf-autotable"; // Importa la función autoTable

import QRCode from "qrcode";

// ############################################################################################################################## FECHAS
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// SOLUCION FECHA LOCAL TOMADA DEL NAVEGADOR *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(tz);

// FECHA HORA ACTUAL GLOBAL
// const getFechaHoraActualClient = async () => {
//   return new Date().toLocaleDateString();
// }

function getFechaHoraActualClient(fechahora = null) {
  // Detectar la zona del navegador (ej: "America/Argentina/Buenos_Aires")
  const zona = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Si no se pasa fechahora, usar ahora mismo
  const fecha = fechahora ? dayjs(fechahora).tz(zona) : dayjs().tz(zona);

  // Devolver como string ISO 8601 con offset (ej: 2025-08-06T00:00:00-03:00)
  const fechaFormateada = fecha.format();

  return {
    fechaServidor: fechaFormateada,
    zona: zona,
  };
}

// TIME ZONES:
// America/Argentina/Cordoba
// America/Mexico_City

// EN TODAS LAS VENTANAS DE FILTRO DE FECHAS HAY QUE AGREGAR LA ZONA. PORQUE ESTAMOS CONSTRUYENDO TIMESTAMP:   'DD/MM/YYYY HH:mm:ss' y necesitamos TIMESTAMPZ para que se compare correctamente con el servidor.

// FUNCIONES: ######

// ### dayjs(): devuelve una fecha y hora sin zona explicita. infiere zona UNIVERSAL, UTC.
// osea que al usar dayjs() SIEMPRE debemos especificar la zona:    dayjs(fechaProcesar).tz(zona)

// ejemplo:
//let fechaProcesar = dayjs(ultimaCaja.fecha).tz(zona).add(1, 'day'); :  ultimaCaja.fecha esta en utc, tz(zona) la convierte a zona, no le dice que esta en zona "zona" sino que lo convierte

// ### new Date(): en JavaScript te devuelve la fecha y hora actual del momento exacto en que se ejecuta, representado como un objeto Date. asume UTC

// ### toDate(): el objeto Date pierde la información de zona horaria visual, pero conserva el instante correcto. el server va a grabar la fecha como esta formateada segun toDate() pero va a inferir la zona. lo cual puede llevar a problemas.
// usamos toDate() en el momento en el que vamos a comparar una fecha con otra o usarla en una condicion.

// ---------------------------------
//---------------------------------
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// ##############################################################################################################################
// URL GLOBAL - Configurado desde .env
const MODE = process.env.REACT_APP_MODE;
let serverURL;

if (MODE === 'production') {
  serverURL = process.env.REACT_APP_URL_PROD || 'http://localhost:5000';
} else {
  serverURL = process.env.REACT_APP_URL_DEV || 'http://localhost:5000';
}
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-
// URL GLOBAL
// const serverURL = "http://localhost:5000";
// const serverURL = "https://erp.lutente.com:5000";
// const serverURL = "http://147.93.12.4:4001";
// *-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-

// CREAR CONTEXT ***********************************************************************
// CREAR CONTEXT ***********************************************************************
// CREAR CONTEXT ***********************************************************************
export const ErpContext = createContext(); //Se define un contexto global utilizando createContext(), que se utiliza para compartir información a través de la aplicación.

function leerUsuarioGuardado() {
  try {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");
    if (token && savedUser) {
      const userParsed = JSON.parse(savedUser);
      return {
        ...userParsed,
        token,
        accesosFuncionalidad: userParsed.accesosFuncionalidad || [],
      };
    }
    if (token) {
      return { ...jwtDecode(token), token };
    }
  } catch (error) {
    console.error("No se pudo restaurar la sesión:", error);
  }
  return null;
}

export const ErpProvider = ({ children }) => {
  //La propiedad children representa los componentes hijos que estarán dentro del proveedor.

  // ADMIN CONTEXT ***********************************************************************
  // ADMIN CONTEXT ***********************************************************************
  // ADMIN CONTEXT ***********************************************************************

  // IMPUESTO HARDCODED ***********************************************************************
  const ivaHardcoded = 21;

  /**
   * Formatea el stock para visualización:
   * - Enteros: sin decimales (5, 10, 100)
   * - Con decimales: solo los decimales significativos, coma como separador (5,5; 0,1234)
   */
  const formatStock = (value) => {
    if (value === null || value === undefined || value === "" || value === "null" || value === "undefined") {
      return "0"
    }
    let numValue
    if (typeof value === "number") {
      numValue = value
    } else if (typeof value === "string") {
      const cleaned = value.toString().trim().replace(",", ".")
      numValue = parseFloat(cleaned)
    } else {
      numValue = Number(value)
    }
    if (isNaN(numValue) || !isFinite(numValue)) {
      return "0"
    }
    const rounded = Math.round(numValue * 10000) / 10000
    if (rounded === Math.round(rounded)) {
      return Math.round(rounded).toString()
    }
    const str = rounded.toString()
    const [entera, decimal] = str.split(".")
    const decimalLimpio = (decimal || "").replace(/0+$/, "")
    const resultado = decimalLimpio ? `${entera},${decimalLimpio}` : entera
    return resultado
  }

  // ADMIN UBICACIONES ***********************************************************************

  // AXIOS COOKIE
  // O, si prefieres usar el interceptor global:
  axios.interceptors.request.use((config) => {
    config.withCredentials = true;
    
    // 🔒 Validar cookie de seguridad antes de cada petición
    // Solo validar para rutas que NO sean login (login no necesita cookie)
    if (!config.url.includes("/login")) {
      const tenantCookie = erpCookies.get("tenant");
      const savedUser = localStorage.getItem("user");
      const savedToken = localStorage.getItem("token");
      
      // Si hay usuario logueado pero no hay cookie de seguridad
      if (savedUser && !tenantCookie) {
        // Verificar si el token JWT es válido antes de bloquear
        // Puede ser un problema temporal de cookies
        if (savedToken) {
          try {
            const decodedToken = jwtDecode(savedToken);
            const currentTime = Date.now() / 1000;
            
            // Solo bloquear si el token también expiró
            if (decodedToken.exp && decodedToken.exp < currentTime) {
              console.error("⚠️ Petición bloqueada: cookie tenant y token JWT expirados");
              return Promise.reject(new Error("Sesión de seguridad expirada"));
            }
            // Si el token es válido pero falta cookie, permitir la petición
            // Puede ser un problema temporal de cookies del navegador
            console.warn("⚠️ Cookie tenant no encontrada pero token válido - permitiendo petición");
          } catch (error) {
            // Si no se puede decodificar el token, bloquear
            console.error("⚠️ Petición bloqueada: error al decodificar token");
            return Promise.reject(new Error("Sesión de seguridad expirada"));
          }
        } else {
          // Hay usuario pero no token ni cookie - bloquear
          console.error("⚠️ Petición bloqueada: cookie tenant no existe y no hay token");
          return Promise.reject(new Error("Sesión de seguridad expirada"));
        }
      }
    }
    
    return config;
  }, (error) => {
    return Promise.reject(error);
  });

  // FECHA HORA ACTUAL GLOBAL
  /* const getFechaHoraActualClient = async () => {
    return new Date().toLocaleDateString();
  };*/
  const [ubicaciones, arrayUbicaciones] = useState([]); //Define el estado ubicaciones con su función setUbicaciones. Inicialmente es un array vacío y contendrá las ubicaciones que se obtengan desde la API.
  const [formatoNumericoGlobal, setFormatoNumericoGlobal] = useState("es-AR"); // Locale numérico a nivel tenant. Default es-AR: NO depender del navegador (rompía en prod)
  const [formatoFechasGlobal, setFormatoFechasGlobal] = useState('DD/MM/YYYY'); // Formato de fechas configurado a nivel tenant (default: DD/MM/YYYY)

  // Función para obtener ubicaciones
  const getUbicacion = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getUbicacion");
      arrayUbicaciones(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear una nueva ubicación
  const postUbicacion = async (descripcionUbicacion, destinoTransferenciaInternaCaja = false) => {
    try {
      await axios.post(serverURL + "/adminAPI/postUbicacion", {
        descripcion: descripcionUbicacion,
        destinoTransferenciaInternaCaja: destinoTransferenciaInternaCaja,
      });
      invalidarCacheUbicaciones();
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar una ubicación
  const updateUbicacion = async (id, descripcion, destinoTransferenciaInternaCaja = false, geo = null, datosImpresion = undefined) => {
    try {
      const payload = { id, descripcion, destinoTransferenciaInternaCaja };
      // geo opcional: { geolocalizacion, latitud, longitud } — se manda desde el modal de edición.
      if (geo) {
        payload.geolocalizacion = geo.geolocalizacion;
        payload.latitud = geo.latitud;
        payload.longitud = geo.longitud;
      }
      // datosImpresion opcional: overrides de los parámetros globales afipsdk_* para
      // ticket y PDF mockup ({ razonSocial, domicilio, telefono, cuit, condicionIva }).
      // Un campo que no viene (undefined) NO se pisa en el backend; "" se normaliza a
      // NULL allá = vuelve a heredar el global.
      if (datosImpresion) {
        for (const campo of ["razonSocial", "domicilio", "telefono", "cuit", "condicionIva"]) {
          if (datosImpresion[campo] !== undefined) payload[campo] = datosImpresion[campo];
        }
      }
      await axios.put(serverURL + "/adminAPI/updateUbicacion", payload);
      invalidarCacheUbicaciones(); // el ticket/PDF leen los datos del emisor de una cache propia
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
      console.error("Error updating ubicacion:", error);
      throw error;
    }
  };

  // Función para eliminar una ubicación (soft delete)
  const deleteUbicacion = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteUbicacion", {
        id,
      });
      invalidarCacheUbicaciones();
      getUbicacion(); // Actualizar la lista de ubicaciones
    } catch (error) {
        console.error("Error deleting ubicacion:", error);
      throw error;
    }
  };

  // Buscar una dirección no guarda cambios: devuelve opciones para mover el marcador.
  const buscarDireccion = async (direccion) => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/buscarDireccion", {
        params: { q: direccion },
      });
      return response.data;
    } catch (error) {
      console.error("Error buscando dirección:", error);
      throw error;
    }
  };

  // ADMIN NEGOCIO ***********************************************************************

  const [negocios, arrayNegocios] = useState([]);

  // Función para obtener negocios
  const getNegocio = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getNegocio");
      arrayNegocios(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postNegocio = async (descripcionUbicacion) => {
    try {
      await axios.post(serverURL + "/adminAPI/postNegocio", {
        descripcion: descripcionUbicacion,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar un negocio
  const updateNegocio = async (id, descripcion) => {
    try {
      await axios.put(serverURL + "/adminAPI/updateNegocio", {
        id,
        descripcion,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error updating negocio:", error);
      throw error;
    }
  };

  // Función para eliminar un negocio (soft delete)
  const deleteNegocio = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteNegocio", {
        id,
      });
      getNegocio(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error deleting negocio:", error);
      throw error;
    }
  };

  // ADMIN TIPO ENTIDAD ***********************************************************************
  const [tipoEntidades, arrayTipoEntidad] = useState([]);

  // Función para obtener negocios
  const getTipoEntidad = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getTipoEntidad");
      arrayTipoEntidad(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching ubicaciones:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postTipoEntidad = async (descripcionTipoEntidad) => {
    try {
      await axios.post(serverURL + "/adminAPI/postTipoEntidad", {
        descripcion: descripcionTipoEntidad,
      });
      getTipoEntidad(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating ubicacion:", error);
    }
  };

  // Función para actualizar un tipo de entidad
  const updateTipoEntidad = async (id, descripcion) => {
    try {
      await axios.put(serverURL + "/adminAPI/updateTipoEntidad", {
        id,
        descripcion,
      });
      getTipoEntidad(); // Actualizar la lista de tipos de entidad
    } catch (error) {
      console.error("Error updating tipoEntidad:", error);
      throw error;
    }
  };

  // Función para eliminar un tipo de entidad (soft delete)
  const deleteTipoEntidad = async (id) => {
    try {
      await axios.post(serverURL + "/adminAPI/deleteTipoEntidad", {
        id,
      });
      getTipoEntidad(); // Actualizar la lista de tipos de entidad
    } catch (error) {
      console.error("Error deleting tipoEntidad:", error);
      throw error;
    }
  };

  // ADMIN CONDICION IVA ***********************************************************************
  const [condicionIva, arrayCondicionIva] = useState([]);

  // Función para obtener condicionIva
  const getCondicionIva = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getCondicionIva");
      arrayCondicionIva(response.data); //setea el array
      return response.data;
    } catch (error) {
      console.error("Error fetching condicionIva:", error);
    }
  };

  // Función para obtener condicionIva por entidad
  const getCondicionIvaByEntidad = async (idEntidad) => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getCondicionIvaByEntidad/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching condicionIva by entidad:", error);
      return null;
    }
  };

  const getEntidadFilterTipoEntidad = async (idTipoEntidad, page = 1, limit = 100, searchText = "", filtrosAtributos = {}) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
      });
      
      if (searchText && searchText.trim() !== "") {
        params.append("searchText", searchText.trim());
      }

      // Agregar filtros de atributos
      Object.entries(filtrosAtributos).forEach(([atributoNumero, valorId]) => {
        if (valorId) {
          params.append(`atributoEntidad${atributoNumero}`, valorId.toString());
        }
      });

      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadFilterTipoEntidad/${idTipoEntidad}?${params.toString()}`,
        { withCredentials: true }
      );
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching entidades por tipo:", error);
      throw error;
    }
  };

  // ADMIN ENTIDAD ***********************************************************************
  const [entidades, arrayEntidad] = useState([]);

  // Función para actualizar la columna 'eliminado' en los registros seleccionados
  const updateEliminarEntidad = async (selectionModel) => {
    try {
      await axios.put(serverURL + "/adminAPI/putEntidad", {
        ids: selectionModel,
      });
      getEntidad(); // Refrescar los datos después de la eliminación
    } catch (error) {
      console.error("Error al eliminar entidades:", error);
    }
  };

  const updateDevolverEntidad = async (selectionModel) => {
    try {
      await axios.put(serverURL + "/adminAPI/putEntidadDevolver", {
        ids: selectionModel,
      });
      getEntidad(); // Refrescar los datos después de la eliminación
    } catch (error) {
      console.error("Error al eliminar entidades:", error);
    }
  };

  const getEntidad = async (page = 1, limit = 100, searchText = "", filtrosAtributos = {}, idTipoEntidad = null) => {
    try {
      const params = {
        page: page.toString(),
        limit: limit.toString(),
      };
      if (searchText && searchText.trim() !== "") {
        params.searchText = searchText;
      }
      // Agregar filtro por tipo de entidad si se proporciona
      if (idTipoEntidad && idTipoEntidad !== "" && idTipoEntidad !== "null") {
        params.idTipoEntidad = idTipoEntidad.toString();
      }
      // Agregar filtros de atributos a los parámetros
      Object.entries(filtrosAtributos).forEach(([key, value]) => {
        if (value && value !== "null" && value !== "") {
          params[key] = value.toString();
        }
      });
      const response = await axios.get(serverURL + "/adminAPI/getEntidad", { params });
      // Si la respuesta tiene estructura de paginación, usar data, sino usar toda la respuesta
      if (response.data && response.data.data) {
        return response.data;
      }
      // Mantener compatibilidad con respuestas antiguas
      arrayEntidad(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
      throw error;
    }
  };

  const getEntidadByID = async (idEntidad) => {
    try {
      // console.log("idEntidad" + idEntidad);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByID/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const getEntidadByDNI = async (dniEntidad) => {
    try {
      // console.log("dniEntidad" + dniEntidad);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByDNI/${dniEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const [entidadesTipoEntidad, arrayEntidadesTipoEntidad] = useState([]);

  const getEntidadByTipoEntidad = async (idTipoEnt) => {
    try {
      // console.log("idTipoEntidad " + idTipoEnt);
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadByTipoEntidad/${idTipoEnt}`,
      );
      arrayEntidadesTipoEntidad(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching entidades:", error);
    }
  };

  const postEntidad = async (
    descripcionEntidad,
    apellidoEntidad,
    telefonoEntidad,
    emailEntidad,
    dniCuitCuilEntidad,
    direccionEntidad,
    localidadEntidad,
    provinciaEntidad,
    idTipoEntidadEntidad,
    idCondicionIvaEntidad,
    atributosForm = [],
  ) => {
    try {
         // Construir objeto de atributos dinámicos
         const atributosData = {};
         if (atributosForm && atributosForm.length > 0) {
           atributosForm.forEach((attr, index) => {
             atributosData[`entidadDatoAtributo${index + 1}`] = attr.valor || null;
           });
         }

      const response = await axios.post(serverURL + "/adminAPI/postEntidad", {
        descripcion: descripcionEntidad,
        apellido: apellidoEntidad,
        telefono: telefonoEntidad,
        email: emailEntidad,
        dniCuitCuil: dniCuitCuilEntidad,
        direccion: direccionEntidad,
        localidad: localidadEntidad,
        provincia: provinciaEntidad,
        idTipoEntidad: idTipoEntidadEntidad,
        idCondicionIva: idCondicionIvaEntidad,
        ...atributosData,
      });

      return response.data;
    } catch (error) {
      console.error("Error creating entidad:", error);
      
      // Capturar error 409 (Conflict) - DNI/CUIT/CUIL duplicado
      if (error.response && error.response.status === 409) {
        const errorMessage = error.response.data.message || "El DNI/CUIT/CUIL ingresado ya está registrado en el sistema.";
        throw new Error(errorMessage);
      }
      
      // Otros errores
      throw new Error(error.response?.data?.message || "Error al crear la entidad. Por favor, intente nuevamente.");
    }
  };

  // ADMIN UPDATE ENTIDAD ***********************************************************************

  const updateEntidad = async (
    idEntidad,
    descripcionEntidad,
    apellidoEntidad,
    telefonoEntidad,
    emailEntidad,
    dniCuitCuilEntidad,
    direccionEntidad,
    localidadEntidad,
    provinciaEntidad,
    idTipoEntidadEntidad,
    idCondicionIvaEntidad,
    atributosForm = [],
  ) => {
    // Validar que no se intente actualizar entidades genéricas
    if (idEntidad === 1 || idEntidad === 2) {
      const errorMessage = "No se puede actualizar entidades genéricas";
      throw new Error(errorMessage);
    }

    try {
      // Construir objeto de atributos dinámicos
      const atributosData = {};
      if (atributosForm && atributosForm.length > 0) {
        atributosForm.forEach((attr, index) => {
          atributosData[`entidadDatoAtributo${index + 1}`] = attr.valor || null;
        });
      }

      const response = await axios.put(serverURL + "/adminAPI/updateEntidad", {
        idEntidad,
        descripcion: descripcionEntidad,
        apellido: apellidoEntidad,
        telefono: telefonoEntidad,
        email: emailEntidad,
        dniCuitCuil: dniCuitCuilEntidad,
        direccion: direccionEntidad,
        localidad: localidadEntidad,
        provincia: provinciaEntidad,
        idTipoEntidad: idTipoEntidadEntidad,
        idCondicionIva: idCondicionIvaEntidad,
        ...atributosData,
      });

      getEntidad();
      return response.data;
    } catch (error) {
      console.error("Error actualizar entidad:", error);
      
      // Capturar error 400 - Entidades genéricas
      if (error.response && error.response.status === 400 && error.response.data?.message?.includes("entidades genéricas")) {
        const errorMessage = error.response.data.message || "No se puede actualizar entidades genéricas";
        throw new Error(errorMessage);
      }
      
      // Capturar error 409 (Conflict) - DNI/CUIT/CUIL duplicado
      if (error.response && error.response.status === 409) {
        const errorMessage = error.response.data.message || "El DNI/CUIT/CUIL ingresado ya pertenece a otra entidad en el sistema.";
        throw new Error(errorMessage);
      }
      
      // Otros errores
      throw new Error(error.response?.data?.message || "Error al actualizar la entidad. Por favor, intente nuevamente.");
    }
  };

  // Update only email for Entidad
  const updateEntidadEmail = async (idEntidad, email) => {
    try {
      if (!idEntidad) throw new Error("idEntidad requerido");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email || !emailRegex.test(email)) throw new Error("Email inválido");
      const response = await axios.put(
        `${serverURL}/adminAPI/updateEntidadEmail`,
        { idEntidad, email },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error actualizando email de entidad:",
        error?.response?.data || error.message,
      );
      throw error;
    }
  };

  const updateUsuario = async (
    idUsuario,
    user,
    nombreUsuario,
    apellidoUsuario,
    telefonoUsuario,
    emailUsuario,
    dniCuitCuilUsuario,
    direccionUsuario,
    localidadUsuario,
    provinciaUsuario,
    password,
    rol,
  ) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateUsuario", {
        idUsuario,
        usuario: user,
        nombre: nombreUsuario,
        apellido: apellidoUsuario,
        telefono: telefonoUsuario,
        email: emailUsuario,
        dniCuitCuil: dniCuitCuilUsuario,
        direccion: direccionUsuario,
        localidad: localidadUsuario,
        provincia: provinciaUsuario,
        password: password,
        rol: rol,
      });
      if (response.status >= 200 && response.status < 300) {
        getUsuario();
        // console.log("Entidad actualizada con éxito:", response.data);
        return { success: true, data: response.data }; // puedes retornar algo si lo necesitas
      }
    } catch (error) {
      console.error("Error actalizar entidad:", error);
    }
  };

  // ADMIN ENTIDAD TRES LETRAS***********************************************************************

  const [entidadesClientesTresLetras, arrayEntidadesClientesTresLetras] =
    useState([]);

  const getEntidadesClientesTresLetras = async (
    searchTextCliente,
    tipoEntidad,
    verEnCaja = false,
    verEnGasto = false,
  ) => {
    const search = String(searchTextCliente ?? "").trim();
    if (search.length < 3) {
      arrayEntidadesClientesTresLetras([]);
      return [];
    }

    try {
      const params = {
        search,
        tipoEntidad: tipoEntidad,
      };
      
      // Solo agregar verEnCaja si es true
      if (verEnCaja === true) {
        params.verEnCaja = 'true';
      }
      
      // Solo agregar verEnGasto si es true
      if (verEnGasto === true) {
        params.verEnGasto = 'true';
      }
      
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadClienteTresLetras`,
        { params }
      );
      arrayEntidadesClientesTresLetras(response.data);
      return response.data; //setea el array
    } catch (error) {
      if (error?.response?.status === 400) {
        arrayEntidadesClientesTresLetras([]);
        return [];
      }
      console.error("Error fetching entidades:", error);
      return [];
    }
  };

  // ADMIN USUARIO ***********************************************************************

  const [usuarios, arrayUsuario] = useState([]);

  const getUsuario = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getUsuario");
      arrayUsuario(response.data);
    } catch (error) {
      // console.error("Error fetching usuarios:", error);
    }
  };

  const deleteUsuarioSoft = async (idUsuario) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteUsuarioSoft", { idUsuario });
      await getUsuario();
      return response.data;
    } catch (error) {
      // console.error("Error eliminando usuario:", error);
      throw error;
    }
  };

  const postUsuario = async (
    usuario,
    nombre,
    apellido,
    telefono,
    email,
    direccion,
    localidad,
    provincia,
    password,
    rol,
    dniCuitCuil,
  ) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postUsuario", {
        usuario: usuario,
        nombre: nombre,
        apellido: apellido,
        telefono: telefono,
        email: email,
        direccion: direccion,
        localidad: localidad,
        provincia: provincia,
        password: password,
        rol: rol,
        dniCuitCuil: dniCuitCuil,
      });

      await getUsuario();

      return { success: true, data: response.data }; // puedes retornar algo si lo necesitas
    } catch (error) {
      console.error("Error creating usuario:", error);
    }
  };

  const getRolUsuario = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getRolUsuario");
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching roles de usuario:", error);
    }
  };

  const postRolUsuario = async (descripcion) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postRolUsuario", { descripcion });
      // Refrescar roles para que aparezca en Autocomplete inmediatamente
      await getRolUsuario();
      return response.data;
    } catch (error) {
      console.error("Error creando rol de usuario:", error);
      throw error;
    }
  };

  const updateRolUsuario = async (id, descripcion) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateRolUsuario", { id, descripcion });
      // Refrescar roles para reflejar cambios
      await getRolUsuario();
      return response.data;
    } catch (error) {
      console.error("Error actualizando rol de usuario:", error);
      throw error;
    }
  };

  const getUsuariosByRol = async (idRol) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getUsuariosByRol/${idRol}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo usuarios por rol:", error);
      throw error;
    }
  };

  const deleteRolYUsuarios = async (idRol) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteRolYUsuarios", { idRol });
      // refrescar roles tras eliminar
      await getRolUsuario();
      return response.data;
    } catch (error) {
      console.error("Error eliminando rol y usuarios:", error);
      throw error;
    }
  };

  // ====================================================================================================
  // SESIONES - Funciones para gestión de sesiones activas
  // ====================================================================================================

  /**
   * Obtener usuarios en línea con sus sesiones activas
   * @param {Object} options - Opciones de filtrado
   * @param {boolean} options.incluirInactivos - Incluir usuarios inactivos (default: false)
   * @param {number} options.limiteActividad - Minutos de inactividad para considerar activo (default: 30)
   * @returns {Promise<Object>} Objeto con usuarios, totalUsuarios, totalSesiones, ultimaActualizacion
   */
  const getUsuariosEnLinea = async (options = {}) => {
    try {
      const { incluirInactivos = false, limiteActividad = 30 } = options;
      const params = new URLSearchParams({
        incluirInactivos: incluirInactivos.toString(),
        limiteActividad: limiteActividad.toString()
      });
      
      const response = await axios.get(
        `${serverURL}/adminAPI/getUsuariosEnLinea?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo usuarios en línea:", error);
      throw error;
    }
  };

  /**
   * Obtener sesiones de un usuario específico
   * @param {number} idUsuario - ID del usuario
   * @param {boolean} activas - Solo sesiones activas (default: true)
   * @returns {Promise<Object>} Objeto con sesiones, total, activas
   */
  const getSesionesUsuario = async (idUsuario, activas = true) => {
    try {
      const params = new URLSearchParams({
        activas: activas.toString()
      });
      
      const response = await axios.get(
        `${serverURL}/adminAPI/getSesionesUsuario/${idUsuario}?${params.toString()}`
      );
      return response.data;
    } catch (error) {
      console.error("Error obteniendo sesiones del usuario:", error);
      throw error;
    }
  };

  /**
   * Cerrar una sesión específica
   * @param {number} idSesion - ID de la sesión a cerrar
   * @param {string} razon - Razón del cierre (default: "Cierre manual por administrador")
   * @returns {Promise<Object>} Objeto con success y message
   */
  const cerrarSesion = async (idSesion, razon = "Cierre manual por administrador") => {
    try {
      const response = await axios.post(
        `${serverURL}/adminAPI/cerrarSesion/${idSesion}`,
        { razon }
      );
      return response.data;
    } catch (error) {
      console.error("Error cerrando sesión:", error);
      throw error;
    }
  };

  /**
   * Cerrar todas las sesiones de un usuario
   * @param {number} idUsuario - ID del usuario
   * @param {string} razon - Razón del cierre (default: "Cierre manual por administrador")
   * @returns {Promise<Object>} Objeto con success, sesionesCerradas y message
   */
  const cerrarTodasSesionesUsuario = async (idUsuario, razon = "Cierre manual por administrador") => {
    try {
      const response = await axios.post(
        `${serverURL}/adminAPI/cerrarTodasSesionesUsuario/${idUsuario}`,
        { razon }
      );
      return response.data;
    } catch (error) {
      console.error("Error cerrando todas las sesiones:", error);
      throw error;
    }
  };

  const getMenuAcceso = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getMenuAcceso");
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching menu de acceso:", error);
    }
  };

  const getRolAccesoByIdRol = async (idRol) => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/rolAcceso/${idRol}`,
      );
      return response.data; //setea el array
    } catch (error) {
      console.error("Error fetching menu de acceso:", error);
    }
  };

  const actualizarRolAccesos = async (idRol, accesos) => {
    try {
      await axios.post(`${serverURL}/adminAPI/actualizarRolAccesos`, {
        idRolUsuario: idRol,
        accesos: accesos, // [{ id, label, activo }]
      });
      return { success: true };
    } catch (error) {
      // console.error("Error al actualizar accesos:", error);
      throw error;
    }
  };

   // MenuFuncionalidadAcceso methods (anteriormente ComponenteSector)
   const getComponenteSector = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getComponenteSector");
      return response.data;
    } catch (error) {
      console.error("Error fetching componentes sector:", error);
      throw error;
    }
  };

  const getComponenteSectorByMenuAcceso = async (idMenuAcceso) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getComponenteSectorByMenuAcceso/${idMenuAcceso}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching componentes sector por menú:", error);
      throw error;
    }
  };

  const postComponenteSector = async (id, idMenuAcceso, descripcion, tipo, meta) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postComponenteSector", {
        id,
        idMenuAcceso,
        descripcion,
        tipo,
        meta,
      });
      return response.data;
    } catch (error) {
      console.error("Error creando componente sector:", error);
      throw error;
    }
  };

  const updateComponenteSector = async (id, descripcion, tipo, meta) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateComponenteSector", {
        id,
        descripcion,
        tipo,
        meta,
      });
      return response.data;
    } catch (error) {
      console.error("Error actualizando componente sector:", error);
      throw error;
    }
  };

  const deleteComponenteSector = async (id) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteComponenteSector", { id });
      return response.data;
    } catch (error) {
      console.error("Error eliminando componente sector:", error);
      throw error;
    }
  };

  // RolFuncionalidadAcceso methods (anteriormente RolSectorAcceso)
  const getRolSectorAccesoByIdRol = async (idRol) => {
    try {
      const response = await axios.get(serverURL + `/adminAPI/getRolSectorAccesoByIdRol/${idRol}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching accesos de sector del rol:", error);
      throw error;
    }
  };

  const actualizarRolSectorAccesos = async (idRol, accesos) => {
    try {
      await axios.post(`${serverURL}/adminAPI/actualizarRolSectorAccesos`, {
        idRolUsuario: idRol,
        accesos: accesos, // [{ idSector, idMenuAcceso, activo }]
      });
      return { success: true };
    } catch (error) {
      console.error("Error al actualizar accesos de sector:", error);
      throw error;
    }
  };

  // RRHH CONTEXT ***********************************************************************
  // RRHH CONTEXT ***********************************************************************
  // RRHH CONTEXT ***********************************************************************

  const getRrhhEmpleados = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empleados RRHH:", error);
      throw error;
    }
  };

  const getRrhhEmpleadoById = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/${idEntidad}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empleado RRHH:", error);
      throw error;
    }
  };

  const buscarEmpleadoPorDocumento = async (valor) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/buscar-documento`, { params: { valor } });
      return response.data;
    } catch (error) {
      console.error("Error buscando empleado por documento:", error);
      throw error;
    }
  };

  const postRrhhEmpleado = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/empleados`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando empleado RRHH:", error);
      throw error;
    }
  };

  const updateRrhhEmpleado = async (idEntidad, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/empleados/${idEntidad}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando empleado RRHH:", error);
      throw error;
    }
  };

  const getRrhhContratosEmpleado = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/${idEntidad}/contratos`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo contratos RRHH:", error);
      throw error;
    }
  };

  const postRrhhContratoEmpleado = async (idEntidad, payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/empleados/${idEntidad}/contratos`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando contrato RRHH:", error);
      throw error;
    }
  };

  const updateRrhhContratoEmpleado = async (idEntidad, idContrato, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/empleados/${idEntidad}/contratos/${idContrato}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando contrato RRHH:", error);
      throw error;
    }
  };

  const getRrhhTurnos = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/turnos`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo turnos RRHH:", error);
      throw error;
    }
  };

  const getRrhhTurnoById = async (idTurno) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/turnos/${idTurno}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo turno RRHH:", error);
      throw error;
    }
  };

  const postRrhhTurno = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/turnos`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando turno RRHH:", error);
      throw error;
    }
  };

  const updateRrhhTurno = async (idTurno, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/turnos/${idTurno}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando turno RRHH:", error);
      throw error;
    }
  };

  const getRrhhAsignacionesTurnoByEmpleado = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/turnos/empleados/${idEntidad}/asignaciones`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo asignaciones RRHH:", error);
      throw error;
    }
  };

  const postRrhhAsignacionTurno = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/turnos/asignaciones`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando asignación de turno RRHH:", error);
      throw error;
    }
  };

  const getRrhhFichajes = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/fichajes`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo fichajes RRHH:", error);
      throw error;
    }
  };

  const postRrhhFichaje = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/fichajes`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando fichaje RRHH:", error);
      throw error;
    }
  };

  const updateRrhhFichaje = async (id, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/fichajes/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando fichaje RRHH:", error);
      throw error;
    }
  };

  const deleteRrhhFichaje = async (id) => {
    try {
      const response = await axios.delete(`${serverURL}/rrhhDomain/fichajes/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error eliminando fichaje RRHH:", error);
      throw error;
    }
  };

  const getRrhhAsistencias = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/asistencia`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo asistencias RRHH:", error);
      throw error;
    }
  };

  const updateRrhhAsistencia = async (idAsistencia, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/asistencia/${idAsistencia}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando asistencia RRHH:", error);
      throw error;
    }
  };

  const postRrhhRecalcularAsistencia = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/asistencia/recalcular`, payload);
      return response.data;
    } catch (error) {
      console.error("Error recalculando asistencia RRHH:", error);
      throw error;
    }
  };

  const getRrhhLiquidaciones = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/liquidaciones`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo liquidaciones RRHH:", error);
      throw error;
    }
  };

  const getRrhhLiquidacionById = async (idLiquidacion) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/liquidaciones/${idLiquidacion}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo liquidación RRHH:", error);
      throw error;
    }
  };

  const postRrhhLiquidacion = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/liquidaciones`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando liquidación RRHH:", error);
      throw error;
    }
  };

  const updateRrhhLiquidacion = async (idLiquidacion, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/liquidaciones/${idLiquidacion}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando liquidación RRHH:", error);
      throw error;
    }
  };

  const postRrhhRecalcularLiquidacion = async (idLiquidacion) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/liquidaciones/${idLiquidacion}/recalcular`);
      return response.data;
    } catch (error) {
      console.error("Error recalculando liquidación RRHH:", error);
      throw error;
    }
  };

  const getRrhhNovedadesLiquidacion = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/liquidaciones/novedades`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo novedades RRHH:", error);
      throw error;
    }
  };

  const postRrhhNovedadLiquidacion = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/liquidaciones/novedades`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando novedad RRHH:", error);
      throw error;
    }
  };

  const updateRrhhNovedadLiquidacion = async (idNovedad, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/liquidaciones/novedades/${idNovedad}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando novedad RRHH:", error);
      throw error;
    }
  };

  const getRrhhReporteResumen = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/reportes/resumen`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo reporte resumen RRHH:", error);
      throw error;
    }
  };

  // RRHH - PLANTILLAS DE HORARIO + HORARIO ESPECIFICO ***********************************
  const getRrhhPlantillas = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/plantillas-horario`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo plantillas de horario:", error);
      throw error;
    }
  };

  const getRrhhPlantillaById = async (id) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/plantillas-horario/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo plantilla de horario:", error);
      throw error;
    }
  };

  const postRrhhPlantilla = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/plantillas-horario`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando plantilla de horario:", error);
      throw error;
    }
  };

  const updateRrhhPlantilla = async (id, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/plantillas-horario/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando plantilla de horario:", error);
      throw error;
    }
  };

  const duplicateRrhhPlantilla = async (id, nombre) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/plantillas-horario/${id}/duplicar`, { nombre });
      return response.data;
    } catch (error) {
      console.error("Error duplicando plantilla de horario:", error);
      throw error;
    }
  };

  const inactivateRrhhPlantilla = async (id) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/plantillas-horario/${id}/inactivar`);
      return response.data;
    } catch (error) {
      console.error("Error inactivando plantilla de horario:", error);
      throw error;
    }
  };

  const activateRrhhPlantilla = async (id) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/plantillas-horario/${id}/activar`);
      return response.data;
    } catch (error) {
      console.error("Error activando plantilla de horario:", error);
      throw error;
    }
  };

  const deleteRrhhPlantilla = async (id) => {
    try {
      const response = await axios.delete(`${serverURL}/rrhhDomain/plantillas-horario/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error eliminando plantilla de horario:", error);
      throw error;
    }
  };

  const getRrhhPlantillaEmpleados = async (id) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/plantillas-horario/${id}/empleados`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo empleados de plantilla:", error);
      throw error;
    }
  };

  const postRrhhPlantillaAsignarEmpleados = async (id, body) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/plantillas-horario/${id}/asignar-empleados`, body);
      return response.data;
    } catch (error) {
      console.error("Error asignando empleados a plantilla:", error);
      throw error;
    }
  };

  const getRrhhEmpleadoHorario = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/${idEntidad}/horario`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo horario del empleado:", error);
      throw error;
    }
  };

  const updateRrhhEmpleadoHorarioEspecifico = async (idEntidad, dias) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/empleados/${idEntidad}/horario-especifico`, { dias });
      return response.data;
    } catch (error) {
      console.error("Error guardando horario específico:", error);
      throw error;
    }
  };

  const activarRrhhHorarioEspecifico = async (idEntidad) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/empleados/${idEntidad}/activar-horario-especifico`);
      return response.data;
    } catch (error) {
      console.error("Error activando horario específico:", error);
      throw error;
    }
  };

  const desactivarRrhhHorarioEspecifico = async (idEntidad) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/empleados/${idEntidad}/desactivar-horario-especifico`);
      return response.data;
    } catch (error) {
      console.error("Error desactivando horario específico:", error);
      throw error;
    }
  };

  // ─── Adjuntos (Documentación) del empleado ───────────────────────────────
  // Estrategia BYTEA en Postgres. Ver
  // documentacion/tecnico/file-storage/file-storage.md.

  const getRrhhEmpleadoAdjuntos = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/${idEntidad}/adjuntos`);
      return response.data; // { data: [...] }
    } catch (error) {
      console.error("Error listando adjuntos del empleado:", error);
      throw error;
    }
  };

  const uploadRrhhEmpleadoAdjunto = async (idEntidad, file, { tipoDocumento = null } = {}) => {
    try {
      const formData = new FormData();
      // El campo se llama "archivo" — debe coincidir con multer.single('archivo')
      // en routesEmpleados.js.
      formData.append("archivo", file, file.name);
      if (tipoDocumento) formData.append("tipoDocumento", tipoDocumento);
      const response = await axios.post(
        `${serverURL}/rrhhDomain/empleados/${idEntidad}/adjuntos`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );
      return response.data;
    } catch (error) {
      console.error("Error subiendo adjunto del empleado:", error);
      throw error;
    }
  };

  // Devuelve la URL absoluta del endpoint. Se usa para abrir en pestaña nueva
  // (inline) o para forzar descarga via <a download>. Ambos endpoints corren
  // con las mismas cookies, así que no hace falta fetch + blob para casos
  // simples.
  const getRrhhEmpleadoAdjuntoUrl = (idEntidad, idAdjunto, modo = "download") => {
    const sufijo = modo === "inline" ? "inline" : "download";
    return `${serverURL}/rrhhDomain/empleados/${idEntidad}/adjuntos/${idAdjunto}/${sufijo}`;
  };

  const deleteRrhhEmpleadoAdjunto = async (idEntidad, idAdjunto) => {
    try {
      const response = await axios.delete(`${serverURL}/rrhhDomain/empleados/${idEntidad}/adjuntos/${idAdjunto}`);
      return response.data;
    } catch (error) {
      console.error("Error eliminando adjunto del empleado:", error);
      throw error;
    }
  };

  // ─── Acceso de fichaje (PWA + passkey) ───────────────────────────────────
  // Ver documentacion/tecnico/fichaje-pwa/fichaje-pwa-passkey.md.

  const getRrhhAccesoFichaje = async (idEntidad) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/${idEntidad}/acceso-fichaje`);
      return response.data; // { estado, invitacionVenceEn?, vinculadoEn?, ultimoUsoEn?, revocadoEn?, motivoRevocacion? }
    } catch (error) {
      console.error("Error obteniendo acceso de fichaje del empleado:", error);
      throw error;
    }
  };

  const postRrhhAccesoFichaje = async (idEntidad, telefono) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/empleados/${idEntidad}/acceso-fichaje`, { telefono });
      return response.data; // { idAcceso, link, linkWhatsapp, invitacionVenceEn }
    } catch (error) {
      console.error("Error generando acceso de fichaje del empleado:", error);
      throw error;
    }
  };

  const deleteRrhhAccesoFichaje = async (idEntidad) => {
    try {
      const response = await axios.delete(`${serverURL}/rrhhDomain/empleados/${idEntidad}/acceso-fichaje`);
      return response.data;
    } catch (error) {
      console.error("Error revocando acceso de fichaje del empleado:", error);
      throw error;
    }
  };

  const getRrhhAreasSugeridas = async (search) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/areas-sugeridas`, {
        params: search ? { search } : undefined,
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo áreas sugeridas:", error);
      throw error;
    }
  };

  const getRrhhPuestosSugeridos = async (search) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/empleados/puestos-sugeridos`, {
        params: search ? { search } : undefined,
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo puestos sugeridos:", error);
      throw error;
    }
  };

  // RRHH - EXCEPCIONES DE PLANIFICACIÓN ***************************************************
  const getRrhhExcepciones = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/excepciones`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo excepciones:", error);
      throw error;
    }
  };

  const getRrhhExcepcionById = async (id) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/excepciones/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo excepción:", error);
      throw error;
    }
  };

  const postRrhhExcepcion = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/excepciones`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando excepción:", error);
      throw error;
    }
  };

  const updateRrhhExcepcion = async (id, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/excepciones/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando excepción:", error);
      throw error;
    }
  };

  const cancelRrhhExcepcion = async (id) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/excepciones/${id}/cancelar`);
      return response.data;
    } catch (error) {
      console.error("Error cancelando excepción:", error);
      throw error;
    }
  };

  const aplicarRrhhExcepciones = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/excepciones/aplicar`, payload);
      return response.data;
    } catch (error) {
      console.error("Error aplicando excepciones masivas:", error);
      throw error;
    }
  };

  // Programa → envío por mail del PDF (completo o individual) a los empleados tildados.
  const enviarRrhhProgramaMail = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/programa/enviar-mail`, payload);
      return response.data;
    } catch (error) {
      console.error("Error enviando el programa por mail:", error);
      throw error;
    }
  };

  const volverRrhhExcepcionesABase = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/excepciones/volver-a-base`, payload);
      return response.data;
    } catch (error) {
      console.error("Error volviendo a horario base:", error);
      throw error;
    }
  };

  const getRrhhPlanificacionEfectiva = async (idEntidad, fecha) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/excepciones/planificacion-efectiva`, {
        params: { idEntidad, fecha },
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo planificación efectiva:", error);
      throw error;
    }
  };

  const getRrhhPlanificacionEfectivaBatch = async (idsEntidad, fecha) => {
    try {
      const ids = Array.isArray(idsEntidad) ? idsEntidad.join(",") : idsEntidad;
      const response = await axios.get(`${serverURL}/rrhhDomain/excepciones/planificacion-efectiva/batch`, {
        params: { idsEntidad: ids, fecha },
      });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo planificación efectiva batch:", error);
      throw error;
    }
  };

  const getRrhhConfiguracion = async () => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/configuracion`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo configuración RRHH:", error);
      throw error;
    }
  };

  const updateRrhhConfiguracion = async (payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/configuracion`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando configuración RRHH:", error);
      throw error;
    }
  };

  const getRrhhTiposEventualidad = async (params = {}) => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/configuracion/tipos-eventualidad`, { params });
      return response.data;
    } catch (error) {
      console.error("Error obteniendo tipos de eventualidad:", error);
      throw error;
    }
  };

  const postRrhhTipoEventualidad = async (payload) => {
    try {
      const response = await axios.post(`${serverURL}/rrhhDomain/configuracion/tipos-eventualidad`, payload);
      return response.data;
    } catch (error) {
      console.error("Error creando tipo de eventualidad:", error);
      throw error;
    }
  };

  const updateRrhhTipoEventualidad = async (id, payload) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/configuracion/tipos-eventualidad/${id}`, payload);
      return response.data;
    } catch (error) {
      console.error("Error actualizando tipo de eventualidad:", error);
      throw error;
    }
  };

  const deleteRrhhTipoEventualidad = async (id) => {
    try {
      const response = await axios.delete(`${serverURL}/rrhhDomain/configuracion/tipos-eventualidad/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error eliminando tipo de eventualidad:", error);
      throw error;
    }
  };

  const getUbicacionesCheckin = async () => {
    try {
      const response = await axios.get(`${serverURL}/rrhhDomain/configuracion/ubicaciones-checkin`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo ubicaciones de check-in:", error);
      throw error;
    }
  };

  const updateToleranciaUbicacion = async (id, radioToleranciaMetros) => {
    try {
      const response = await axios.put(`${serverURL}/rrhhDomain/configuracion/ubicaciones-checkin/${id}/tolerancia`, { radioToleranciaMetros });
      return response.data;
    } catch (error) {
      console.error("Error actualizando tolerancia de ubicación:", error);
      throw error;
    }
  };

  // TRANSACCION CONTEXT ***********************************************************************
  // TRANSACCION CONTEXT ***********************************************************************
  // TRANSACCION CONTEXT ***********************************************************************

  // TRANSACCION MONEDA ***********************************************************************
  const [monedas, arrayMonedas] = useState([]);

  // Función para obtener negocios
  const getMoneda = async () => {
    try {
      const response = await axios.get(serverURL + "/transaccionAPI/getMoneda");
      arrayMonedas(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching moneda:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postMoneda = async (descripcionMoneda) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postMoneda", {
        descripcion: descripcionMoneda,
      });
      getMoneda(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating moneda:", error);
    }
  };

  // Función para actualizar una moneda
  const updateMoneda = async (id, descripcionMoneda) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateMoneda/" + id, {
        descripcion: descripcionMoneda,
      });
      getMoneda(); // Actualizar la lista de monedas
    } catch (error) {
      console.error("Error updating moneda:", error);
      throw error;
    }
  };

  // Función para eliminar (soft delete) una moneda
  const deleteMoneda = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteMoneda/" + id);
      getMoneda(); // Actualizar la lista de monedas
    } catch (error) {
      console.error("Error deleting moneda:", error);
      throw error;
    }
  };

  // TRANSACCION TIPO MEDIO DE PAGO ***********************************************************************
  const [tipoMedioDePago, arrayTipoMedioDePago] = useState([]);

  // Función para obtener negocios
  const getTipoMedioDePago = async (condicionExtra) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTipoMedioDePago",
        {
          params: {
            condicionExtra,
          },
        },
      );
      arrayTipoMedioDePago(response.data); //setea el array
      return response.data || [];
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
      return [];
    }
  };

  // Función para crear un nuevo negocio
  const postTipoMedioDePago = async (
    descripcionMedioPago,
    verEnCajaMedioPago,
    verEnTransaccionMedioPago,
    esMultiMonedaMedioPago,
    esPagoDiferidoMedioPago,
    userSelect,
  ) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postTipoMedioDePago", {
        descripcion: descripcionMedioPago,
        verEnCaja: verEnCajaMedioPago,
        verEnTransaccion: verEnTransaccionMedioPago,
        esMultiMoneda: esMultiMonedaMedioPago,
        esPagoDiferido: esPagoDiferidoMedioPago,
        userSelect: userSelect,
      });
      getTipoMedioDePago(); // Actualizar la lista de negocios
    } catch (error) {
      console.error("Error creating medio de pago:", error);
    }
  };

  // Función para actualizar tipo medio de pago
  const updateTipoMedioDePago = async (id, datos) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateTipoMedioDePago/" + id, datos);
      getTipoMedioDePago();
    } catch (error) {
      console.error("Error updating tipo medio de pago:", error);
      throw error;
    }
  };

  // Función para eliminar tipo medio de pago
  const deleteTipoMedioDePago = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteTipoMedioDePago/" + id);
      getTipoMedioDePago();
    } catch (error) {
      console.error("Error deleting tipo medio de pago:", error);
      throw error;
    }
  };

  // TRANSACCION MEDIO DE PAGO ***********************************************************************
  const [medioDePago, arrayMedioDePago] = useState([]);

  // Función para obtener negocios
  const getMedioDePago = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getMedioDePago",
      );
      arrayMedioDePago(response.data); //setea el array
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
    }
  };

  // Función para crear un nuevo negocio
  const postMedioDePago = async (idTipoMedioDePago, descripcionMedioDePago) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postMedioDePago", {
        idTipoMedioDePago: idTipoMedioDePago,
        descripcion: descripcionMedioDePago,
      });

      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error creating medio de pago:", error);
    }
  };

  // Función para actualizar medio de pago
  const updateMedioDePago = async (id, datos) => {
    try {
      await axios.put(serverURL + "/transaccionAPI/updateMedioDePago/" + id, datos);
      await getMedioDePago();
      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error updating medio de pago:", error);
      throw error;
    }
  };

  // Función para eliminar medio de pago
  const deleteMedioDePago = async (id) => {
    try {
      await axios.delete(serverURL + "/transaccionAPI/deleteMedioDePago/" + id);
      await getMedioDePago();
      await getMedioDePagoConDescripcion();
    } catch (error) {
      console.error("Error deleting medio de pago:", error);
      throw error;
    }
  };

  const [medioDePagoConDescripcion, arrayMedioDePagoConDescripcion] = useState(
    [],
  );

  // Cache en memoria: idTipoMedioDePago → medios[]. Evita GET al elegir tipo en POS.
  const mediosDePagoCacheByTipoRef = useRef({});
  const mediosDePagoCacheLoadedRef = useRef(false);
  const [mediosDePagoCacheByTipo, setMediosDePagoCacheByTipo] = useState({});

  const rebuildMediosDePagoCache = (list) => {
    const byTipo = {};
    for (const m of list || []) {
      const tid = m?.idTipoMedioDePago;
      if (tid == null) continue;
      if (!byTipo[tid]) byTipo[tid] = [];
      byTipo[tid].push(m);
    }
    mediosDePagoCacheByTipoRef.current = byTipo;
    mediosDePagoCacheLoadedRef.current = true;
    setMediosDePagoCacheByTipo(byTipo);
    return byTipo;
  };

  // Función para obtener negocios
  const getMedioDePagoConDescripcion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getMedioDePagoConDescripcion",
      );
      const list = response.data || [];
      arrayMedioDePagoConDescripcion(list);
      rebuildMediosDePagoCache(list);
      return list;
    } catch (error) {
      console.error("Error fetching medio de pago:", error);
      return [];
    }
  };

  // Eager prefetch: un GET de todos los medios activos, agrupados por tipo.
  // No bloquea el resto del load del form si se dispara en background.
  const prefetchMediosDePagoCache = async () => {
    try {
      if (mediosDePagoCacheLoadedRef.current) {
        return mediosDePagoCacheByTipoRef.current;
      }
      await getMedioDePagoConDescripcion();
      return mediosDePagoCacheByTipoRef.current;
    } catch (error) {
      console.error("Error prefetch medios de pago:", error);
      return {};
    }
  };

  const [medioDePagoIdTipoEspecifico, arrayMedioDePagoIdTipoEspecifico] =
    useState([]);

  const getMedioDePagoIdTipoEspecifico = async (selectedTipoMedioDePago) => {
    try {
      // Soportar tanto objeto con .id como ID directo (número)
      const id = typeof selectedTipoMedioDePago === 'object'
        ? selectedTipoMedioDePago?.id
        : selectedTipoMedioDePago;

      if (!id) {
        console.warn("getMedioDePagoIdTipoEspecifico: ID inválido", selectedTipoMedioDePago);
        return [];
      }

      const cached = mediosDePagoCacheByTipoRef.current[id];
      if (cached) {
        arrayMedioDePagoIdTipoEspecifico(cached);
        return cached;
      }

      const response = await axios.get(
        serverURL + `/transaccionAPI/getMedioDePagoConDescripcion/${id}`,
      );
      const data = response.data || [];
      arrayMedioDePagoIdTipoEspecifico(data);

      const next = { ...mediosDePagoCacheByTipoRef.current, [id]: data };
      mediosDePagoCacheByTipoRef.current = next;
      setMediosDePagoCacheByTipo(next);

      return data;
    } catch (error) {
      // 404 (tipo sin medios) u otros errores → lista vacía, cachear para no reintentar
      console.error("Error fetching medio de pago:", error);
      const id = typeof selectedTipoMedioDePago === 'object'
        ? selectedTipoMedioDePago?.id
        : selectedTipoMedioDePago;
      if (id) {
        const next = { ...mediosDePagoCacheByTipoRef.current, [id]: [] };
        mediosDePagoCacheByTipoRef.current = next;
        setMediosDePagoCacheByTipo(next);
      }
      arrayMedioDePagoIdTipoEspecifico([]);
      return [];
    }
  };

  // 🆕 Carga los medios de pago para una lista de tipos (multi-select).
  // Fetches en paralelo, mergea por id (dedupe), y setea el array una sola vez
  // para evitar race conditions con múltiples setState.
  const getMediosDePagoPorTipos = async (tipos) => {
    try {
      if (!Array.isArray(tipos) || tipos.length === 0) {
        arrayMedioDePagoIdTipoEspecifico([]);
        return [];
      }

      const responses = await Promise.all(
        tipos.map((t) =>
          axios
            .get(serverURL + `/transaccionAPI/getMedioDePagoConDescripcion/${t.id}`)
            .then((r) => r.data || [])
            .catch((err) => {
              console.error(`Error fetching medios del tipo ${t.id}:`, err);
              return [];
            }),
        ),
      );

      const byId = new Map();
      for (const list of responses) {
        for (const m of list) {
          if (m && m.id != null && !byId.has(m.id)) byId.set(m.id, m);
        }
      }
      const merged = Array.from(byId.values());

      arrayMedioDePagoIdTipoEspecifico(merged);
      return merged;
    } catch (error) {
      console.error("Error fetching medios de pago por tipos:", error);
      return [];
    }
  };

  // TRANSACCION CUENTA CORRIENTE ***********************************************************************

  const [cuentasCorrientes, setCuentasCorrientes] = useState([]);

  const getCuentaCorriente = async () => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/cuentaCorriente`,
      );
      setCuentasCorrientes(response.data); // Esto actualiza el estado para futuras referencias
      return response.data; // Devolver la lista de cuentas corrientes directamente
    } catch (error) {
      console.error("Error al obtener cuentas corrientes:", error);
      return []; // Devuelve un arreglo vacío en caso de error
    }
  };

  const getCuentaCorrienteByIdEntidad = async (idEntidad) => {
    try {
// Validar entrada
if (!idEntidad || isNaN(Number(idEntidad))) {
  console.error("getCuentaCorrienteByIdEntidad: idEntidad inválido", idEntidad);
  return [];
}

const response = await axios.get(
  serverURL +
    `/transaccionAPI/getCuentaCorrienteByIdEntidad/${idEntidad}`,
);

// Validar respuesta
if (response.data && Array.isArray(response.data)) {
  return response.data;
}

return [];
} catch (error) {
console.error("Error al obtener cuentas corrientes:", error);

// Retornar array vacío solo si es 404 (no encontrado)
// Para otros errores, también retornar array vacío (comportamiento actual)
if (error.response?.status === 404) {
  return [];
}

// Para otros errores, retornar array vacío (comportamiento actual)
return [];
    }
  };

  const postCuentaCorriente = async (idEntidad, monto, idTipoTransaccion) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/cuentaCorriente",
        { idEntidad, monto, idTipoTransaccion },
      );
      return response.data;
    } catch (error) {
      console.error("Error al crear la cuenta corriente:", error);
    }
  };

  const updateCuentaCorriente = async (idEntidad, monto, idTipoTransaccion, usarOperacionCaja = false) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/cuentaCorriente/${idEntidad}`,
        { monto, idTipoTransaccion, usarOperacionCaja },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar la cuenta corriente:", error);
    }
  };

  // TRANSACCION CATEGORIA ***********************************************************************
  const [categoriaTransaccion, arrayCategoriaTransaccion] = useState([]);

  const getCategoriaTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getCategoriaTransaccion",
      );
      arrayCategoriaTransaccion(response.data);
    } catch (error) {
      console.error("Error fetching Categoria:", error);
    }
  };

  const postCategoriaTransaccion = async (descripcionCategoriaTransaccion) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postCategoriaTransaccion", {
        descripcion: descripcionCategoriaTransaccion,
      });
      getCategoriaTransaccion();
    } catch (error) {
      console.error("Error creating Categoria:", error);
      throw error;
    }
  };

  const updateCategoriaTransaccion = async (idCategoria, descripcionCategoriaTransaccion) => {
    try {
      await axios.put(
        `${serverURL}/transaccionAPI/updateCategoriaTransaccion/${idCategoria}`,
        {
          descripcion: descripcionCategoriaTransaccion,
        },
      );
      await getCategoriaTransaccion();
    } catch (error) {
      console.error("Error updating Categoria:", error);
      throw error;
    }
  };

  const deleteCategoriaTransaccion = async (idCategoria) => {
    try {
      await axios.delete(
        `${serverURL}/transaccionAPI/deleteCategoriaTransaccion/${idCategoria}`,
      );
      await Promise.all([getCategoriaTransaccion(), getSubCategoriaTransaccion()]);
    } catch (error) {
      console.error("Error deleting Categoria:", error);
      throw error;
    }
  };

  // TRANSACCION SUB CATEGORIA ***********************************************************************
  const [subCategoriaTransaccion, arraySubCategoriaTransaccion] = useState([]);

  const getSubCategoriaTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getSubCategoriaTransaccion",
      );
      arraySubCategoriaTransaccion(response.data);
    } catch (error) {
      console.error("Error fetching SubCat:", error);
    }
  };

  const getGastosTransacciones = async ({
    page = 1,
    limit = 100,
    categoria = null,
    idSubCategoria = null,
    idsSubCategoria = null,
    idEntidad = null,
    idTipoEntidad = null,
    ubicacionId = null,
    idTipoTransaccion = null,
    idUsuario = null,
    startDate = null,
    endDate = null,
    agrupar = null,
  } = {}) => {
    // Construyo params exactamente con las claves que envía el front
    const params = { page, limit };
    // agrupar = "empleado": una fila por entidad (RRHH > Historial de pagos)
    if (agrupar) params.agrupar = agrupar;

    if (categoria !== null) params.categoria = categoria;
    if (idSubCategoria !== null) params.idSubCategoria = idSubCategoria;
    // Lista de subcategorías (RRHH > Historial de pagos). Vacía = no trae nada.
    if (Array.isArray(idsSubCategoria)) params.idsSubCategoria = idsSubCategoria.join(",");
    if (idEntidad !== null) params.idEntidad = idEntidad;
    if (idTipoEntidad !== null) params.idTipoEntidad = idTipoEntidad;
    if (ubicacionId !== null) params.ubicacionId = ubicacionId;
    if (idTipoTransaccion !== null) params.idTipoTransaccion = idTipoTransaccion;
    if (idUsuario !== null) params.idUsuario = idUsuario;
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;

    const { data } = await axios.get(
      `${serverURL}/transaccionAPI/getGastosTransacciones`,
      { params },
    );

    // data viene como { data: [...], totalCount, totalPages, currentPage }
    return {
      data: data.data,
      totalCount: data.totalCount,
      totalMontoGastos: data.totalMontoGastos,
      totalPagos: data.totalPagos,
      totalPages: data.totalPages,
      currentPage: data.currentPage,
    };
  };

  const getSubCategoriaTransaccionByCategoria = async (
    idSubCategoria,
    idEntidad,
  ) => {
    try {
      const url =
        `${serverURL}/transaccionAPI/getSubCategoriaTransaccionByCategoria/${idSubCategoria}` +
        (idEntidad ? `?idEntidad=${idEntidad}` : "");
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error fetching SubCat by Categoria:", error);
      return null;
    }
  };

  const postSubCategoriaTransaccion = async (
    descripcionSubCategoriaTransaccion,
    idCategoriaTransaccion,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postSubCategoriaTransaccion",
        {
          descripcion: descripcionSubCategoriaTransaccion,
          idCategoriaTransaccion: idCategoriaTransaccion,
        },
      );
      getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error creating SubCat:", error);
      throw error;
    }
  };

  const updateSubCategoriaTransaccion = async (idSubCategoria, descripcionSubCategoriaTransaccion, idCategoriaTransaccion) => {
    try {
      const payload = {
        descripcion: descripcionSubCategoriaTransaccion,
      };
      
      // Si se proporciona idCategoriaTransaccion, incluirlo en el payload
      if (idCategoriaTransaccion !== undefined && idCategoriaTransaccion !== null) {
        payload.idCategoriaTransaccion = idCategoriaTransaccion;
      }
      
      await axios.put(
        `${serverURL}/transaccionAPI/updateSubCategoriaTransaccion/${idSubCategoria}`,
        payload,
      );
      await getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error updating SubCat:", error);
      throw error;
    }
  };

  const deleteSubCategoriaTransaccion = async (idSubCategoria) => {
    try {
      await axios.delete(
        `${serverURL}/transaccionAPI/deleteSubCategoriaTransaccion/${idSubCategoria}`,
      );
      await getSubCategoriaTransaccion();
    } catch (error) {
      console.error("Error deleting SubCat:", error);
      throw error;
    }
  };

  // TRANSACCION TIPO TRANSACCION ***********************************************************************
  const [tipoTransaccion, arrayTipoTransaccion] = useState([]);
  const [gestionTipoTransaccionTablaData, setGestionTipoTransaccionTablaData] = useState([]);

  const getTipoTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTipoTransaccion",
      );
      // Validar que la respuesta sea un array válido
      if (Array.isArray(response.data)) {
        arrayTipoTransaccion(response.data);
      } else {
        console.error("Error: getTipoTransaccion no retornó un array válido", response.data);
        arrayTipoTransaccion([]); // Asegurar que siempre sea un array
      }
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
      // Asegurar que siempre sea un array incluso en caso de error
      arrayTipoTransaccion([]);
    }
  };

  const gestionTipoTransaccionTabla = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/gestionTipoTransaccionTabla",
      );
      // Validar que la respuesta sea un array válido
      if (Array.isArray(response.data)) {
        setGestionTipoTransaccionTablaData(response.data);
      } else {
        console.error("Error: gestionTipoTransaccionTabla no retornó un array válido", response.data);
        setGestionTipoTransaccionTablaData([]); // Asegurar que siempre sea un array
      }
    } catch (error) {
      console.error("Error fetching gestion tipo transaccion tabla:", error);
      // Asegurar que siempre sea un array incluso en caso de error
      setGestionTipoTransaccionTablaData([]);
    }
  };


  const postTipoTransaccion = async (descripcionTipoTransaccion, verEnCaja, verEnTransaccion, verEnColumna) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postTipoTransaccion", {
        descripcion: descripcionTipoTransaccion,
        verEnCaja: verEnCaja || false,
        verEnTransaccion: verEnTransaccion || false,
        verEnColumna: verEnColumna || null,
      });
      getTipoTransaccion();
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
      throw error;
    }
  };

  const updateTipoTransaccion = async (id, data) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/updateTipoTransaccion/${id}`,
        data
      );
      arrayTipoTransaccion(response.data);
      return response;
    } catch (error) {
      console.error("Error updating tipo transaccion:", error);
      throw error;
    }
  };

  const deleteTipoTransaccion = async (id) => {
    try {
      const response = await axios.delete(
        serverURL + `/transaccionAPI/deleteTipoTransaccion/${id}`
      );
      arrayTipoTransaccion(response.data.data);
      return response;
    } catch (error) {
      console.error("Error deleting tipo transaccion:", error);
      throw error;
    }
  };

  // TRANSACCION TRANSACCION PAGO ***********************************************************************
  const getTransaccionesPagoFilter = async (
    startDate,
    endDate,
    page,
    idTipoMedioPago,    // single (legacy / compat)
    idMedioPago,        // single (legacy / compat)
    zona,
    idUbicacion,
    idUsuario,
    idTipoTransaccion,
    idUbicacionesCsv = null,
    idTiposTransaccionCsv = null,
    idMediosPagoCsv = null,         // multi-select medios de pago específicos
    idTiposMedioPagoCsv = null,     // 🆕 multi-select tipos de medio de pago
  ) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionesPagoFilter",
        {
          params: {
            startDate,
            endDate,
            page,
            zona,
            idUsuario,
            ...(idUbicacionesCsv
              ? { idUbicaciones: idUbicacionesCsv }
              : { idUbicacion }),
            ...(idTiposTransaccionCsv
              ? { idTiposTransaccion: idTiposTransaccionCsv }
              : { idTipoTransaccion }),
            ...(idMediosPagoCsv
              ? { idMediosPago: idMediosPagoCsv }
              : { idMedioPago }),
            ...(idTiposMedioPagoCsv
              ? { idTiposMedioPago: idTiposMedioPagoCsv }
              : { idTipoMedioPago }),
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  const getAndPostCajaDatos = async (startDate, zona, idUbicacion, createOrUpdate, ubicacionIdsMulti = null, idTipoMedioPago = null, idMedioPago = null,) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getAndPostCajaDatos",
        {
          params: {
            startDate,
            zona,
            createOrUpdate,
            idTipoMedioPago,
            idMedioPago,
            ...(ubicacionIdsMulti && ubicacionIdsMulti.length > 0
              ? { idUbicaciones: ubicacionIdsMulti.join(",") }
              : { idUbicacion }),
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  const recalcularCajaCompleta = async (zona) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/caja/recalcular",
        {
          params: { zona },
        },
      );

      return response.data;
    } catch (error) {
      console.error("Error recalculando caja completa:", error);
      throw error;
    }
  };

  const getCajaAndRecalcularCaja = async (fecha, zona, idUbicacion, createOrUpdate) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getAndPostCajaDatos",
        {
          params: {
            startDate: fecha,
            zona,
            idUbicacion,
            createOrUpdate,
          },
        },
      );

      return response.data;
    } catch (error) {}
  };

  // TEST 8N8 ***********************************************************************

  const resumenVentasN8N = async (fecha) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/resumenVentasN8N",
        {
          fecha,
        },
      );

      return response.data;
    } catch (error) {}
  };

  // TRANSACCION TRANSACCION ITEM ***********************************************************************
  const [transaccionItem, arrayTransaccionItem] = useState([]);

  const getTransaccionItem = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionItem",
      );
      arrayTransaccionItem(response.data);
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionItemByTipoTransaccion = async (params) => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionItemByTipoTransaccion",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };
  // NUEVO: para gráficas, esto utiliza el filtro de ventas pero no tiene en cuenta el paginado
  const getTransaccionItemByTipoTransaccionAllData = async (params) => {
    try {
      const response = await axios.get(
        serverURL +
          "/transaccionAPI/getTransaccionItemByTipoTransaccionAllData",
        {
          params,
        },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los detalles de transacciones para gráficas:",
        error,
      );
      throw error;
    }
  };

  const getParametrosGlobales = async (parametros) => {
    try {
      const response = await axios.post(
        serverURL + "/adminAPI/getParametrosGlobales",
        { parametros },
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getParametrosGlobalesMenu = async () => {
    try {
      const response = await axios.get(
        serverURL + "/adminAPI/getParametrosGlobalesMenu"
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching parámetros globales del menú:", error);
      throw error;
    }
  };

  const updateParametroGlobal = async (nombreParametro, valorParametro) => {
    try {
      const response = await axios.put(
        serverURL + "/adminAPI/updateParametroGlobal",
        { nombreParametro, valorParametro }
      );
      return response.data;
    } catch (error) {
      console.error("Error updating parámetro global:", error);
      throw error;
    }
  };

  /** Logo navbar desde BD (base64). Sin valor o error → null (usar Lutente por defecto). */
  const getLogoNavbar = useCallback(async (tenantOverride) => {
    try {
      const tenant =
        tenantOverride ||
        erpCookies.get("tenant") ||
        erpCookies.get("tenantURL");

      if (!tenant) {
        return null;
      }

      const response = await axios.get(
        serverURL + "/adminAPI/logoNavbarBase64",
        { params: { tenant }, withCredentials: true },
      );

      const valor = response.data?.logoURL?.valorParametro;
      if (typeof valor === "string" && valor.trim() !== "") {
        return valor;
      }
      return null;
    } catch (error) {
      console.error("Error obteniendo logo navbar:", error);
      return null;
    }
  }, [serverURL]);

  const exportarPLUsBalanza = async (ubicacion) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/exportarPLUsBalanza?ubicacion=${ubicacion}`,
        {
          responseType: "blob", // Importante para descargar archivos
        },
      );

      // Crear un enlace temporal para descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      // Extraer el nombre del archivo del header Content-Disposition
      const contentDisposition = response.headers["content-disposition"];
      let filename = "plus_balanza.csv";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return { success: true, message: "Archivo exportado correctamente" };
    } catch (error) {
      console.error("Error al exportar PLUs de balanza:", error);
      throw error;
    }
  };

  const postTransaccionItem = async (
    idTransaccion,
    idItem,
    cantidad,
    precio,
    porcentajeDescuento,
    lotes, // 🆕 Parámetro opcional para lotes
    idUbicacion, // 🆕 Parámetro requerido para lotes
    porcentajeInteres = 0, // 🆕 Recargo por ítem (opcional)
  ) => {
    // console.log("AAA");
    // console.log("Datos enviados:", idItem);
    // console.log("Datos enviados:", { idItem, cantidad });
    try {
      await axios.post(serverURL + "/transaccionAPI/postTransaccionItem", {
        idTransaccion: idTransaccion,
        idItem: idItem,
        cantidad: cantidad,
        precio: precio,
        montoTotal:
          precio *
          cantidad *
          (1 - (porcentajeDescuento || 0) / 100) *
          (1 + (porcentajeInteres || 0) / 100),
        porcentajeDescuento: porcentajeDescuento, // Enviar descuento específico del ítem
        porcentajeInteres: porcentajeInteres || 0,
        lotes: lotes, // 🆕 Enviar lotes si existen
        idUbicacion: idUbicacion, // 🆕 Enviar ubicación
      });
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  const postTransaccionItemDevolucion = async (
    idTransaccion,
    idItem,
    cantidad,
    precio,
    porcentajeDescuento,
    signo,
    porcentajeInteres,
  ) => {
    try {
      // Calcular el monto total basado en el signo
      const descuento = porcentajeDescuento || 0;
      const interes = porcentajeInteres || 0;
      let montoTotal;
      if (signo === "-") {
        montoTotal = precio * cantidad * (1 - descuento / 100) * (1 + interes / 100);
      } else {
        montoTotal = precio * cantidad * (1 + interes / 100);
      }

      // Hacer la solicitud POST con el objeto correctamente estructurado
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionItemDevolucion",
        {
          idTransaccion: idTransaccion,
          idItem: idItem,
          cantidad: cantidad,
          precio: precio,
          montoTotal: montoTotal, // Incluye el monto calculado aquí
          porcentajeDescuento: descuento, // Manejar caso undefined
          porcentajeInteres: interes, // Interés aplicado al ítem
          signo: signo,
        },
      );
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  // TRANSACCION TRANSACCION ***********************************************************************
  const [transaccion, arrayTransaccion] = useState([]);

  const getTransaccion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccion",
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      const formattedTransacciones = transacciones.map((transaccion) => ({
        ...transaccion,
        createdAt: transaccion.createdAt
          ? format(new Date(transaccion.createdAt), "dd/MM/yyyy")
          : "",
      }));

      // Aquí asumo que `arrayTransaccion` es un setter para el estado
      arrayTransaccion(formattedTransacciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const updateDeleteTransaccion = async (id) => {
    try {
      await axios.put(
        serverURL + `/transaccionAPI/updateDeleteTransaccion/${id}`,
      );
    } catch (error) {
      console.error("Error al eliminar transaccion:", error);
      // 409: el server rechazó el borrado (p. ej. un cobro del módulo Servicios).
      // Se relanza para que la pantalla no informe un borrado que no ocurrió.
      if (error.response?.status === 409) throw error;
    }
  };

  const postTransaccionAuditoria = async (idTransaccion, idUsuario, comentario, accion = "eliminar") => {
    try {
      const response = await axios.post(
        serverURL + `/transaccionAPI/postTransaccionAuditoria`,
        {
          idTransaccion,
          idUsuario,
          comentario,
          accion,
        }
      );
      return response.data;
    } catch (error) {
      // console.error("Error al crear registro de auditoría:", error);
      throw error;
    }
  };

  const getTransaccionAuditoria = async (idTransaccion) => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionAuditoria/${idTransaccion}`
      );
      return response.data;
    } catch (error) {
      // console.error("Error al obtener auditoría de transacción:", error);
      return null; // Retorna null si no hay auditoría o hay error
    }
  };

  const [transaccionFilter, setTransaccionFilter] = useState([]);

  const getTransaccionFilter = async (idTransaccion) => {
    try {
      // console.log(idTransaccion);
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionFilter/${idTransaccion}`,
      );

      // console.log(response.data);
      return response.data;

      // Accede a la propiedad `data` de la respuesta

      /*const formattedTransacciones = transacciones.map((transaccion) => ({
        ...transaccion,
        createdAt: transaccion.createdAt
          ? format(new Date(transaccion.createdAt), "dd/MM/yyyy")
          : "",
      }));*/
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const [transaccionTransformed, arrayTransaccionTransformed] = useState([]);

  /**
   * @deprecated Sin consumidores desde el 2026-09-21: traía TODAS las transacciones del tenant
   * (46 MB en lapolo) y ningún componente leía `transaccionTransformed`. No volver a usar;
   * las pantallas paginan con `fetchFilteredTransactions`.
   */
  const getTransaccionTransformed = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTransaccionTransformed",
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      arrayTransaccionTransformed(transacciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  // Nueva función para obtener TODOS los datos de ventas sin paginado (para gráficas)
  const getTransaccionTransformedVentasAllData = async (
    tipoTransaccion,
    fecha,
    formattedDate2,
    dniCliente = "",
    selectedUbicacion = "",
    valorMin = "",
    valorMax = "",
    mostrarEliminados = false,
    idTransaccionSearch = "",
    traerDevolucion = "",
    buscarCAE = "",
    tipoTransaccionFiltro = "",
    canalEntidad = "",
    atributosEntidad = {},
  ) => {
    try {
      const params = new URLSearchParams({
        fecha,
        formattedDate2,
        dniCliente,
        selectedUbicacion,
        valorMin,
        valorMax,
        mostrarEliminados: mostrarEliminados.toString(),
        idTransaccionSearch,
        traerDevolucion,
        buscarCAE,
        tipoTransaccionFiltro,
        canalEntidad,
        ...(atributosEntidad[1] && { atributoEntidad1: atributosEntidad[1] }),
        ...(atributosEntidad[2] && { atributoEntidad2: atributosEntidad[2] }),
        ...(atributosEntidad[3] && { atributoEntidad3: atributosEntidad[3] }),
        ...(atributosEntidad[4] && { atributoEntidad4: atributosEntidad[4] }),
        ...(atributosEntidad[5] && { atributoEntidad5: atributosEntidad[5] }),
        ...(atributosEntidad[6] && { atributoEntidad6: atributosEntidad[6] }),
        ...(atributosEntidad[7] && { atributoEntidad7: atributosEntidad[7] }),
        ...(atributosEntidad[8] && { atributoEntidad8: atributosEntidad[8] }),
        ...(atributosEntidad[9] && { atributoEntidad9: atributosEntidad[9] }),
        ...(atributosEntidad[10] && { atributoEntidad10: atributosEntidad[10] }),
      });

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedVentasAllData/${tipoTransaccion}?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los datos de ventas para gráficas:",
        error,
      );
      throw error;
    }
  };

  // Nueva función para obtener TODOS los datos de presupuestos sin paginado (para gráficas)
  const getTransaccionTransformedPresupuestosAllData = async (
    tipoTransaccion,
    fecha,
    formattedDate2,
    dniCliente = "",
    selectedUbicacion = "",
    valorMin = "",
    valorMax = "",
    mostrarEliminados = false,
    idTransaccionSearch = "",
    traerDevolucion = "",
    buscarCAE = "",
    tipoTransaccionFiltro = "",
    canalEntidad = "",
    atributosEntidad = {},
  ) => {
    try {
      const params = new URLSearchParams({
        fecha,
        formattedDate2,
        dniCliente,
        selectedUbicacion,
        valorMin,
        valorMax,
        mostrarEliminados: mostrarEliminados.toString(),
        idTransaccionSearch,
        traerDevolucion,
        buscarCAE,
        tipoTransaccionFiltro,
        canalEntidad,
        ...(atributosEntidad[1] && { atributoEntidad1: atributosEntidad[1] }),
        ...(atributosEntidad[2] && { atributoEntidad2: atributosEntidad[2] }),
        ...(atributosEntidad[3] && { atributoEntidad3: atributosEntidad[3] }),
        ...(atributosEntidad[4] && { atributoEntidad4: atributosEntidad[4] }),
        ...(atributosEntidad[5] && { atributoEntidad5: atributosEntidad[5] }),
        ...(atributosEntidad[6] && { atributoEntidad6: atributosEntidad[6] }),
        ...(atributosEntidad[7] && { atributoEntidad7: atributosEntidad[7] }),
        ...(atributosEntidad[8] && { atributoEntidad8: atributosEntidad[8] }),
        ...(atributosEntidad[9] && { atributoEntidad9: atributosEntidad[9] }),
        ...(atributosEntidad[10] && { atributoEntidad10: atributosEntidad[10] }),
      });

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedPresupuestosAllData/${tipoTransaccion}?${params}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener TODOS los datos de presupuestos para gráficas:",
        error,
      );
      throw error;
    }
  };

  const getTransaccionMontoTotalByTipoTransaccion = async (
    idTipoTransaccion,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionMontoTotalByTipoTransaccion/${idTipoTransaccion}`,
      );

      return response.data; // Cambiar aquí para acceder a `data`
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedVentas = async (
    tipoTransaccion,
    date,
    page = 1,
    limit = 100,
    options = {},
    formattedDate2,
    dniCliente,
    selectedUbicacion,
    valorMin,
    valorMax,
    mostrarEliminados,
    idTransaccionSearch,
    traerDevolucion,
    buscarCAE,
    tipoTransaccionFiltro,
    canalEntidad,
    soloFacturadas = false,
    idTipoMedioPago = null,
    idMedioPago = null,
    atributosEntidad = {},
  ) => {
    try {
         console.log("Frontend - soloFacturadas:", soloFacturadas, "type:", typeof soloFacturadas);

      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedVentas/${tipoTransaccion}`,
        {
          params: {
            fecha: date,
            page: page,
            limit: limit,
            formattedDate2: formattedDate2,
            dniCliente: dniCliente,
            selectedUbicacion: selectedUbicacion,
            valorMin: valorMin,
            valorMax: valorMax,
            mostrarEliminados: mostrarEliminados,
            idTransaccionSearch: idTransaccionSearch,
            traerDevolucion: traerDevolucion,
            buscarCAE: buscarCAE,
            tipoTransaccionFiltro: tipoTransaccionFiltro,
            canalEntidad: canalEntidad,
            soloFacturadas: soloFacturadas,
            idTipoMedioPago: idTipoMedioPago,
            idMedioPago: idMedioPago,
            ...(atributosEntidad[1] && { atributoEntidad1: atributosEntidad[1] }),
            ...(atributosEntidad[2] && { atributoEntidad2: atributosEntidad[2] }),
            ...(atributosEntidad[3] && { atributoEntidad3: atributosEntidad[3] }),
            ...(atributosEntidad[4] && { atributoEntidad4: atributosEntidad[4] }),
            ...(atributosEntidad[5] && { atributoEntidad5: atributosEntidad[5] }),
            ...(atributosEntidad[6] && { atributoEntidad6: atributosEntidad[6] }),
            ...(atributosEntidad[7] && { atributoEntidad7: atributosEntidad[7] }),
            ...(atributosEntidad[8] && { atributoEntidad8: atributosEntidad[8] }),
            ...(atributosEntidad[9] && { atributoEntidad9: atributosEntidad[9] }),
            ...(atributosEntidad[10] && { atributoEntidad10: atributosEntidad[10] }),
          },
          signal: options.signal,
        },
      );

      if (!response || response.status < 200 || response.status >= 300) {
        throw new Error("Network response was not ok");
      }

      // console.log(response.data);

      return response.data; // API devuelve { total, totalPages, currentPage, data }
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedCompras = async (
    tipoTransaccion,
    startDate,
    endDate,
    page,
    limit,
    options,
    idProveedor,
    idUbicacion,
    valorMin,
    valorMax,
    idEstado,
    mostrarDeletes,
    idTransaccionSearch,
    atributosEntidad = {},
  ) => {
    try {
      const queryParams = new URLSearchParams();
      queryParams.append("startDate", startDate);
      queryParams.append("endDate", endDate);
      queryParams.append("page", page.toString());
      queryParams.append("limit", limit.toString());
      if (idProveedor) queryParams.append("idProveedor", idProveedor);
      if (idUbicacion) queryParams.append("idUbicacion", idUbicacion);
      if (idEstado != null && idEstado !== "")
        queryParams.append("idEstado", idEstado);

      if (Number(valorMin) !== 0 || Number(valorMax) !== 0) {
        queryParams.append("valorMin", valorMin.toString());
        queryParams.append("valorMax", valorMax.toString());
      }
      queryParams.append("mostrarDeletes", mostrarDeletes);
      queryParams.append("idTransaccionSearch", idTransaccionSearch);

       // Agregar filtros de atributos de entidad
       if (atributosEntidad[1]) queryParams.append("atributoEntidad1", atributosEntidad[1]);
       if (atributosEntidad[2]) queryParams.append("atributoEntidad2", atributosEntidad[2]);
       if (atributosEntidad[3]) queryParams.append("atributoEntidad3", atributosEntidad[3]);
       if (atributosEntidad[4]) queryParams.append("atributoEntidad4", atributosEntidad[4]);
       if (atributosEntidad[5]) queryParams.append("atributoEntidad5", atributosEntidad[5]);
       if (atributosEntidad[6]) queryParams.append("atributoEntidad6", atributosEntidad[6]);
       if (atributosEntidad[7]) queryParams.append("atributoEntidad7", atributosEntidad[7]);
       if (atributosEntidad[8]) queryParams.append("atributoEntidad8", atributosEntidad[8]);
       if (atributosEntidad[9]) queryParams.append("atributoEntidad9", atributosEntidad[9]);
       if (atributosEntidad[10]) queryParams.append("atributoEntidad10", atributosEntidad[10]);

      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getTransaccionTransformedCompras/${tipoTransaccion}?${queryParams.toString()}`,
        options,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const getTransaccionTransformedPresupuesto = async (
    tipoTransaccion,
    date,
    page = 1,
    limit = 100,
    options = {},
    formattedDate2,
    dniCliente,
    selectedUbicacion,
    valorMin,
    valorMax,
    mostrarEliminados,
    idTransaccionSearch,
    traerDevolucion,
    buscarCAE,
    tipoTransaccionFiltro,
    canalEntidad,
    atributosEntidad = {},
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionTransformedPresupuesto/${tipoTransaccion}`,
        {
          params: {
            fecha: date,
            page: page,
            limit: limit,
            formattedDate2: formattedDate2,
            dniCliente: dniCliente,
            selectedUbicacion: selectedUbicacion,
            valorMin: valorMin,
            valorMax: valorMax,
            mostrarEliminados: mostrarEliminados,
            idTransaccionSearch: idTransaccionSearch,
            traerDevolucion: traerDevolucion,
            buscarCAE: buscarCAE,
            tipoTransaccionFiltro: tipoTransaccionFiltro,
            canalEntidad: canalEntidad,
            ...(atributosEntidad[1] && { atributoEntidad1: atributosEntidad[1] }),
            ...(atributosEntidad[2] && { atributoEntidad2: atributosEntidad[2] }),
            ...(atributosEntidad[3] && { atributoEntidad3: atributosEntidad[3] }),
            ...(atributosEntidad[4] && { atributoEntidad4: atributosEntidad[4] }),
            ...(atributosEntidad[5] && { atributoEntidad5: atributosEntidad[5] }),
            ...(atributosEntidad[6] && { atributoEntidad6: atributosEntidad[6] }),
            ...(atributosEntidad[7] && { atributoEntidad7: atributosEntidad[7] }),
            ...(atributosEntidad[8] && { atributoEntidad8: atributosEntidad[8] }),
            ...(atributosEntidad[9] && { atributoEntidad9: atributosEntidad[9] }),
            ...(atributosEntidad[10] && { atributoEntidad10: atributosEntidad[10] }),
          },
          signal: options.signal,
        },
      );
      return response.data;
    } catch (error) {
      if (options.signal?.aborted) {
        console.warn("Solicitud abortada");
      } else {
        console.error("Error fetching presupuestos:", error);
      }
      throw error;
    }
  };

  const postTransaccion = async (
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idSubCategoriaTransaccion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    montoDescuento,
    porcentajeDescuento,
    transaccionAsociada = null,
    fecha = null,
    afectaCuentaCorriente = false,
    clientOS = null, // Nuevo parámetro para el SO del cliente
    operacionParaCuentaCorriente = null, // 'operacionCC' o 'operacionCaja' - indica qué operación usar para CC
    archivosAdjuntos = null, // Array de archivos en Base64
  ) => {
    try {
      const fechaTransaccion = fecha ? fecha : new Date();
      
      // Si no se proporciona clientOS, intentar detectarlo
      let detectedOS = clientOS;
      if (!detectedOS) {
        try {
          // Detección simple inline si no se importó la utilidad
          const platform = navigator.platform.toLowerCase();
          if (platform.includes('win')) detectedOS = 'windows';
          else if (platform.includes('mac')) detectedOS = 'macos';
          else if (platform.includes('linux')) detectedOS = 'linux';
          else detectedOS = 'unknown';
        } catch (e) {
          detectedOS = 'unknown';
        }
      }
      
      const transaccionResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccion",
        {
          fecha: fechaTransaccion, // Fecha contable elegida por el usuario 
          montoTotal: montoTotal,
          idTipoTransaccion: idTipoTransaccion,
          idEntidad: idEntidad,
          idCategorizacion: idSubCategoriaTransaccion,
          descripcion: descripcion,
          fechaHoraCreacion: fechaTransaccion, // ✅ FIX: Usar la misma fecha que 'fecha' para que ambas transacciones de transferencia interna tengan la misma fecha
          idUsuario: idUsuario,
          idUbicacion: idUbicacion,
          idNegocio: idNegocio,
          transaccionAsociada: transaccionAsociada,
          montoDescuento: montoDescuento, // Enviar valor de descuento total
          porcentajeDescuento: porcentajeDescuento, // Enviar porcentaje de descuento
          afectaCuentaCorriente: afectaCuentaCorriente, // Enviar si afecta cuenta corriente
          operacionParaCuentaCorriente: operacionParaCuentaCorriente, // 'operacionCC' o 'operacionCaja' - indica qué operación usar
          clientOS: detectedOS, // Enviar SO del cliente para instrucciones de impresión
          archivosAdjuntos: archivosAdjuntos ? JSON.stringify(archivosAdjuntos) : null, // Enviar archivos como JSON string
        },
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  const postTransaccionDevolucion = async (
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idSubCategoriaTransaccion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    transaccionAsociada,
    montoDescuento,
    porcentajeDescuento,
  ) => {
    // console.log(
    //   "Datos enviados:",
    //   "montoTotal " + montoTotal,
    //   "idTipoTransaccion " + idTipoTransaccion,
    //   "idEntidad " + idEntidad,
    //   "idSubCategoriaTransaccion " + idSubCategoriaTransaccion,
    //   "descripcion " + descripcion,
    //   "idUsuario " + idUsuario,
    //   "idUbicacion " + idUbicacion,
    //   "idNegocio " + idNegocio
    // );

    try {
      const transaccionResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionDevolucion",
        {
          fecha: new Date(), // Fecha hardcodeada, *HARDCODED* 
          montoTotal: montoTotal,
          idTipoTransaccion: idTipoTransaccion,
          idEntidad: idEntidad,
          idCategorizacion: idSubCategoriaTransaccion,
          descripcion: descripcion,
          fechaHoraCreacion: new Date(),
          idUsuario: idUsuario,
          idUbicacion: idUbicacion,
          idNegocio: idNegocio,
          transaccionAsociada: transaccionAsociada,
          montoDescuento: montoDescuento, // Enviar valor de descuento total
          porcentajeDescuento: porcentajeDescuento, // Enviar porcentaje de descuento
        },
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error creating tipo transaccion:", error);
    }
  };

  const validarDevolucionCanje = async (
    idTransaccionOriginal,
    itemsDevolucion,
  ) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/validarDevolucionCanje",
        {
          idTransaccionOriginal: idTransaccionOriginal,
          itemsDevolucion: itemsDevolucion,
        },
      );
      return response.data;
    } catch (error) {
      // Si es un error 400 con datos de validación, retornar esos datos
      if (
        error.response?.status === 400 &&
        error.response?.data?.valido !== undefined
      ) {
        return error.response.data;
      }

      // Para otros errores, lanzar la excepción
      console.error("Error en validación de devolución:", error);
      throw error;
    }
  };

  const postTransaccionPago = async (idTransaccion, idPago, fechaOriginal = null) => {
    try {
      const transaccionPagoResponse = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionPago",
        {
          idTransaccion: idTransaccion,
          idPago: idPago,
          ...(fechaOriginal && { fechaOriginal }), // Solo incluir si existe
        },
      );
      return transaccionPagoResponse;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const postCrearPago = async (
    idMoneda,
    cotizacion,
    idMedioDePago,
    montoTotal,
    fechaOriginal = null, // Parámetro opcional para edición de ventas
  ) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postCrearPago",
        {
          idMoneda: idMoneda,
          cotizacion: cotizacion,
          idMedioDePago: idMedioDePago,
          montoTotal: montoTotal,
          ...(fechaOriginal && { fechaOriginal }), // Solo incluir si existe
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const [estados, arrayEstados] = useState([]); //Define el estado ubicaciones con su función setUbicaciones. Inicialmente es un array vacío y contendrá las ubicaciones que

  const getEstadoCompra = async () => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getEstadoCompra`,
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  const postTransaccionCompraEstado = async (idTransaccion, idEstado) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionCompraEstado",
        {
          idTransaccion,
          idEstado,
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const postTransaccionCompraItem = async (
    fecha,
    idTransaccion,
    idItem,
    cantidadRecibida,
  ) => {
    try {
      const transaccionCrearPago = await axios.post(
        serverURL + "/transaccionAPI/postTransaccionCompraItem",
        {
          fecha,
          idTransaccion,
          idItem,
          cantidadRecibida,
        },
      );
      return transaccionCrearPago;
    } catch (error) {
      console.error("Error creating transaccion pago:", error);
    }
  };

  const updateTransaccionCompraEstado = async (idTransaccion, idEstado) => {
    try {
      const updateCompraEstado = await axios.put(
        serverURL + "/transaccionAPI/updateTransaccionCompraEstado",
        {
          idTransaccion, // ✅ este nombre sí lo reconoce el backend
          idEstado,
        },
      );
      return updateCompraEstado;
    } catch (error) {
      console.error("Error actualizando estado de compra:", error);
    }
  };

  const putTransaccion = async (
    idTransaccion,
    montoTotal,
    idTipoTransaccion,
    idEntidad,
    idCategorizacion,
    descripcion,
    idUsuario,
    idUbicacion,
    idNegocio,
    montoDescuento,
    porcentajeDescuento,
    transaccionAsociada = null, // ✅ Nuevo parámetro para transferencias internas
    fecha = null, // ✅ Nuevo parámetro para especificar la fecha
    archivosAdjuntos = undefined, // Array Base64; undefined = no tocar el campo
  ) => {
    // console.log(
    //   "idTransaccion " + idTransaccion,
    //   "montoTotal " + montoTotal,
    //   "idTipoTransaccion " + idTipoTransaccion,
    //   "idEntidad " + idEntidad,
    //   "idSubCategoriaTransaccion " + idSubCategoriaTransaccion,
    //   "descripcion " + descripcion,
    //   "idUsuario " + idUsuario,
    //   "idUbicacion " + idUbicacion,
    //   "idNegocio " + idNegocio,
    //   "montoDescuento " + montoDescuento,
    //   "porcentajeDescuento " + porcentajeDescuento,
    //   "transaccionAsociada " + transaccionAsociada,
    //   "fecha " + fecha
    // );
    
    try {
      // ✅ Preparar el body de la petición
      const requestBody = {
        montoTotal,
        idTipoTransaccion,
        idEntidad,
        idCategorizacion,
        descripcion,
        idUsuario,
        idUbicacion,
        idNegocio,
        montoDescuento,
        porcentajeDescuento,
        transaccionAsociada, // ✅ Incluir transaccionAsociada en el body
      };

      // ✅ IMPORTANTE: Solo incluir campos de fecha si se proporcionan explícitamente
      // Si fecha viene null/undefined, NO enviar fecha ni fechaHoraCreacion
      // Esto permite que el backend preserve las fechas originales en ediciones
      if (fecha) {
        requestBody.fecha = fecha;
        requestBody.fechaHoraCreacion = fecha;
      }

      // Solo enviar adjuntos si el caller los pasó (evita borrar en otros put)
      if (archivosAdjuntos !== undefined) {
        requestBody.archivosAdjuntos = archivosAdjuntos
          ? JSON.stringify(archivosAdjuntos)
          : null;
      }
      
      const transaccionResponse = await axios.put(
        `${serverURL}/transaccionAPI/putTransaccion/${idTransaccion}`,
        requestBody,
      );
      return transaccionResponse;
    } catch (error) {
      console.error("Error updating transacción:", error);
    }
  };

  const getTransaccionItemByTransactionAndItem = async (
    idTransaccion,
    idItem,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionItemByTransactionAndItem/${idTransaccion}/${idItem}`,
      );
      return response.data; // Devuelve el transaccionItem encontrado
    } catch (error) {
      console.error("Error al obtener transaccionItem:", error);
      return null; // Retorna null si no se encuentra o hay un error
    }
  };

  const updateTransaccionPago = async (
    idTransaccion,
    idMedioDePago,
    montoTotal,
  ) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateTransaccionPago`,
        { idTransaccion, idMedioDePago, montoTotal },
      );
      return response.data; // Retorna los datos actualizados
    } catch (error) {
      console.error("Error al actualizar transaccionPago:", error);
    }
  };

  const updateTransaccionItem = async (idTransaccion, idItem, data) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/actualizarTransaccionExistente/${idTransaccion}/${idItem}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar transaccionItem:", error);
    }
  };

  const [transaccionItemsPostDelete, setTransaccionItemsPostDelete] = useState(
    [],
  );

  // Función para eliminar un transaccionItem
  const deleteItem = async (idTransaccion, idItem) => {
    try {
      const response = await axios.delete(
        `${serverURL}/transaccionAPI/transaccionItemDelete/${idTransaccion}/${idItem}`,
      );

      // Actualizar la lista de transaccionItems después de eliminar
      setTransaccionItemsPostDelete((prevItems) =>
        prevItems.filter(
          (item) =>
            !(item.idTransaccion === idTransaccion && item.idItem === idItem),
        ),
      );

      console.log("TransaccionItem eliminado exitosamente:", response.data);
    } catch (error) {
      console.error("Error al eliminar transaccionItem:", error);
    }
  };

  // Función para obtener transaccionItems por idTransaccion
  const getTransaccionItemsByTransactionId = async (idTransaccion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/transaccionItemsById/${idTransaccion}`,
      );
      console.log("TransaccionItems obtenidos exitosamente:", response.data);
      return response.data; // Retorna los ítems si existen
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log("No se encontraron transaccionItems para esta transacción");
        return []; // Retorna un array vacío si no existen ítems
      } else {
        console.error("Error al obtener transaccionItems:", error);
        throw error; // Lanza el error para otros errores diferentes a 404
      }
    }
  };

  const deleteTransaccionItemNoLista = async (idTransaccion, idItems) => {
    try {
      await axios.delete(
        `${serverURL}/transaccionAPI/transaccionItemDelete/${idTransaccion}`,
        {
          data: { idItems },
        },
      );
      console.log("TransaccionItems eliminados exitosamente.");
    } catch (error) {
      console.error("Error eliminando transaccionItems:", error);
    }
  };

  const deleteTransaccionItem = async (idTransaccion, idItem) => {
    try {
      await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionItem/${idTransaccion}/${idItem}`,
      );
    } catch (error) {
      console.log("Error eliminando deleteTransaccionItem:", error);
    }
  };

  const deleteTransaccionPago = async (idTransaccion) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionPago/${idTransaccion}`,
      );
      console.log("✅ TransaccionPago eliminados:", response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log("⚠️ No se encontraron TransaccionPago para eliminar");
        return { affectedRows: 0 };
      }
      console.error("❌ Error eliminando deleteTransaccionPago:", error);
      throw error;
    }
  };

  // 🆕 Obtener lotes de una transacción
  const getLotesDeTransaccion = async (idTransaccion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/lotesDeTransaccion/${idTransaccion}`,
      );
      console.log("✅ Lotes de transacción obtenidos:", response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log("⚠️ No se encontraron lotes para esta transacción");
        return [];
      }
      console.error("❌ Error obteniendo lotes de transacción:", error);
      return [];
    }
  };

  // 🆕 Revertir stock de lotes de una transacción
  const revertirLotesDeTransaccion = async (idTransaccion) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/revertirLotesDeTransaccion/${idTransaccion}`,
      );
      console.log("✅ Lotes revertidos:", response.data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        console.log("⚠️ No se encontraron lotes para revertir");
        return { lotesRevertidos: 0 };
      }
      console.error("❌ Error revirtiendo lotes de transacción:", error);
      throw error;
    }
  };

  const deleteTransaccionCompraItem = async (idTransaccion, idItem) => {
    try {
      await axios.put(
        `${serverURL}/transaccionAPI/deleteTransaccionCompraItem/${idTransaccion}/${idItem}`,
      );
    } catch (error) {
      console.log("Error eliminando transaccionCompraItem:", error);
    }
  };

  // Crear impuesto de item de transacción
  const postTransaccionImpuestoItem = async (
    idTransaccion,
    idItem,
    idImpuesto,
    porcentaje,
    montoTotal,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionImpuestoItem",
        {
          idTransaccion: idTransaccion,
          idItem: idItem,
          idImpuesto: idImpuesto,
          porcentaje: porcentaje,
          montoTotal: montoTotal || null,
        },
      );
    } catch (error) {
      console.error("Error creating impuesto item transaccion:", error);
    }
  };

  // Actualizar impuesto de item de transacción
  const updateTransaccionImpuestoItem = async (idTransaccion, idItem, data) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateTransaccionImpuestoItem/${idTransaccion}/${idItem}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al actualizar impuesto de item de transacción:",
        error,
      );
    }
  };

  // Obtener impuestos de items de una transacción
  const getTransaccionImpuestoItems = async (idTransaccion) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTransaccionImpuestoItems/${idTransaccion}`,
      );
      console.log(
        "Impuestos de items de transacción obtenidos exitosamente:",
        response.data,
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.log(
          "No se encontraron impuestos de items para esta transacción",
        );
        return [];
      } else {
        console.error(
          "Error al obtener impuestos de items de transacción:",
          error,
        );
        throw error;
      }
    }
  };

  const fetchFilteredTransactions = async (
    startDate,
    endDate,
    medioDePagoId,
    tipoMedioDePagoId,
    tipoTransaccionId,
    page,
    idTransaccionSearch,
    idDni,
    idUbicacion,
    limit = 100,
    atributosParams = {},
    incluirEliminados = false
  ) => {
    try {
      // Construir params, filtrando valores null/undefined
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (medioDePagoId != null) params.medioDePagoId = medioDePagoId;
      if (tipoMedioDePagoId != null) params.tipoMedioDePagoId = tipoMedioDePagoId;
      if (tipoTransaccionId != null) params.tipoTransaccionId = tipoTransaccionId;
      params.page = page || 1;
      if (idTransaccionSearch) params.idTransaccionSearch = idTransaccionSearch;
      if (idDni != null) params.idDni = idDni;
      if (idUbicacion != null) params.idUbicacion = idUbicacion;
      params.limit = limit || 100;
      
      // Agregar parámetro para incluir eliminados
      if (incluirEliminados === true) {
        params.incluirEliminados = true;
      }
      
      // Agregar atributos dinámicos (solo los que tienen valor)
      Object.keys(atributosParams).forEach(key => {
        if (atributosParams[key] != null && atributosParams[key] !== '') {
          params[key] = atributosParams[key];
        }
      });
      
      const response = await axios.get(
        `${serverURL}/transaccionAPI/transaccionesFiltered`,
        {
          params,
        },
      );

      return response.data; // Devuelve los datos para utilizarlos después
      //setTotalPages(response.data.totalPages); // Total de páginas
      //setTotalCount(response.data.totalCount); // Cantidad total de registros
    } catch (error) {
      console.error("Error al obtener transacciones:", error);
    }
  };
  // TRANS CUENTRA CORRIENTE CONTEXT ***********************************************************************

  const [cuentaCorrienteTransformed, arrayCuentaCorrienteTransformed] =
    useState([]);

  const getCuentaCorrienteTransformed = async (
    tipoTransaccion,
    date,
    page = 1,
    limit = 100,
    options = {},
    formattedDate2,
    dniCliente,
    selectedUbicacion,
    valorMin,
    valorMax,
    mostrarEliminados,
    idTransaccionSearch,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getCuentaCorrienteTransformed/${tipoTransaccion}`,
        {
          params: {
            fecha: date,
            page: page,
            limit: limit,
            formattedDate2: formattedDate2,
            dniCliente: dniCliente,
            selectedUbicacion: selectedUbicacion,
            valorMin: valorMin,
            valorMax: valorMax,
            mostrarEliminados: mostrarEliminados,
            idTransaccionSearch: idTransaccionSearch,
          },
          signal: options.signal,
        },
      );

      // Accede a la propiedad `data` de la respuesta
      const transacciones = response.data; // Cambiar aquí para acceder a `data`

      arrayCuentaCorrienteTransformed(transacciones); // Cambiar aquí también
      return transacciones.data;
    } catch (error) {
      console.error("Error fetching tipo transaccion:", error);
    }
  };

  // ITEM CONTEXT ***********************************************************************
  // ITEM CONTEXT ***********************************************************************
  // ITEM CONTEXT ***********************************************************************

  const [itemAndItemUbicacion, arrayItemAndItemUbicacion] = useState([]);

  const getItemAndItemUbicacion = async (
    page = 1,
    limit = 100,
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId = null,
    searchText = null, // Nuevo parámetro para búsqueda múltiple
    soloItemsConPLU = false,
    filtrosAtributos = {}, // NUEVO: Filtros dinámicos por atributos
    sortField = null,
    sortDirection = null,
  ) => {
    try {
      // Construir params base
      const params = {
        page,
        limit,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloItemsConPLU,
      };

      if (sortField && sortDirection) {
        params.sortField = sortField;
        params.sortDirection = sortDirection;
      }

      // NUEVO: Agregar filtros de atributos si existen
      // Serializar como JSON solo si hay filtros activos
      if (filtrosAtributos && Object.keys(filtrosAtributos).length > 0) {
        // Filtrar solo valores no vacíos
        const filtrosActivos = Object.entries(filtrosAtributos)
          .filter(([_, valor]) => valor && valor.trim() !== "")
          .reduce((acc, [campo, valor]) => {
            acc[campo] = valor;
            return acc;
          }, {});
        
        if (Object.keys(filtrosActivos).length > 0) {
          params.filtrosAtributos = JSON.stringify(filtrosActivos);
          console.log('📊 Enviando filtros de atributos al backend:', filtrosActivos);
        }
      }

      const response = await axios.get(
        serverURL + "/itemAPI/getItemAndItemUbicacion",
        { params }
      );
      arrayItemAndItemUbicacion(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const updateItemAtributo = async (payload) => {
    try {
      const response = await axios.put(
        serverURL + "/itemAPI/updateItemAtributo",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar atributos:", error);
    }
  };

  const [itemAtributo, arrayItemAtributo] = useState([]);
  const getItemAtributo = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItemAtributo");
      arrayItemAtributo(response.data);
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const [itemAtributoNoEliminados, setItemAtributoNoEliminados] = useState([]);
  // Obtener atributos no eliminados (no pisa estado si la lista no cambió:
  // evita re-renders globales en todos los consumidores del contexto).
  const getItemAtributoNoEliminados = useCallback(async () => {
    try {
      const response = await axios.get(
        serverURL + "/itemAPI/getItemAtributoNoEliminados",
      );
      const next = Array.isArray(response.data) ? response.data : [];
      setItemAtributoNoEliminados((prev) => {
        if (
          Array.isArray(prev) &&
          prev.length === next.length &&
          prev.every((p, i) => p?.id === next[i]?.id && p?.nombre === next[i]?.nombre)
        ) {
          return prev
        }
        return next
      });
    } catch (error) {
      console.error("Error al obtener atributos:", error);
    }
  }, [serverURL]);

  // ENTIDAD ATRIBUTO ***********************************************************************
  const updateEntidadAtributo = async (payload) => {
    try {
      const response = await axios.put(
        serverURL + "/adminAPI/updateEntidadAtributo",
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar atributos de entidad:", error);
    }
  };

  const [entidadAtributo, arrayEntidadAtributo] = useState([]);
  const getEntidadAtributo = async (idTipoEntidad) => {
    if (!idTipoEntidad) {
      console.warn('idTipoEntidad requerido para obtener atributos');
      return [];
    }
    
    try {
      const response = await axios.get(
        serverURL + "/adminAPI/getEntidadAtributo",
        { params: { idTipoEntidad } }
      );
      arrayEntidadAtributo(response.data);
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching entidad atributo:", error);
      return [];
    }
  };

  const [entidadAtributoNoEliminados, setEntidadAtributoNoEliminados] = useState([]);
  // Obtener atributos de entidad no eliminados
  const getEntidadAtributoNoEliminados = async (idTipoEntidad) => {
    if (!idTipoEntidad) {
      console.warn('idTipoEntidad requerido para obtener atributos');
      setEntidadAtributoNoEliminados([]);
      return [];
    }
    
    try {
      const response = await axios.get(
        serverURL + "/adminAPI/getEntidadAtributoNoEliminados",
        { params: { idTipoEntidad } }
      );
      setEntidadAtributoNoEliminados(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener atributos de entidad:", error);
      setEntidadAtributoNoEliminados([]);
      return [];
    }
  };

  // ENTIDAD ATRIBUTO CLASIFICACION ***********************************************************************
  const [entidadAtributoClasificacion, setEntidadAtributoClasificacion] = useState([]);
  
  // Obtener todas las opciones de atributos
  const getEntidadAtributoClasificacion = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getEntidadAtributoClasificacion");
      setEntidadAtributoClasificacion(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener opciones de atributos:", error);
      throw error;
    }
  };

  // Obtener opciones por idEntidadAtributo
  const getEntidadAtributoClasificacionByIdAtributo = async (idAtributo, idTipoEntidad) => {
    if (!idAtributo || !idTipoEntidad) {
      console.warn('idAtributo e idTipoEntidad requeridos');
      return [];
    }
    
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getEntidadAtributoClasificacionByIdAtributo`,
        { params: { idAtributo, idTipoEntidad } }
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener opciones por atributo:", error);
      return [];
    }
  };

  // Crear una nueva opción de atributo
  const postEntidadAtributoClasificacion = async (data) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/postEntidadAtributoClasificacion", data);
      return response.data;
    } catch (error) {
      console.error("Error al crear opción de atributo:", error);
      throw error;
    }
  };

  // Actualizar una opción de atributo
  const updateEntidadAtributoClasificacion = async (id, descripcion, eliminado) => {
    try {
      const response = await axios.put(serverURL + "/adminAPI/updateEntidadAtributoClasificacion", {
        id,
        descripcion,
        eliminado,
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar opción de atributo:", error);
      throw error;
    }
  };

  // Eliminar una opción de atributo
  const deleteEntidadAtributoClasificacion = async (id) => {
    try {
      const response = await axios.post(serverURL + "/adminAPI/deleteEntidadAtributoClasificacion", {
        id,
      });
      return response.data;
    } catch (error) {
      console.error("Error al eliminar opción de atributo:", error);
      throw error;
    }
  };

  // ITEM CREATE ITEM***********************************************************************
  const [item, arrayItem] = useState([]);
  const [itemTresLetras, arrayItemTresLetras] = useState([]);

  const getItem = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItem");
      arrayItem(response.data);
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const getItemById = async (idItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemById/${idItem}`,
      );
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };
  const getItemByCodigoItem = async (codigoItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemByCodigoItem/${encodeURIComponent(codigoItem)}`,
      );
      return response.data; // Devuelve los datos para utilizarlos después
    } catch (error) {
      if (error?.response?.status === 404) {
        return null;
      }
      console.error("Error fetching item:", error);
      throw error;
    }
  };

  const getItemByIdentity = async (codigo, descripcion, codigoScanner) => {
    try {
      const params = new URLSearchParams({ codigo, descripcion, codigoScanner });
      const response = await axios.get(`${serverURL}/itemAPI/getItemByIdentity?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error validating item identity:", error);
      return { exists: false, item: null };
    }
  };
 // `signal` (opcional) es un AbortSignal: si el que busca cancela antes de la respuesta, no se
 // pisa itemTresLetras con un resultado viejo y se devuelve null en vez del objeto vacío.
 const getItemTresLetras = async (searchText, { signal } = {}) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemTresLetras?search=${searchText}` /*{
          idUbicacion
        }*/,
        { signal },
      );
      arrayItemTresLetras(response.data.items); // Actualiza la lista de ítems con los resultados de la búsqueda

      // Retornar toda la respuesta para que el frontend pueda acceder a todos los campos
      return {
        items: response.data.items,
        buscadoPorScanner: response.data.buscadoPorScanner,
        buscadoPorBalanza: response.data.buscadoPorBalanza,
        pesoBalanza: response.data.pesoBalanza,
      };
    } catch (error) {
      if (axios.isCancel(error)) return null;
      console.error("Error fetching item:", error);
      return {
        items: [],
        buscadoPorScanner: false,
        buscadoPorBalanza: false,
        pesoBalanza: null,
      };
    }
  };

  // SUGERENCIAS DE CODIGOS DE ITEMS EN CREACION PARA SABER EL CODIGO SIGUIENTE.
  const getItemSuggestions = async (field, search) => {
    try {
      const params = new URLSearchParams({ field, search });
      const response = await axios.get(`${serverURL}/itemAPI/getItemSuggestions?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error("Error obteniendo sugerencias de ítems:", error);
      return { items: [] };
    }
  };

  const postItem = async (
    descripcionItem,
    codigoItem,
    atributos,
    codigoScannerItem,
    pluBalanzaItem = null,
    usaGestionLotes = false,
  ) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/postItem", {
        descripcion: descripcionItem,
        codigo: codigoItem,
        atributos,
        codigoScanner: codigoScannerItem,
        pluBalanza: pluBalanzaItem,
        usaGestionLotes,
      });
      return response; // Retornar la respuesta para usarla en handleItemSubmit
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  // Actualizar el estado (activo/inactivo)
  const getTop10ItemVentas = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTop10ItemVentas/`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al pedir 10 items mas vendidos:", error);
    }
  };

  const getTop3ItemsLast7Days = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getTop10ItemVentas/`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al pedir 10 items mas vendidos:", error);
    }
  };

  // ITEM CREATE ITEM***********************************************************************
  const [itemUbicacion, arrayItemUbicacion] = useState([]);

  const getItemUbicacion = async () => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getItemUbicacion");

      // Accede a la propiedad `data` de la respuesta
      const itemUbicaciones = response.data; // Cambiar aquí para acceder a `data`

      // Formatear el campo updatedAt
      const formattedItemUbicaciones = itemUbicaciones.map((itemUbi) => ({
        ...itemUbi,
        updatedAt: itemUbi.updatedAt
          ? format(new Date(itemUbi.updatedAt), "dd/MM/yyyy")
          : "", // Formato deseado
      }));

      // Aquí asumo que `arrayItemUbicacion` es un setter para el estado
      arrayItemUbicacion(formattedItemUbicaciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching item ubicacion:", error);
    }
  };

  const getDeletedItemUbicacion = async () => {
    try {
      const response = await axios.get(
        serverURL + "/itemAPI/getDeletedItemUbicacion",
      );

      // Accede a la propiedad `data` de la respuesta
      const itemUbicaciones = response.data; // Cambiar aquí para acceder a `data`

      // Formatear el campo updatedAt
      const formattedItemUbicaciones = itemUbicaciones.map((itemUbi) => ({
        ...itemUbi,
        updatedAt: itemUbi.updatedAt
          ? format(new Date(itemUbi.updatedAt), "dd/MM/yyyy")
          : "", // Formato deseado
      }));

      // Aquí asumo que `arrayItemUbicacion` es un setter para el estado
      arrayItemAndItemUbicacion(formattedItemUbicaciones); // Cambiar aquí también
    } catch (error) {
      console.error("Error fetching item ubicacion:", error);
    }
  };

  const postItemUbicacion = async (
    idItem,
    idUbicacion,
    inventario,
    stockMinimoItem,
  ) => {
    try {
      await axios.post(serverURL + "/itemAPI/postItemUbicacion", {
        idItem: idItem,
        idUbicacion: idUbicacion,
        inventario: inventario,
        stockMinimo: stockMinimoItem,
      });
      getItemUbicacion();
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  const getRecetas = async (
    startDate,
    endDate,
    idReceta,
    idMateriaPrima,
    page,
    limit,
  ) => {
    try {
      const response = await axios.get(serverURL + "/itemAPI/getRecetas", {
        params: {
          startDate: startDate,
          endDate: endDate,
          idReceta: idReceta,
          idMateriaPrima: idMateriaPrima,
          page: page,
          limit: limit, // Puedes ajustar la página según sea necesario
        },
      });
      return response.data; // Devuelve los datos de las recetas
    } catch (error) {
      console.error("Error al obtener recetas:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const crearRecetaApi = async (
    idProductoTerminado,
    ingredientes,
    existeReceta,
  ) => {
    try {
      const response = await axios.post(serverURL + "/itemAPI/crearReceta", {
        idProductoTerminado,
        ingredientes,
        existeReceta,
      });
      console.log("Receta creada exitosamente:", response.data);
      return response.data; // Retorna la receta creada
    } catch (error) {
      console.error("Error al crear receta:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const getBomByIdItem = async (idItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getBomByIdItem/${idItem}`,
      );
      return response.data; // Devuelve los datos de la receta
    } catch (error) {
      console.error("Error al obtener receta:", error);
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const getCanalEntidad = async () => {
    try {
      const response = await axios.get(serverURL + "/adminAPI/getCanalEntidad");
      return response.data;
    } catch (error) {
      console.error("Error fetching canal entidad:", error);
    }
  };

  const postListaMonto = async (
    newItemId,
    idUbicacion,
    entidad,
    precio_costo,
    margenGanancia = null,
    esProveedorReferente = false,
  ) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postListaMonto", {
        newItemId,
        idUbicacion,
        entidad,
        precio_costo,
        margenGanancia,
        esProveedorReferente,
      });
    } catch (error) {
      console.error("Error creating item:", error);
    }
  };

  const getTransaccionItemID = async (transaccionId, mostrarEliminados = false) => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionItemID/${transaccionId}`,
        { params: { mostrarEliminados } } // ✅ Pasar parámetro para filtrar eliminados 
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const getTransaccionItemIDEnCompras = async (transaccionId) => {
    try {
      const response = await axios.get(
        serverURL +
          `/transaccionAPI/getTransaccionItemIDEnCompras/${transaccionId}`,
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const updateTransaccionCompraItem = async (
    transaccionId,
    idItem,
    cantidadRecibida,
  ) => {
    try {
      const response = await axios.put(
        serverURL + `/transaccionAPI/updateTransaccionCompraItem/`,
        {
          transaccionId,
          idItem,
          cantidadRecibida,
        },
      ); // Ajusta la URL según tu API
      return response.data; // Suponiendo que esto retorna un arreglo de ítems de la transacción
    } catch (error) {
      console.error("Error al obtener los ítems de la transacción:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const updateItemUbicacion = async (
    idItem,
    idUbicacion,
    inventarioItem,
    proviene, // Nueva variable
  ) => {
    // console.log(idItem, idUbicacion, inventarioItem, precioItem, proviene);

    try {
      await axios.put(serverURL + "/itemAPI/putItemUbicacion", {
        idItem: idItem,
        idUbicacion: idUbicacion,
        inventario: inventarioItem,
        proviene: proviene, // Enviamos 'proviene' al backend
      });
    } catch (error) {
      console.error("Error updating item:", error);
    }
  };

  // ITEM FILTER ITEM UBICACION *********************************************
  const [itemUbicacionFilter, arrayItemUbicacionFilter] = useState([]);

  const getItemUbicacionFilter = async (itemID) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemUbicacionFilter/${itemID}`,
      ); // Ajusta la URL según tu API

      arrayItemUbicacionFilter(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los ítems ubicacion:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  const getItemUbicacionFilterByUbicacion = async (itemID, ubicacionID) => {
    try {
      const response = await axios.get(
        serverURL +
          `/itemAPI/getItemUbicacionFilterByUbicacion/${itemID}/${ubicacionID}`,
      ); // Ajusta la URL según tu API

      arrayItemUbicacionFilter(response.data);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los ítems ubicacion:", error);
      return []; // Retorna un arreglo vacío en caso de error
    }
  };

  // Función para actualizar un item
  const updateItem = async (
    itemId,
    descripcion,
    codigo,
    codigoScannerItem,
    atributos,
    eliminado,
    pluBalanzaItem,
    usaGestionLotes,
  ) => {
    try {
      const payload = {
        descripcion,
        codigo,
        codigoScannerItem,
        atributos,
        eliminado,
      };

      if (pluBalanzaItem !== undefined) {
        payload.pluBalanza = pluBalanzaItem;
      }

      if (usaGestionLotes !== undefined) {
        payload.usaGestionLotes = usaGestionLotes;
      }

      const response = await axios.put(
        serverURL + `/itemAPI/itemsUpdate/${itemId}`,
        payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar el item:", error);
      throw error;
    }
  };

  // Función para actualizar las ubicaciones asociadas a un item
  const updateItemUbicaciones = async (itemId, ubicacionesData) => {
    try {
      const response = await axios.put(
        serverURL + `/itemAPI/itemUbicacionUpdate/${itemId}`,
        {
          ubicaciones: ubicacionesData,
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar las ubicaciones del item:", error);
      throw error;
    }
  };

  // === FUNCIONES PARA ELIMINACIÓN MASIVA ===
  
  /**
   * Actualizar el estado eliminado de un itemUbicacion específico
   * @param {number} itemUbicacionId - ID del itemUbicacion
   * @param {boolean} eliminado - Nuevo estado eliminado
   */
  const updateItemUbicacionEliminado = async (itemUbicacionId, eliminado) => {
    try {
      console.log(`🔄 Actualizando itemUbicacion ${itemUbicacionId} a eliminado=${eliminado}`);
      const response = await axios.put(
        serverURL + `/itemAPI/itemUbicacion/${itemUbicacionId}/eliminado`,
        { eliminado }
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error al actualizar itemUbicacion:", error);
      throw error;
    }
  };

  /**
   * Obtener todas las itemUbicaciones de un item específico
   * @param {number} itemId - ID del item
   */
  const getItemUbicacionesByItemId = async (itemId) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/itemUbicaciones/byItem/${itemId}`
      );
      return response.data;
    } catch (error) {
      console.error("❌ Error al obtener itemUbicaciones:", error);
      throw error;
    }
  };

  /**
   * Eliminar múltiples items en lote (soft delete)
   * @param {number[]} itemIds - Array de IDs de items a eliminar
   * @param {number|null} ubicacionId - ID de ubicación (opcional)
   * Si ubicacionId existe: solo elimina itemUbicacion específico
   * Si ubicacionId es null: elimina item completo y todas sus ubicaciones
   */
  const bulkDeleteItems = async (itemIds, ubicacionId = null) => {
    try {
      console.log(`🗑️ Eliminando items: ${itemIds.length} items, ubicación: ${ubicacionId || 'todas'}`);
      
      const response = await axios.post(
        serverURL + `/itemAPI/items/bulk-delete`,
        { itemIds, ubicacionId }
      );
      
      console.log(`✅ Eliminación completada:`, response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Error al eliminar items en lote:", error);
      throw error;
    }
  };

  // IMPUESTOS ***********************************************************************

  const updateIncluirImpuestos = async (dato) => {
    try {
      const response = await axios.put(
        serverURL + `/adminAPI/updateIncluirImpuestos/${dato}`,
      );
      return response.data;
    } catch (error) {}
  };

  const getIncluirImpuestos = async () => {
    try {
      const response = await axios.get(
        serverURL + `/adminAPI/getIncluirImpuestos`,
      );
      return response.data; // Cambiar aquí para acceder a `data`
    } catch (error) {}
  };

  const [impuestos, arrayImpuestos] = useState([]);

  const getImpuestos = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getImpuestos",
      );
      arrayImpuestos(response.data);
    } catch (error) {
      console.error("Error fetching impuestos:", error);
    }
  };

  const postImpuestos = async (descripcionImpuesto, porcentajeImpuesto) => {
    try {
      await axios.post(serverURL + "/transaccionAPI/postImpuestos", {
        descripcion: descripcionImpuesto,
        porcentaje: porcentajeImpuesto,
        incluidoEnPrecio: true, // Incluir en precio por defecto va true por el momento por la logica que agregamos a ultimo momento
      });
      getImpuestos();
    } catch (error) {
      console.error("Error creating impuestos:", error);
    }
  };

  const postTransaccionImpuesto = async (
    idTransaccion,
    idImpuesto,
    porcentajeImpuesto,
    montoImpuesto,
  ) => {
    try {
      // console.log("Enviando datos a postTransaccionImpuesto:", {
      //   idTransaccion,
      //   idImpuesto,
      //   porcentajeImpuesto,
      // });
      await axios.post(serverURL + "/transaccionAPI/postTransaccionImpuesto", {
        idTransaccion: idTransaccion,
        idImpuesto: Number(idImpuesto),
        porcentaje: porcentajeImpuesto,
        montoTotal: montoImpuesto,
      });
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const [tiposFacturas, arrayTiposFacturas] = useState([]);

  const getTiposFacturas = async () => {
    try {
      const response = await axios.get(
        serverURL + "/transaccionAPI/getTiposFacturas",
      );
      arrayTiposFacturas(response.data);
    } catch (error) {
      console.error("Error fetching tipo facturas:", error);
    }
  };

  // PUNTOS DE VENTA AFIP ************************************************************************************
  // Consulta los puntos de venta habilitados para WSFE.
  // Lee de cache (parametrosGlobales) si existe. Con refresh=true fuerza re-consulta a AFIP (1 request).
  const getAfipSalesPoints = async (refresh = false) => {
    try {
      const url = refresh
        ? serverURL + "/api/afip/sales-points?refresh=true"
        : serverURL + "/api/afip/sales-points";
      const response = await axios.get(url);
      return response.data; // { success, salesPoints: [...], cached: bool }
    } catch (error) {
      console.error("Error fetching AFIP sales points:", error);
      throw error;
    }
  };

  // Crea un punto de venta en ARCA via automation (consume automations del plan AFIP SDK)
  // El backend calcula automáticamente el próximo número disponible
  const createAfipSalesPoint = async (nombreFantasia) => {
    try {
      const response = await axios.post(serverURL + "/api/afip/create-sales-point", {
        nombreFantasia,
      });
      return response.data; // { success, numero, result: { id, status, data } }
    } catch (error) {
      console.error("Error creating AFIP sales point:", error);
      throw error;
    }
  };

  const postTransaccionTipoFactura = async (
    idTipoFactura,
    idTransaccion,
    CAE,
    vencimientoCAE,
    idCondicionIva,
    numeroFactura,
    puntoVenta,
    fechaEmision,
  ) => {
    try {
      await axios.post(
        serverURL + "/transaccionAPI/postTransaccionTipoFactura",
        {
          idTipoFactura: idTipoFactura,
          idTransaccion: idTransaccion,
          CAE: CAE,
          vencimientoCAE: vencimientoCAE,
          idCondicionIva: idCondicionIva,
          numeroFactura: numeroFactura,
          puntoVenta: puntoVenta,
          fechaEmision: fechaEmision,
        },
      );
      getTiposFacturas();
    } catch (error) {
      console.error("Error creating impuestos:", error);
    }
  };

  // Función para verificar si una transacción fue facturada y obtener datos de la factura original
  const getTransaccionFacturadaData = async (idTransaccion) => {
    try {
      const response = await axios.get(
        serverURL + `/transaccionAPI/getTransaccionFacturadaData/${idTransaccion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al verificar datos de facturación:", error);
      throw error;
    }
  };

  // Función para generar nota de crédito en AFIP
  const generarNotaCredito = async (datosFacturaOriginal, datosDevolucion, entidadCliente) => {
    try {

      // VALIDACIÓN 2: Verificar que la transacción original fue facturada
      if (!datosFacturaOriginal.tipoFacturaAFIP) {
        throw new Error("La transacción original no fue facturada, no se requiere Nota de Crédito");
      }

      // Mapear el tipo de factura original al tipo de nota de crédito correspondiente
      let tipoNotaCredito = null;
      if (datosFacturaOriginal.tipoFacturaAFIP === 1) {
        tipoNotaCredito = 3; // Nota de Crédito A
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 6) {
        tipoNotaCredito = 8; // Nota de Crédito B
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 11) {
        tipoNotaCredito = 13; // Nota de Crédito C
      } else if (datosFacturaOriginal.tipoFacturaAFIP === 51) {
        tipoNotaCredito = 53; // Nota de Crédito M
      }

      if (!tipoNotaCredito) {
        throw new Error("No se pudo determinar el tipo de nota de crédito");
      }

      // LÓGICA DE DocTipo/DocNro según tipo de factura y longitud de documento
      let docTipo = 99; // Por defecto: Consumidor Final
      let docNro = 0;
      
      const documentoCliente = entidadCliente.dniCuitCuil || '';
      const documentoLimpio = documentoCliente ? String(documentoCliente).replace(/\D/g, '') : '';
      const documentoNumerico = documentoLimpio ? Number(documentoLimpio) : 0;
      const tipoFacturaOriginalId = datosFacturaOriginal.tipoFacturaAFIP;

      if (tipoFacturaOriginalId === 1) {
        // Factura A -> NC A: siempre requiere CUIT
        if (documentoLimpio.length === 11 && documentoNumerico > 0) {
          docTipo = 80; // CUIT
          docNro = documentoNumerico;
        } else {
          throw new Error("Nota de Crédito A requiere CUIT de 11 dígitos");
        }
      } else if (tipoFacturaOriginalId === 6) {
        // Factura B -> NC B: lógica según longitud del documento
        if (documentoLimpio.length === 11 && documentoNumerico > 0) {
          docTipo = 80; // CUIT
          docNro = documentoNumerico;
        } else if (documentoLimpio.length >= 7 && documentoNumerico > 0) {
          docTipo = 96; // DNI
          docNro = documentoNumerico;
        } else {
          // Sin documento válido, usar Consumidor Final
          docTipo = 99;
          docNro = 0;
        }
      } else if (tipoFacturaOriginalId === 11) {
        // Factura C -> NC C: siempre Consumidor Final
        docTipo = 99;
        docNro = 0;
      }

      // CÁLCULO DE IVA DETALLADO (igual que en GestionGenerarVentaComponent)
      const ivaAFIP = getIvaAFIP();
      const gruposIva = {};
      let impNetoTotal = 0;
      let impIVATotal = 0;

      // Solo procesar items con cantidad > 0 (items devueltos)
      const itemsDevueltos = datosDevolucion.items.filter(item => item.cantidad > 0);

      if (itemsDevueltos.length === 0) {
        throw new Error("No hay items con cantidad > 0 para devolver");
      }

      // Agrupar items por alícuota de IVA
      itemsDevueltos.forEach(item => {
        let porcentajeIva = 21; // Default

        if (item.impuestoData && item.impuestoData.porcentaje !== undefined) {
          porcentajeIva = item.impuestoData.porcentaje;
        } else if (item.ivaPercentage !== undefined) {
          porcentajeIva = item.ivaPercentage;
        }

        // Encontrar el ID de AFIP correspondiente al porcentaje
        const ivaAFIPEncontrado = ivaAFIP.find(iva => Math.abs(iva.porcentaje - porcentajeIva) < 0.01);
        const idAFIP = ivaAFIPEncontrado ? ivaAFIPEncontrado.ivaAFIP : 5; // Default a 21%

        if (!gruposIva[idAFIP]) {
          gruposIva[idAFIP] = {
            id: idAFIP,
            porcentaje: porcentajeIva,
            baseImponible: 0,
            importeIva: 0,
            items: []
          };
        }

        // Calcular importes del item (siempre positivos para NC)
        const importeItem = Math.abs(item.importe || (item.cantidad * item.precio));
        const baseImponibleItem = Math.abs(importeItem / (1 + porcentajeIva / 100));
        const ivaItem = Math.abs(importeItem - baseImponibleItem);

        gruposIva[idAFIP].baseImponible += baseImponibleItem;
        gruposIva[idAFIP].importeIva += ivaItem;
        gruposIva[idAFIP].items.push({
          ...item,
          baseImponibleItem,
          ivaItem,
          importeItem
        });

        impNetoTotal += baseImponibleItem;
        impIVATotal += ivaItem;
      });

      // Convertir a array para AFIP (solo si hay IVA)
      const ivaArray = tipoNotaCredito !== 13 ? Object.values(gruposIva).map(grupo => ({
        Id: grupo.id,
        BaseImp: Number.parseFloat(grupo.baseImponible.toFixed(2)),
        Importe: Number.parseFloat(grupo.importeIva.toFixed(2))
      })) : [];

      const impTotal = Number.parseFloat((impNetoTotal + impIVATotal).toFixed(2));

      // Preparar los datos para la nota de crédito
      const notaCreditoData = {
        PtoVta: datosFacturaOriginal.ptoVta,
        CbteTipo: tipoNotaCredito,
        Concepto: 1, // Productos y Servicios
        DocTipo: docTipo,
        DocNro: docNro,
        CbteFch: dayjs().format('YYYYMMDD'),
        ImpTotal: impTotal, // Importe siempre positivo
        ImpTotConc: 0,
        ImpNeto: Number.parseFloat(impNetoTotal.toFixed(2)), // Importe siempre positivo
        ImpOpEx: 0,
        ImpIVA: Number.parseFloat(impIVATotal.toFixed(2)), // Importe siempre positivo
        ImpTrib: 0,
        MonId: 'PES',
        MonCotiz: 1,
        CondicionIVAReceptorId: datosDevolucion.condicionIVA || 5,
        Iva: ivaArray, // Array de IVA con importes positivos calculados correctamente
        ItemsList: itemsDevueltos, // Solo items con cantidad > 0
        DniCuitCliente: docTipo === 99 ? '' : documentoLimpio,
        ApellidoNombre: entidadCliente.descripcion || 'Consumidor Final',
        direccionCliente: datosDevolucion.direccionCliente || entidadCliente.direccion || '',
        condicionVenta: datosDevolucion.condicionVenta || 'CONTADO',
        condicionIvaCliente: entidadCliente.condicionIvaDescripcion || datosDevolucion.condicionIvaDescripcion || datosDevolucion.condicionIVA || datosDevolucion.CondicionIVAReceptorDescripcion,
        telefonoCliente: datosDevolucion.telefonoCliente || entidadCliente.telefono || '',
        emailCliente: datosDevolucion.emailCliente || entidadCliente.email || '',
        localidadCliente: datosDevolucion.localidadCliente || '',
        provinciaCliente: datosDevolucion.provinciaCliente || '',
        abrirPDF: false,
        // Campos para asociación a factura original (para el endpoint)
        tipoFacturaOriginal: datosFacturaOriginal.tipoFacturaAFIP,
        ptoVtaOriginal: datosFacturaOriginal.ptoVta,
        nroFacturaOriginal: datosFacturaOriginal.nroFactura
      };

      console.log("Datos de la nota de crédito:", notaCreditoData);

      // Enviar a AFIP
      const response = await axios.post(serverURL + "/api/afip/credit-note", notaCreditoData);
      
      if (response.data && response.data.cae) {
        console.log("Nota de crédito generada exitosamente:", response.data);
        
        // ✅ Guardar información de la Nota de Crédito en TransaccionTipoFactura
        try {
          // Determinar el idTipoFactura para la nota de crédito
          let idTipoFacturaNC = null;
          if (tipoNotaCredito === 3) {
            idTipoFacturaNC = 1; // Nota de Crédito A
          } else if (tipoNotaCredito === 8) {
            idTipoFacturaNC = 2; // Nota de Crédito B  
          } else if (tipoNotaCredito === 13) {
            idTipoFacturaNC = 3; // Nota de Crédito C
          } else if (tipoNotaCredito === 53) {
            idTipoFacturaNC = 7; // Nota de Crédito M
          }

          if (idTipoFacturaNC && datosDevolucion.idTransaccion) {
            console.log("Guardando información de Nota de Crédito en TransaccionTipoFactura");
            console.log("idTipoFacturaNC:", idTipoFacturaNC);
            console.log("datosDevolucion.idTransaccion:", datosDevolucion.idTransaccion);
            console.log("response.data.cae:", response.data.cae);
            console.log("response.data.vto:", response.data.vto);
            console.log("datosDevolucion.condicionIVA:", datosDevolucion.condicionIVA);
            console.log("response.data.cbteNro:", response.data.cbteNro);
            await postTransaccionTipoFactura(
              idTipoFacturaNC,
              datosDevolucion.idTransaccion, // ID de la transacción de devolución
              response.data.cae,
              response.data.vto,
              datosDevolucion.condicionIVA || 5,
              response.data.cbteNro,
              notaCreditoData.PtoVta,
              response.data.fechaEmision || notaCreditoData.CbteFch,
            );
            console.log("Información de Nota de Crédito guardada en TransaccionTipoFactura");
          } else {
            console.warn("No se pudo determinar idTipoFactura para NC o falta idTransaccion");
          }
        } catch (saveError) {
          console.error("Error al guardar información de NC en TransaccionTipoFactura:", saveError);
          // No fallar la operación principal si hay error en el guardado
        }
        
              // Generar y guardar PDF de la Nota de Cr�dito
              try {
                const idTransaccionDevolucion = datosDevolucion.idTransaccion || Date.now();
                await abrirNotaCreditoAfip(response.data, notaCreditoData, idTransaccionDevolucion);
                console.log("PDF de Nota de Cr�dito generado y abierto exitosamente");
              } catch (pdfError) {
                console.error("Error al generar PDF de Nota de Cr�dito:", pdfError);
                // No fallar la operaci�n principal si hay error en el PDF
              }
        
        return response.data;
      } else {
        throw new Error("No se recibió CAE de AFIP");
      }

    } catch (error) {
      console.error("Error al generar nota de crédito:", error);
      throw error;
    }
  };


  // Función para guardar comprobantes
  const guardarComprobante = async (idFactura, pdfBase64, tipo) => {
    try {
      const response = await axios.post(
        serverURL + "/transaccionAPI/guardarComprobante",
        { idFactura, pdfBase64, tipo }
      );
      return response.data;
    } catch (error) {
      console.error("Error guardando comprobante:", error);
      throw error;
    }
  };

  // Función para generar PDF AFIP de Nota de Crédito (reutilizando abrirFacturaHtml)
  const abrirNotaCreditoAfip = async (datosNC, payloadNC, idTransaccionDevolucion) => {
    try {
      // Importar dinámicamente las funciones de facturaAfipHtmlGenerator
      const { abrirFacturaPdf, generarFacturaPdfBlob } = await import('./facturaAfipHtmlGenerator.js');
      
      // Generar el PDF usando la lógica existente pero con datos de NC
      const blob = await generarFacturaPdfBlob(datosNC, payloadNC, getParametrosGlobales);
      
      // Convertir blob a base64 para guardar
      const pdfDataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
      
      // Guardar en carpeta devoluciones como notaCredito
      await guardarComprobante(idTransaccionDevolucion, pdfDataUrl, 'notaCredito');
      
      // Abrir el PDF (igual que abrirFacturaPdf)
      await abrirFacturaPdf(datosNC, payloadNC, getParametrosGlobales);
      
      return { success: true, pdfDataUrl };
    } catch (error) {
      console.error("Error generando PDF AFIP de Nota de Crédito:", error);
      throw error;
    }
  };

  // item proveedor ***********************************************************************

  const postItemProveedor = async (idItem, idEntidad, costo) => {
    try {
      await axios.post(serverURL + "/itemAPI/postItemProveedor", {
        idItem: idItem,
        idEntidad: idEntidad,
        costo: costo,
      });
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const getItemProveedor = async (idItem, idEntidad) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/getItemProveedor/${idItem}/${idEntidad}`,
      );
      return response.data; // Verifica que la respuesta esté correctamente formateada
    } catch (error) {
      console.error("Error al obtener el item proveedor:", error);
      return null; // En caso de error, retorna null para que el código sepa que no existe
    }
  };

  const updateItemProveedor = async (idItem, idEntidad, costo) => {
    try {
      await axios.put(
        serverURL + `/itemAPI/uptdateItemProveedor/${idItem}/${idEntidad}`,
        {
          costo: costo,
        },
      );
    } catch (error) {
      console.error("Error creating transaccion impuestos:", error);
    }
  };

  const updateItemPrecioListaId = async (
    idItem,
    idEntidad,
    idUbicacion,
    monto,
    tipoAjuste,
  ) => {
    // console.log("Datos enviados:", idItem, idEntidad, idUbicacion, monto, tipoAjuste);
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateItemPrecioListaId`,
        {
          idItem,
          idEntidad,
          idUbicacion,
          monto, // Valor ingresado en el campo
          tipoAjuste,
        },
      );
    } catch (error) {
      console.error("Error al crear el registro:", error);
      alert("Hubo un error al crear el registro.");
    }
  };

  const updatePreciosListaMultiple = async (idEntidades, monto, tipoAjuste, filtros = null) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updatePreciosListaMultiple`,
        {
          idEntidades,
          monto,
          tipoAjuste,
          filtros, // Pasar filtros al backend
        },
      );

      // console.log("Nuevos registros creados:", response.data);
      const mensaje = filtros?.hayFiltrosActivos
        ? `Se actualizaron los precios de los productos filtrados para ${idEntidades.length} entidades.`
        : `Se actualizaron los precios de TODOS los productos para ${idEntidades.length} entidades.`;
      alert(mensaje);
    } catch (error) {
      console.error("Error al actualizar los precios:", error);
      alert("Hubo un error al actualizar los precios.");
    }
  };

  const updateAllPrices = async (tipoAjuste, valor) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateAllPrices`,
        {
          tipoAjuste, // "porcentaje" o "valor"
          valor, // Valor ingresado en el campo
        },
      );

      // console.log("Precios actualizados:", response.data);
      alert("Todos los precios han sido actualizados correctamente.");
    } catch (error) {
      console.error("Error al actualizar los precios:", error);
      alert("Hubo un error al actualizar los precios.");
    }
  };

  // Nueva función para actualizar precios respetando filtros actuales
  const updateFilteredPrices = async (
    tipoAjuste, 
    valor, 
    idEntidad, 
    idItem, 
    idUbicacion, 
    idTipoEntidad, 
    soloUltimos, 
    searchText, 
    incluirItemsSinPrecio,
    filtrosAtributos = {},
    actualizarPrecios = false,
    idEntidadesCliente = [],
    soloProveedoresReferentes = false
    ) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateFilteredPrices`,
        {
          tipoAjuste,
          valor,
          idEntidad,
          idItem,
          idUbicacion,
          idTipoEntidad,
          soloUltimos: soloUltimos ? "true" : "false",
          searchText,
          incluirItemsSinPrecio: incluirItemsSinPrecio ? "true" : "false",
          filtrosAtributos,
          actualizarPrecios,
          idEntidadesCliente,
          soloProveedoresReferentes,
        },
      );

      console.log("Precios filtrados actualizados:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error al actualizar los precios filtrados:", error);
      throw error;
    }
  };

  const updateMargenGananciaListaId = async (idItem, idEntidad, idUbicacion, margenGanancia) => {
    try {
      await axios.post(`${serverURL}/transaccionAPI/updateMargenGananciaListaId`, {
        idItem,
        idEntidad,
        idUbicacion,
        margenGanancia,
      });
    } catch (error) {
      console.error("Error al actualizar margenGanancia:", error);
      alert("Hubo un error al actualizar el margen.");
    }
  };

  const updateMargenGananciaFiltrado = async (margenGanancia, tipoAjusteMargen, filtros = {}, actualizarPrecios = false, idEntidadesCliente = []) => {
    try {
      const response = await axios.post(`${serverURL}/transaccionAPI/updateMargenGananciaFiltrado`, {
        margenGanancia,
        tipoAjusteMargen,
        ...filtros,
        actualizarPrecios,
        idEntidadesCliente,
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar margenGanancia filtrado:", error);
      throw error;
    }
  };

  const getClientesConPreciosByFiltros = async (filtros = {}) => {
    try {
      const params = {};
      if (filtros.idEntidad && filtros.idEntidad !== "null") params.idEntidad = filtros.idEntidad;
      if (filtros.idItem && filtros.idItem !== "null") params.idItem = filtros.idItem;
      if (filtros.idUbicacion && filtros.idUbicacion !== "null") params.idUbicacion = filtros.idUbicacion;
      if (filtros.idTipoEntidad && filtros.idTipoEntidad !== "null") params.idTipoEntidad = filtros.idTipoEntidad;
      if (filtros.soloUltimos !== undefined) params.soloUltimos = filtros.soloUltimos;
      if (filtros.searchText) params.searchText = filtros.searchText;
      if (filtros.filtrosAtributos) params.filtrosAtributos = JSON.stringify(filtros.filtrosAtributos);
      const response = await axios.get(`${serverURL}/transaccionAPI/getClientesConPreciosByFiltros`, { params });
      return response.data.clientes || [];
    } catch (error) {
      console.error("Error al obtener clientes con precios:", error);
      return [];
    }
  };

  const promoverProveedorReferente = async (idItem, idEntidad, idUbicacion, monto, tipoAjuste, margenGanancia, idEntidadesCliente = []) => {
    try {
      const response = await axios.post(`${serverURL}/transaccionAPI/promoverProveedorReferente`, {
        idItem,
        idEntidad,
        idUbicacion,
        monto,
        tipoAjuste,
        margenGanancia,
        idEntidadesCliente,
      });
      return response.data;
    } catch (error) {
      console.error("Error al promover proveedor referente:", error);
      throw error;
    }
  };

  const actualizarPreciosClientesDesdeReferente = async (idItem, idEntidad, idUbicacion, idEntidadesCliente) => {
    try {
      const response = await axios.post(`${serverURL}/transaccionAPI/actualizarPreciosClientesDesdeReferente`, {
        idItem,
        idEntidad,
        idUbicacion,
        idEntidadesCliente,
      });
      return response.data;
    } catch (error) {
      console.error("Error al actualizar precios de clientes desde referente:", error);
      throw error;
    }
  };

  const copiarPreciosEntreEntidades = async (idCopiar, idPegar) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/copiarPreciosEntreEntidades`,
        {
          idCopiar,
          idPegar,
        },
      );
      // console.log("Precios copiados:", response.data);
      const { message, entidadesAfectadas, preciosPorEntidad } = response.data;
      alert(
        message || 
        `Los precios han sido copiados correctamente a ${entidadesAfectadas} ${entidadesAfectadas === 1 ? 'entidad' : 'entidades'} (${preciosPorEntidad} precios por entidad).`
      );
    } catch (error) {
      console.error("Error al copiar los precios:", error);
      alert("Hubo un error al copiar los precios.");
    }
  };

  // Función para obtener los ítems del proveedor
  const getListaMontosByEntidad = async (
    idEntidad,
    idItem,
    idUbicacion,
    idTipoEntidad,
    page,
    limit,
    soloUltimos,
    searchText, // Nuevo parámetro para búsqueda múltiple
    incluirItemsSinPrecio = false, // Nuevo parámetro para incluir items sin precio
    filtrosAtributos = {}, // NUEVO: Filtros por atributos dinámicos
  ) => {
    try {
      // Realizamos la petición GET para obtener los ítems asociados a ese proveedor
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByEntidad`,
        {
          params: {
            idEntidad: idEntidad || null,
            idItem: idItem || null,
            idUbicacion: idUbicacion || null,
            idTipoEntidad,
            page,
            limit,
            soloUltimos: soloUltimos ? "true" : "false",
            searchText: searchText || null, // Agregar parámetro de búsqueda
            incluirItemsSinPrecio: incluirItemsSinPrecio ? "true" : "false", // Nuevo parámetro
            filtrosAtributos: JSON.stringify(filtrosAtributos), // NUEVO: Enviar filtros de atributos como JSON
          },
        },
      );
      return response.data; // Devuelve los ítems encontrados
    } catch (error) {
      console.error("Error al obtener los ítems del proveedor:", error);
      return [];
    }
  };

  // Función para obtener entidades únicas basadas en filtros actuales
  const getEntidadesUnicasByFilters = async (
    idEntidad,
    idItem,
    idUbicacion,
    idTipoEntidad,
    soloUltimos,
    searchText,
    incluirItemsSinPrecio = false,
    filtrosAtributos = {},
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getEntidadesUnicasByFilters`,
        {
          params: {
            idEntidad: idEntidad || null,
            idItem: idItem || null,
            idUbicacion: idUbicacion || null,
            idTipoEntidad,
            soloUltimos: soloUltimos ? "true" : "false",
            searchText: searchText || null,
            incluirItemsSinPrecio: incluirItemsSinPrecio ? "true" : "false",
            filtrosAtributos: JSON.stringify(filtrosAtributos),
          },
        },
      );
      return response.data.entidades || []; // Devuelve las entidades únicas
    } catch (error) {
      console.error("Error al obtener entidades únicas:", error);
      return [];
    }
  };

  // Función para obtener valores únicos de un atributo específico
  const getValoresUnicosAtributo = async (campo, searchText = "") => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getValoresUnicosAtributo`,
        {
          params: {
            campo: campo,
            searchText: searchText || null,
          },
        },
      );
      return response.data.valores || []; // Devuelve los valores únicos del atributo
    } catch (error) {
      console.error(`Error al obtener valores únicos del atributo ${campo}:`, error);
      return [];
    }
  };

  // Función para obtener valores únicos de atributo ordenados por recencia (últimos ítems creados)
  const getValoresUnicosAtributoRecientes = async (campo, searchText = "", limit = 10) => {
    try {
      const response = await axios.get(
        `${serverURL}/itemDomain/getValoresUnicosAtributoRecientes`,
        {
          params: { campo, searchText: searchText || null, limit },
          withCredentials: true,
        },
      );
      return response.data?.valores ?? [];
    } catch (error) {
      console.error(`Error al obtener valores recientes del atributo ${campo}:`, error);
      return [];
    }
  };

  const getListaMontosByIdItem = async (idItem) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByIdItem`,
        {
          params: { idItem: idItem || null }, // Enviar como Query Param
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener las listas de montos:", error);
      return [];
    }
  };

  const getListaMontosByIdItemIdEntidad = async (
    idEntidad,
    idItem,
    idUbicacion,
  ) => {
    try {
      const response = await axios.get(
        `${serverURL}/transaccionAPI/getListaMontosByIdItemIdEntidad`,
        {
          params: { idEntidad, idItem, idUbicacion }, // Enviar como Query Param
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener las listas de montos:", error);
      return [];
    }
  };

  const updateListaDeMonto = async ({
    idItem,
    idUbicacion,
    idEntidad,
    monto,
  }) => {
    try {
      // console.log(idItem, idUbicacion, idEntidad, monto)
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateListaDeMonto`,
        {
          idItem,
          idUbicacion,
          idEntidad,
          monto,
        },
      );
      // console.log("Respuesta del nuevo registro:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error al crear la lista de montos:", error);
      throw error;
    }
  };

  // Actualizar múltiples precios en batch para mejor performance
  const updateListaDeMontoBatch = async (updates) => {
    try {
      const response = await axios.post(
        `${serverURL}/transaccionAPI/updateListaDeMontoBatch`,
        { updates }
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar lista de montos en batch:", error);
      throw error;
    }
  };

  const getCajaByMedioDePago = async ({
    startDate,
    endDate,
    medioDePagoId,
    tipoMedioDePagoId,
    ubicacionId,
    ubicacionIds,
    tiposTransaccionIds,
    entidadesIds,
    itemUbicacionPairs,
  }) => {
    try {
      // ✅ Serializar Date objects a ISO strings manualmente para query params
      // Axios no serializa Date objects correctamente en query params
      const params = {
        startDate: startDate instanceof Date ? startDate.toISOString() : startDate,
        endDate: endDate instanceof Date ? endDate.toISOString() : endDate,
        medioDePagoId,
        tipoMedioDePagoId,
      };

      // Ubicación: soporta ubicacionId (single) o ubicacionIds (multiple)
      if (ubicacionIds && ubicacionIds.length > 0) {
        params.ubicacionIds = ubicacionIds.join(',');
      } else if (ubicacionId != null) {
        params.ubicacionId = ubicacionId;
      }

      // Agregar filtros opcionales solo si tienen valores
      if (tiposTransaccionIds && tiposTransaccionIds.length > 0) {
        params.tiposTransaccionIds = tiposTransaccionIds.join(',');
      }
      if (entidadesIds && entidadesIds.length > 0) {
        params.entidadesIds = entidadesIds.join(',');
      }
      if (itemUbicacionPairs && String(itemUbicacionPairs).trim() !== '') {
        params.itemUbicacionPairs = itemUbicacionPairs;
      }

      const data = await axios.get(
        `${serverURL}/transaccionAPI/getCajaByMedioDePago`,
        { params },
      );
      return data; // { movimientos, caja }
    } catch (error) {
      console.error("Error al obtener análisis financiero:", error);
      throw error;
    }
  };

  // Actualizar el estado (activo/inactivo)
  const updateImpuestoEstado = async (impuestosEliminados) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateImpuestoEstado/`,
        {
          impuestosEliminados,
        },
      );
      alert("Estado del impuesto actualizado correctamente.");
      getImpuestos(); // Refrescar la lista
    } catch (error) {
      console.error("Error al actualizar el estado del impuesto:", error);
    }
  };

  // Modificar nombre y porcentaje del impuesto
  const updateImpuestoContenido = async (
    id,
    descripcion,
    porcentaje,
    checkedState,
  ) => {
    try {
      const response = await axios.put(
        `${serverURL}/transaccionAPI/updateImpuestoContenido/${id}`,
        { descripcion, porcentaje, checkedState },
      );
      alert("Impuesto actualizado correctamente.");
      getImpuestos(); // Refrescar la lista
    } catch (error) {
      console.error("Error al actualizar el impuesto:", error);
    }
  };

  // Obtener el impuesto de un item específico
  const getImpuestoItem = async (idItem) => {
    try {
      const response = await axios.get(
        `${serverURL}/itemAPI/getImpuestoItem/${idItem}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener impuesto del item:", error);
      return {
        idItem: parseInt(idItem),
        idImpuesto: null,
        porcentaje: 21,
        descripcionImpuesto: "IVA General",
      };
    }
  };

  // Actualizar el impuesto de un item
  const updateImpuestoItem = async (idItem, idImpuesto, porcentaje) => {
    try {
      const response = await axios.put(
        `${serverURL}/itemAPI/updateImpuestoItem/${idItem}`,
        { idImpuesto, porcentaje },
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar impuesto del item:", error);
      throw error;
    }
  };

  // Obtener todos los impuestos disponibles
  const getImpuestosDisponibles = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/itemAPI/getImpuestosDisponibles`,
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener impuestos disponibles:", error);
      return [];
    }
  };

  const getCondicionIvaByIdEntidad = async (idEntidad) => {
    try {
      console.log("idEntidad ", idEntidad);
      const response = await axios.get(
        `${serverURL}/adminAPI/getCondicionIvaByEntidad/${idEntidad}`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error al obtener condición de IVA por ID de entidad:",
        error,
      );
      return null;
    }
  };

  // Función para obtener los impuestos válidos de AFIP para Argentina
  const getIvaAFIP = () => {
    return [
      {
        id: 1,
        idIva: 1,
        descripcion: "IVA 0%",
        porcentaje: 0,
        ivaAFIP: 3,
      },
      {
        id: 2,
        idIva: 1,
        descripcion: "IVA 10.5%",
        porcentaje: 10.5,
        ivaAFIP: 4,
      },
      {
        id: 3,
        idIva: 1,
        descripcion: "IVA 21%",
        porcentaje: 21,
        ivaAFIP: 5,
      },
      // {
      //   id: 4,
      //   idIva: 1,
      //   descripcion: "IVA 27%",
      //   porcentaje: 27,
      //   ivaAFIP: 6
      // },
      // {
      //   id: 5,
      //   idIva: 1,
      //   descripcion: "IVA 5%",
      //   porcentaje: 5,
      //   ivaAFIP: 8
      // },
      // {
      //   id: 6,
      //   idIva: 1,
      //   descripcion: "IVA 2.5%",
      //   porcentaje: 2.5,
      //   ivaAFIP: 9
      // }
    ];
  };

  // LOGICA NAVBAR ***********************************************************************
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(false); // Estado del tamaño del navbar

  // FACTURA PDF ***********************************************************************

  // Helper function to format numbers in ARS currency format
  const formatARS = (number) => {
    return Number(number).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
    });
  };

  async function enviarFacturaAfip(payload) {
    /*const res = await fetch(serverURL + "/api/afip/invoice", {
    method:  "POST",
    headers: { "Content-Type": "application/json" },
    body:    JSON.stringify(payload),
  });*/
    const res = await axios.post(`${serverURL}/api/afip/invoice`, payload);

    console.log("res AFIP: ", res);
    const data = await res.data;

    // 1) POSTea tu TransaccionTipoFactura
    await postTransaccionTipoFactura(
      payload.idTipoFacturaTransaccion,
      payload.idTransaccion,
      data.cae,
      data.vto,
      payload.idCondicionIva,
      data.cbteNro,
      payload.PtoVta || payload.puntoVenta,
      data.fechaEmision || String(payload.CbteFch),
    );

    console.log("payload:", payload);
    console.log("Factura enviada a AFIP:", data);

    if (payload.abrirPdf === true) {
      try {
        // Generar y abrir el PDF según el tipo de factura
        await abrirFacturaHtml(data, payload, getParametrosGlobales);

        // También abrir el HTML si está disponible
        /*if (data.invoiceHtml) {
        const htmlBlob = new Blob([data.invoiceHtml], { type: "text/html" })
        window.open(URL.createObjectURL(htmlBlob), "_blank")
      }*

      // Si viene PDF del backend, también abrirlo
      /*if (data.invoicePdfBase64) {
        const pdfBytes = Uint8Array.from(atob(data.invoicePdfBase64), (c) => c.charCodeAt(0))
        const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" })
        window.open(URL.createObjectURL(pdfBlob), "_blank")
      }*/
      } catch (error) {
        console.error("Error al generar PDF de factura:", error);
        // Continuar con el flujo normal aunque falle la generación del PDF
      }
    }

    return data;
  }

  const getDescuentoFactor = (item) =>
    1 - (Number(item?.porcentajeDescuento) || 0) / 100;

  const getInteresFactor = (item) =>
    1 + (Number(item?.porcentajeInteres) || 0) / 100;

  const calcularTotalLineaConAjustes = (item, cantidadOverride = null) => {
    const precio = Number(item?.precio) || 0;
    const cantidad =
      cantidadOverride != null
        ? Number(cantidadOverride) || 0
        : Number(item?.cantidad) || 0;

    return precio * cantidad * getDescuentoFactor(item) * getInteresFactor(item);
  };

  // Función para calcular el subtotal con descuento/interés por ítem
  const calcularSubtotal = (items, vieneDe = null) =>
    items.reduce((sum, item) => {
      const cantidad =
        vieneDe == "devolucion"
          ? item.cantidadDevolver || 0
          : item.cantidad || 0;
      return sum + calcularTotalLineaConAjustes(item, cantidad);
    }, 0);

    /**
     * Prefijo de archivo/título del PDF local según origen o tipo de transacción.
     * AFIP usa su propio generador (Factura_/Nota_Credito_).
     */
    const resolverPrefijoPdfComprobante = (transaccionData, deDondeViene) => {
      const origen = (deDondeViene || "").toString().toLowerCase()
      if (origen === "compra") return "Compra"
      if (origen === "presupuesto") return "Presupuesto"
      if (origen === "devolucion") return "Devolucion"
      if (origen === "gasto") return "Gasto"
      if (origen === "venta" || origen === "crearventa") return "Venta"

      const tipoId = Number(
        transaccionData?.idTipoTransaccionID ??
        transaccionData?.idTipoTransaccion ??
        transaccionData?.tipoTransaccion?.id ??
        NaN
      )
      if (tipoId === 2) return "Compra"
      if (tipoId === 5 || tipoId === 9) return "Gasto"
      if (tipoId === 6) return "Devolucion"
      if (tipoId === 3) return "Presupuesto"
      if (tipoId === 1) return "Venta"

      return "Factura"
    }

    const generarFacturaPDF = async (
      transaccionData,
      itemsTransaccion,
      entidades,
      tipoDeFactura,
      impuestos,
      deDondeViene = null,
      returnBase64 = false,
    ) => {
      
      const beigeBackground = [240, 235, 225]
      const darkNavy = [26, 26, 26]
      const orangeAccent = [245, 166, 35]
      const WHITE = [255, 255, 255]
      const TEXT_BLACK = [0, 0, 0]
      const prefijoPdf = resolverPrefijoPdfComprobante(transaccionData, deDondeViene)
      const tituloDocumentoPdf = {
        Compra: "Compra",
        Presupuesto: "Presupuesto",
        Devolucion: "Devolución",
        Gasto: "Gasto",
        Venta: "Venta",
        Factura: "Factura",
      }[prefijoPdf] || "Factura"
      // ===========================================
      // PASO 1: INICIALIZACIÓN Y CONFIGURACIÓN BASE
      // ===========================================
      
      // Crear instancia del documento PDF
      const doc = new jsPDF();
      
      // Obtener dimensiones de la página para cálculos de layout
      const pageWidth  = doc.internal.pageSize.getWidth();   // Ancho total de la página
      const pageHeight = doc.internal.pageSize.getHeight();  // Alto total de la página
    
      // ===========================================
      // PASO 2: OBTENER DATOS EXTERNOS (LOGO Y CONFIGURACIÓN)
      // ===========================================
      
      // Obtener logo de la empresa desde la base de datos
      const logoURLbase64 = await axios.get(serverURL + `/adminAPI/logoURLbase64`);
      console.log("[PDF] logoURLbase64 fetched");
      const logoURLBD = logoURLbase64.data.logoURL.valorParametro;
    
      // Obtener parámetros globales del sistema (dirección, teléfono; leyenda solo en presupuesto)
      const parametrosGlobales = await getParametrosGlobales(
        deDondeViene === "presupuesto"
          ? ["afipsdk_domicilio", "afipsdk_telefono", "leyendaPresupuestoPDF"]
          : ["afipsdk_domicilio", "afipsdk_telefono"],
      );

      // Dirección y teléfono de la SUCURSAL de la transacción si están cargados, sino los
      // globales. Este PDF no es fiscal (factura en negro, presupuesto, remito, gasto), así
      // que puede mostrar los datos del local; el de AFIP con CAE y QR no (ver
      // emisorImpresion.js). Se mantienen los placeholders históricos cuando no hay ningún
      // dato: acá el campo vacío ya imprimía un texto, y cambiarlo sería otro cambio.
      const emisor = await resolverEmisorImpresion(transaccionData?.idUbicacion, parametrosGlobales);
      const direccion = emisor.domicilio || "Dirección no configurada";
      const telefono  = emisor.telefono  || "Teléfono no configurado";
      const leyendaPresupuestoPDF = String(
        parametrosGlobales?.leyendaPresupuestoPDF ?? "",
      ).trim();
    
      // ===========================================
      // PASO 3: CONFIGURACIÓN DE IMAGEN Y HEADER
      // ===========================================
      
      // Detectar formato de imagen del logo (PNG o JPEG)
      let imgFormat = "PNG";
      if (typeof logoURLBD === "string") {
        if (/^data:image\/jpe?g;base64,/i.test(logoURLBD)) imgFormat = "JPEG";
        else if (/^data:image\/png;base64,/i.test(logoURLBD)) imgFormat = "PNG";
      }
      
      // Agregar logo en la esquina superior izquierda
      // Posición: x=10, y=10, ancho=70px, alto=40px
      try { 
        doc.addImage(logoURLBD, imgFormat, 10, 10, 70, 40); 
      } catch(e){ 
        console.error("[PDF] Error adding logo image:", e); 
      }
    
      // ===========================================
      // PASO 4: INFORMACIÓN DEL DOCUMENTO (ESQUINA SUPERIOR DERECHA)
      // ===========================================
      
      // Título del documento según el tipo (Venta, Compra, Gasto, Factura, etc.)
      doc.setFontSize(12);  // Reducido de 14 a 12
      doc.text(`${tituloDocumentoPdf} Nº ${transaccionData.id}`, 100, 20);
    
      // Información de la empresa (dirección, teléfono, fecha) - más compacto
      doc.setFontSize(8);  // Reducido de 10 a 8
      doc.text(`Dirección: ${direccion}`, 100, 26);  // Y reducido de 31 a 26
      doc.text(`Teléfono: ${telefono}`,   100, 32);  // Y reducido de 39 a 32
      doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 100, 38);  // Y reducido de 47 a 38
    
      // ===========================================
      // PASO 5: INFORMACIÓN DEL CLIENTE/DESTINATARIO
      // ===========================================
      
      // Títulos de sección - más compacto
      doc.setFontSize(10);  // Reducido de 12 a 10
      doc.setFont("Helvetica", "bold");
      doc.text("Destinatario", 10, 50);                    // Título izquierda (Y reducido de 55 a 50)
      doc.text(`Información de pago:`, 100, 50);          // Título derecha (Y reducido de 55 a 50)
      
      // Información del cliente (lado izquierdo) - más compacto
      doc.setFont("Helvetica", "normal");
      doc.setFontSize(8);  // Reducido de 12 a 8
      const entidadPdf = entidades || {};
      doc.text(`Cliente: ${entidadPdf.descripcion || "N/A"} ${entidadPdf.apellido || ""}`, 10, 55);  // Y reducido de 61 a 55
      doc.text(`DNI/CUIT/CUIL: ${entidadPdf.dniCuitCuil || "N/A"}`, 10, 60);  // Y reducido de 67 a 60
      doc.text(`Domicilio: ${entidadPdf.direccion || "N/A"}`, 10, 65);  // Y reducido de 73 a 65
      doc.text(`${entidadPdf.localidad || "N/A"} - ${entidadPdf.provincia || "N/A"}`, 10, 68);  // Y reducido de 76 a 68
      doc.text(`${entidadPdf.telefono || "N/A"}`, 10, 73);  // Y reducido de 82 a 73
    
      // ===========================================
      // PASO 6: INFORMACIÓN DE PAGOS (LADO DERECHO)
      // ===========================================
      
      // Procesar medios de pago (puede ser array o objeto único)
      const mediosDePago = Array.isArray(transaccionData.pagos)
        ? transaccionData.pagos.map(p => `${p.descripcion}: $${formatARS(p.monto || 0)}`)
        : transaccionData.pagos
          ? [`${transaccionData.pagos.descripcion}: $${formatARS(transaccionData.pagos.monto || 0)}`]
          : ["N/A"];
    
      // Mostrar cada medio de pago en líneas separadas - más compacto
      let currentYPosition = 55;  // Y reducido de 61 a 55
      mediosDePago.forEach((medio) => {
        doc.text(`${medio}`, 100, currentYPosition);
        currentYPosition += 4; // Espaciado reducido entre medios de pago (de 6 a 4)
      });
    
      // ===========================================
      // PASO 7: CALCULAR POSICIÓN DE INICIO DE TABLA
      // ===========================================
      
      // Determinar dónde empezar la tabla basado en el contenido anterior
      // El teléfono del cliente está en Y=73, así que la tabla debe empezar después
      const clienteEndY = 73;  // Última línea del cliente (teléfono)
      let startY = Math.max(clienteEndY + 5, currentYPosition + 5);  // Mínimo 5px después del contenido
    
      // ===========================================
      // PASO 8: CONFIGURACIÓN DE LA TABLA MANUAL
      // ===========================================
      // Esta tabla se dibuja "a mano" para tener control total sobre el diseño
    
      // ========== CONFIGURACIÓN DE DIMENSIONES ==========
      const MARGIN_X = 10;                    // Margen izquierdo de la tabla (reducido para ocupar más ancho)
      const TABLE_W  = pageWidth - MARGIN_X * 2;  // Ancho total de la tabla (página - márgenes)
    
      // ========== ANCHOS DE COLUMNAS (MODIFICAR AQUÍ PARA CAMBIAR PROPORCIONES) ==========
      const COL_W_PRICE = 30;                 // Ancho columna PRECIO (reducido)
      const COL_W_QTY   = 18;                 // Ancho columna CANTIDAD (reducido)
      const COL_W_DISC  = 20;                 // Ancho columna DESCUENTO (reducido)
      const COL_W_TOTAL = 30;                 // Ancho columna TOTAL (reducido)
      const COL_W_DESC  = TABLE_W - (COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL); // DESCRIPCIÓN = resto del espacio (más espacio)
    
      // ========== COLORES Y ESTILOS (MODIFICAR AQUÍ PARA CAMBIAR APARIENCIA) ==========
      const HEADER_FILL  = [245, 245, 235];   // Color de fondo del header (beige claro)
      const BORDER_COLOR = [160, 160, 160];   // Color de los bordes (gris medio)
      const TEXT_COLOR   = [0, 0, 0];         // Color del texto (negro)
      const LINE_H       = 6;                 // Altura mínima de cada fila (reducida para menos espacio entre filas)
    
      doc.setTextColor(...TEXT_COLOR);
    
      // ========== FUNCIONES AUXILIARES ==========
      
      // Función para verificar si hay espacio suficiente, si no, crea nueva página
      const ensureSpace = (neededHeight) => {
        if (startY + neededHeight > pageHeight - 40) {
          doc.addPage();
          startY = 30;  // Posición Y en nueva página
        }
      };
    
      // Función para dibujar títulos de sección (ej: "Items Canjeados")
      const drawBlockTitle = (title) => {
        ensureSpace(10);
        doc.setFont("Helvetica", "bold");
        doc.text(title, 100, startY, { align: "center" });  // Centrado en x=100
        startY += 6;  // Avanzar posición Y
        doc.setFont("Helvetica", "normal");
      };
    
      // ========== FUNCIÓN PARA DIBUJAR HEADER DE TABLA ==========
      const drawHeader = () => {
        ensureSpace(14);  // Verificar espacio para header
        
        // Configurar colores y bordes (sin background para ahorrar tinta)
        doc.setDrawColor(...BORDER_COLOR);    // Color de borde
        doc.setLineWidth(0.5);                // Grosor de línea
        // Sin color de fondo para ahorrar tinta al imprimir
    
        // Configurar texto del header
        doc.setFont("Helvetica", "bold");
        doc.setFontSize(8);  // TAMAÑO DE FUENTE DEL HEADER (reducido para ocupar menos espacio)
        
        // ========== TEXTO DE CADA COLUMNA DEL HEADER ==========
        // Posiciones calculadas: MARGIN_X + suma de anchos de columnas anteriores
        doc.text("DESCRIPCIÓN", MARGIN_X + 4, startY + 8);  // Columna 1: Izquierda
        doc.text("PRECIO",     MARGIN_X + COL_W_DESC + COL_W_PRICE - 2, startY + 8, { align: "right" });  // Columna 2: Derecha
        doc.text("CANTIDAD",   MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY/2, startY + 8, { align: "center" });  // Columna 3: Centro
        doc.text("DESC. / INT.", MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC/2, startY + 8, { align: "center" });  // Columna 4: Centro
        doc.text("TOTAL",      MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL - 2, startY + 8, { align: "right" });  // Columna 5: Derecha
    
        // Dibujar borde del header
        doc.rect(MARGIN_X, startY, TABLE_W, 12, "S");  // "S" = solo borde
        startY += 12;  // Avanzar posición Y
        doc.setFont("Helvetica", "normal");
      };
    
      // ========== FUNCIÓN PARA DIBUJAR FILAS DE DATOS ==========
      const drawRows = (rows) => {
        // Configurar fuente pequeña para las filas de datos
        doc.setFontSize(8);  // Tamaño de fuente pequeño para ocupar menos espacio
        
        rows.forEach((r) => {
          // ========== CONFIGURACIÓN DE FILA ==========
          const descMaxWidth = COL_W_DESC - 8;  // Ancho máximo para descripción (con margen)
          const wrapped = doc.splitTextToSize(r.descripcion || "N/A", descMaxWidth);  // Dividir texto largo en líneas
          const rowHeight = Math.max(LINE_H, 4 + (wrapped.length - 1) * 4 + 2);  // Altura de fila reducida (mínimo LINE_H)
  
          ensureSpace(rowHeight + 2);  // Verificar espacio
  
          // ========== DIBUJAR LÍNEA SUPERIOR DE LA FILA ==========
          doc.setDrawColor(...BORDER_COLOR);
          doc.setLineWidth(0.3);  // Grosor de línea de fila
          doc.line(MARGIN_X, startY, MARGIN_X + TABLE_W, startY);
  
          // ========== DIBUJAR CONTENIDO DE CADA COLUMNA ==========
          
          // COLUMNA 1: DESCRIPCIÓN (izquierda, puede ser múltiples líneas)
          let textY = startY + 4;  // Posición Y inicial del texto (reducida)
          wrapped.forEach((line) => {
            doc.text(line, MARGIN_X + 4, textY);  // x = MARGIN_X + 4 (margen interno)
            textY += 4;  // Avanzar Y para siguiente línea (reducido)
          });
  
          // COLUMNA 2: PRECIO (derecha)
          doc.text(String(r.precio || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE - 2, startY + 4, { align: "right" });
          
          // COLUMNA 3: CANTIDAD (centro)
          doc.text(String(r.cantidad || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY/2, startY + 4, { align: "center" });
          
          // COLUMNA 4: DESCUENTO (centro)
          doc.text(String(r.descuento || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC/2, startY + 4, { align: "center" });
          
          // COLUMNA 5: TOTAL (derecha)
          doc.text(String(r.total || ""), MARGIN_X + COL_W_DESC + COL_W_PRICE + COL_W_QTY + COL_W_DISC + COL_W_TOTAL - 2, startY + 4, { align: "right" });
  
          startY += rowHeight;  // Avanzar a siguiente fila
        });
    
        // ========== LÍNEA INFERIOR DE CIERRE DE TABLA ==========
        doc.setDrawColor(...BORDER_COLOR);
        doc.setLineWidth(0.3);
        doc.line(MARGIN_X, startY, MARGIN_X + TABLE_W, startY);
        startY += 10;  // Espacio después de la tabla
      };
    
      // ---- Construcción de filas con TU MISMA LÓGICA (descuento incluido en el total) ----
      const impuestoItems =
        deDondeViene === "gasto"
          ? []
          : await getTransaccionImpuestoItems(transaccionData.id);
      console.log("impuestoItems: ", impuestoItems);
    
      let subtotal = 0;
    
      if (deDondeViene === "devolucion") {
        const { itemList = [], itemListCanjeables = [] } = itemsTransaccion;
    
        // Items Canjeados
        const rowsCanjeados = [];
        itemList.forEach((item) => {
          const descuento = Number(item.porcentajeDescuento) || 0;
          const interes = Number(item.porcentajeInteres) || 0;
          const cantidad  = Number(item.cantidad) || 0;
          const precio    = Number(item.precio) || 0;
          const totalFila = calcularTotalLineaConAjustes(item, cantidad);
          if (cantidad !== 0) {
            rowsCanjeados.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precio)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%${interes ? ` / +${formatARS(interes)}%` : ""}`,
              total:    `$${formatARS(totalFila)}`
            });
          }
        });
    
        // Items Devueltos
        const rowsDevueltos = [];
        itemListCanjeables.forEach((item) => {
          const descuento = Number(item.porcentajeDescuento) || 0;
          const interes = Number(item.porcentajeInteres) || 0;
          const cantidad  = Number(item.cantidadDevolver) || 0;
          const precio    = Number(item.precio) || 0;
          const totalFila = calcularTotalLineaConAjustes(item, cantidad);
          if (cantidad !== 0) {
            rowsDevueltos.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precio)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%${interes ? ` / +${formatARS(interes)}%` : ""}`,
              total:    `$${formatARS(totalFila)}`
            });
          }
        });
    
        const valor1 = calcularSubtotal(itemList);
        const valor2 = calcularSubtotal(itemListCanjeables, deDondeViene);
        subtotal = valor1 - valor2;
    
        if (rowsCanjeados.length > 0) {
          drawBlockTitle("Items Canjeados");
          drawHeader();
          drawRows(rowsCanjeados);
        }
        if (rowsDevueltos.length > 0) {
          drawBlockTitle("Items Devueltos");
          drawHeader();
          drawRows(rowsDevueltos);
        }
    
      } else if (deDondeViene === "gasto") {
        // Gastos no tienen TransaccionItem de catálogo: la línea es la descripción + monto.
        const arr = Array.isArray(itemsTransaccion) ? itemsTransaccion : [];
        const rows = arr.map((item) => {
          const cantidad = Number(item.cantidad) || 1;
          const precio = Number(item.precio) || 0;
          const descuento = Number(item.porcentajeDescuento) || 0;
          const interes = Number(item.porcentajeInteres) || 0;
          const totalFila = calcularTotalLineaConAjustes(item, cantidad);
          return {
            descripcion: item.descripcion || "Gasto",
            precio: `$${formatARS(precio)}`,
            cantidad: formatARS(cantidad),
            descuento: `${formatARS(descuento)}%${interes ? ` / +${formatARS(interes)}%` : ""}`,
            total: `$${formatARS(totalFila)}`,
          };
        });
        subtotal = calcularSubtotal(arr);
        drawHeader();
        drawRows(rows.length > 0 ? rows : [{
          descripcion: transaccionData?.descripcion || "Gasto",
          precio: `$${formatARS(Number(transaccionData?.montoTotal) || 0)}`,
          cantidad: formatARS(1),
          descuento: "0%",
          total: `$${formatARS(Number(transaccionData?.montoTotal) || 0)}`,
        }]);
        if (rows.length === 0) {
          subtotal = Number(transaccionData?.montoTotal) || 0;
        }
      } else {
        const arr = Array.isArray(itemsTransaccion) ? itemsTransaccion : [];
        const impuestosArr = Array.isArray(impuestoItems) ? impuestoItems : [];
    
        const rows = [];
        await Promise.all(
          arr.map(async (item) => {
            const itx = await getTransaccionItemByTransactionAndItem(
              transaccionData.id,
              item.idItem,
            );
    
            const descuento    = Number(item.porcentajeDescuento) || 0;
            const interes      = Number(item.porcentajeInteres) || 0;
            const cantidad     = Number(item.cantidad) || 0;
            const precioSinIva = Number(itx?.precio) || 0;
    
            const impItem  = impuestosArr.find(imp => imp.idItem === item.idItem);
            const montoImp = Number(impItem?.montoTotal) || 0;
    
            const precioVisible =
              impItem && deDondeViene === "presupuesto"
                ? precioSinIva + montoImp
                : precioSinIva;
    
            const totalFila = calcularTotalLineaConAjustes(
              { ...item, precio: precioVisible },
              cantidad,
            );
    
            rows.push({
              descripcion: item.descripcion || "N/A",
              precio:   `$${formatARS(precioVisible)}`,
              cantidad: formatARS(cantidad),
              descuento: `${formatARS(descuento)}%${interes ? ` / +${formatARS(interes)}%` : ""}`,
              total:    `$${formatARS(totalFila)}`
            });
          })
        );
    
        subtotal = calcularSubtotal(arr);
    
        // Render tabla
        drawHeader();
        drawRows(rows);
      }
    
      // ==========
      //  FIN TABLA
      // ==========
    
      // Totales y descuentos (misma lógica)
      const montoDescuento = Number(transaccionData.montoDescuento) || 0;
      const porcentajeDescuento = Number(transaccionData.porcentajeDescuento) || 0;
    
      let totalAntesIVA = subtotal - montoDescuento;
      totalAntesIVA = totalAntesIVA * (1 - porcentajeDescuento / 100);
    
      let totalFinal = totalAntesIVA;
      let totalImpuestos = 0;
    
      let totalsY = startY;
      // espacio para totales
      if (totalsY + 40 > pageHeight - 40) { doc.addPage(); totalsY = 30; }
    
      /*doc.text(
        `Descuento: $${formatARS(montoDescuento)} + ${formatARS(porcentajeDescuento)}%`,
        20,
        totalsY
      );*/
  
      // Sin firma - eliminada para ahorrar espacio
  
      doc.text(
        `Descuento: ${formatARS(porcentajeDescuento)}%`,
        pageWidth - 20,
        totalsY,
        { align: "right" },
      );
  
      // TOTAL sin background, letra negra
      totalsY += 8;  // Reducido de 12 a 8
      doc.setTextColor(...TEXT_BLACK);  // Letra negra
      doc.setFont("Helvetica", "bold");
      doc.setFontSize(11.5);
      const totalMostrar = (tipoDeFactura == true) ? totalAntesIVA : totalFinal;
      doc.text(`TOTAL: $${formatARS(totalMostrar)}`, pageWidth - 20, totalsY, { align: "right" });
    
      // Mensaje adicional para presupuestos
      if (deDondeViene === "presupuesto") {
        doc.setTextColor(...TEXT_BLACK);
        doc.setFont("Helvetica", "normal");
        doc.setFontSize(9);
        //doc.text(`Válido por 30 días`, pageWidth - 20, totalsY + 20, { align: "right" });
      }
  
      // restaurar texto negro
        doc.setTextColor(...TEXT_BLACK);
        doc.setFont("Helvetica", "normal");
    
      // QR WhatsApp - más cerca del total
      const qrX = 20;
      const qrY = totalsY + 15;  // Reducido de 50 a 15 para estar más cerca del total
      if (qrY + 60 > pageHeight - 20) { doc.addPage(); }
      // Limpiar el teléfono obtenido de parámetros globales (eliminar espacios, guiones, paréntesis)
      const phoneClean = telefono.replace(/[\s\-\(\)]/g, '');
      const waLink = `https://wa.me/${phoneClean}`;
      const qrDataUrl = await QRCode.toDataURL(waLink, { width: 150 });
    
      doc.addImage(qrDataUrl, "PNG", qrX, qrY, 40, 40);
      doc.setFontSize(9);
      doc.text("Escanea para chatear por WhatsApp", qrX + 50, qrY + 20);
    
      // Footer - leyenda configurable (solo presupuesto) y marca del sistema
      const lutenteFooterY = pageHeight - 10;
      const footerGap = 4;
      const footerLineH = 4;
      doc.setFontSize(11);
      doc.setTextColor(150, 150, 150);
      doc.setFont("Helvetica", "italic");
      if (deDondeViene === "presupuesto" && leyendaPresupuestoPDF) {
        const leyendaLines = doc.splitTextToSize(leyendaPresupuestoPDF, pageWidth - 20);
        const lastLeyendaBaseline = lutenteFooterY - footerGap;
        const firstLeyendaBaseline =
          lastLeyendaBaseline - (leyendaLines.length - 1) * footerLineH;
        leyendaLines.forEach((line, i) => {
          doc.text(line, pageWidth / 2, firstLeyendaBaseline + i * footerLineH, {
            align: "center",
          });
        });
      }
      doc.text(
        "LUTENTE CLOUD - sistema de gestión",
        pageWidth / 2,
        lutenteFooterY,
        { align: "center" },
      );
      doc.setTextColor(...TEXT_BLACK);
      doc.setFont("Helvetica", "normal");
    
    
      // Output
      let result;
      if (returnBase64 === 'blob') {
        const pdfBlob = doc.output('blob');
        result = pdfBlob;
      } else {
        const pdfBase64 = doc.output('datauristring');
        console.log(`[PDF] generated base64 length=${pdfBase64?.length || 0}`);
    
        if (!returnBase64) {
          const fileName = `${prefijoPdf}_${transaccionData.id}.pdf`
          doc.setProperties({ title: fileName, subject: "Comprobante", creator: "Sistema" })
          deliverPdf({
            doc,
            fileName,
            title: `${tituloDocumentoPdf} ${transaccionData.id}`,
            targetWindow: null,
          })
        }
        result = pdfBase64;
      }
    
      return result;
    };

  const generarRemitoPDF = async (
    transaccionData,
    itemsTransaccion,
    entidades,
    vendedorData,
    tipoDeFactura,
    impuestos,
    cuentaCorrienteInfo = null,
  ) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const logoURLbase64 = await axios.get(
      serverURL + `/adminAPI/logoURLbase64`,
    );

    const logoURLBD = logoURLbase64.data.logoURL.valorParametro;

    // Obtener parámetros globales para dirección y teléfono
    const parametrosGlobales = await getParametrosGlobales([
      "afipsdk_domicilio",
      "afipsdk_telefono",
    ]);
    // Mismo criterio que generarFacturaPDF: sucursal de la transacción → global →
    // placeholder histórico. El remito no es comprobante fiscal.
    const emisor = await resolverEmisorImpresion(transaccionData?.idUbicacion, parametrosGlobales);
    const direccion = emisor.domicilio || "Dirección no configurada";
    const telefono = emisor.telefono || "Teléfono no configurado";

    const tenant = erpCookies.get("tenant"); // Obtén el tenant desde las cookies

    doc.addImage(logoURLBD, "PNG", 10, 10, 70, 40);

    doc.setFontSize(14);
    doc.text("Remito (Ticket no valido como factura)", 100, 15);
    doc.setFontSize(10);
    // Usar parámetros globales dinámicos
    doc.text(`Dirección: ${direccion}`, 100, 23);
    doc.text(`Teléfono: ${telefono}`, 100, 31);
    doc.text(`Fecha: ${new Date().toLocaleDateString()}`, 100, 39);
    doc.text(`Vendedor: ${vendedorData.nombre || "N/A"}`, 100, 47);

    doc.setLineWidth(0.5);
    doc.line(10, 50, pageWidth - 10, 50); // Línea separadora

    // **Información del cliente**
    doc.setFontSize(12);
    doc.setFont("Helvetica", "bold");
    doc.text("Información del Cliente", 20, 60);
    doc.setFont("Helvetica", "normal");
    // console.log(entidades);
    doc.text(
      `Cliente: ${entidades.descripcion || "N/A"} ${entidades.apellido || ""}`,
      20,
      70,
    );
    doc.text(`DNI/CUIT/CUIL: ${entidades.dniCuitCuil || "N/A"}`, 100, 70);
    doc.text(`Condición: Receptor`, 20, 80);
    doc.text(`Domicilio: ${entidades.direccion || "N/A"}`, 100, 80);
    doc.text(
      `${entidades.localidad || "N/A"} - ${entidades.provincia || "N/A"}`,
      105,
      85,
    );
     
    // ===========================================
    // INFORMACIÓN DE CUENTA CORRIENTE (solo para venta o presupuesto)
    // ===========================================
    // Si cuentaCorrienteInfo no es null, significa que se pasó desde handleDownloadRemito
    // y solo se pasa cuando es venta o presupuesto, así que podemos mostrarlo directamente
    let startYTable = 95; // Posición inicial de la tabla (ajustable si hay cuenta corriente)
    
    if (cuentaCorrienteInfo) {
      let yPosCuentaCorriente = 95; // Posición después de la información del cliente
      doc.setFontSize(10);
      doc.setFont("Helvetica", "bold");
      doc.text("Cuenta Corriente:", 20, yPosCuentaCorriente);
      doc.setFont("Helvetica", "normal");
      
      if (cuentaCorrienteInfo.tieneCuentaCorriente) {
        const saldo = cuentaCorrienteInfo.saldo || 0;
        const saldoFormateado = new Intl.NumberFormat("es-AR", {
          style: "currency",
          currency: "ARS",
        }).format(saldo);
        
        // Determinar el color según el signo del saldo
        let colorSaldo = [0, 0, 0]; // Negro por defecto
        
        if (saldo < 0) {
          colorSaldo = [200, 0, 0]; // Rojo para deuda
        } else if (saldo > 0) {
          colorSaldo = [0, 150, 0]; // Verde para crédito
        } else {
          colorSaldo = [0, 0, 0]; // Negro para saldo cero
        }
        
        doc.setTextColor(...colorSaldo);
        doc.text(`Saldo: ${saldoFormateado}`, 20, yPosCuentaCorriente + 5);
        doc.setTextColor(0, 0, 0); // Restaurar color negro
        startYTable = yPosCuentaCorriente + 12; // Ajustar posición de la tabla después de la cuenta corriente
      } else {
        doc.text("Sin cuenta corriente", 20, yPosCuentaCorriente + 5);
        startYTable = yPosCuentaCorriente + 12; // Ajustar posición de la tabla después de la cuenta corriente
      }
    }

    doc.setFontSize(12);
    doc.setFont("Helvetica", "normal");

    const tableColumn = [
      "#",
      "Código",
      "Descripción",
      "Cantidad",
      "Valor Unitario",
      "Desc / Int",
      "Subtotal",
    ];
    const tableRows = [];

    let totalCantidad = 0;
    let totalSubtotal = 0;

    itemsTransaccion.forEach((item, index) => {
      const descuento = item.porcentajeDescuento || 0;
      const interes = item.porcentajeInteres || 0;
      const totalLinea = calcularTotalLineaConAjustes(item);

      const itemData = [
        index + 1,
        item.codigo || "N/A",
        item.descripcion,
        item.cantidad || 0,
        `$${(item.precio || 0).toFixed(2)}`,
        `${descuento}%${interes ? ` / +${interes}%` : ""}`,
        `$${totalLinea.toFixed(2)}`,
      ];
      tableRows.push(itemData);
      totalCantidad += item.cantidad || 0;
      totalSubtotal += totalLinea;
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: startYTable,
      styles: {
        fontSize: 10,
        halign: "center",
        cellPadding: 3,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: [240, 240, 240],
        textColor: [0, 0, 0],
      },
    });

    // **Totales sectorizados**
    const subtotal = calcularSubtotal(itemsTransaccion);
    const montoDescuento = Number(transaccionData.montoDescuento) || 0;
    const porcentajeDescuento =
      Number(transaccionData.porcentajeDescuento) || 0;

    let totalAntesIVA = subtotal - montoDescuento;
    totalAntesIVA = totalAntesIVA * (1 - porcentajeDescuento / 100);
    const iva = totalAntesIVA * 0.21;
    const totalFinal = totalAntesIVA + iva;

    const totalsY = doc.lastAutoTable.finalY + 10;
    doc.setDrawColor(0);
    doc.setFillColor(250, 250, 250);
    doc.rect(10, totalsY, pageWidth - 20, 40, "FD");

    doc.setFont("Helvetica", "bold");
    doc.text(`Subtotal: $${subtotal.toFixed(2)}`, 20, totalsY + 10);
    doc.text(
      `Descuento: $${montoDescuento.toFixed(2)} + ${porcentajeDescuento}%`,
      20,
      totalsY + 20,
    );
    if (tipoDeFactura == true) {
      doc.text(
        `Total a Pagar: $${totalAntesIVA.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 10,
        { align: "right" },
      );
    } else {
      doc.text(
        `Total antes de IVA: $${totalAntesIVA.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 10,
        { align: "right" },
      );
      doc.text(`IVA (21%): $${iva.toFixed(2)}`, pageWidth - 20, totalsY + 20, {
        align: "right",
      });
      doc.text(
        `Total a Pagar: $${totalFinal.toFixed(2)}`,
        pageWidth - 20,
        totalsY + 30,
        { align: "right" },
      );
    }

    // **Generar QR localmente**
    const qrX = 20;
    const qrY = totalsY + 50;
    // Limpiar el teléfono obtenido de parámetros globales (eliminar espacios, guiones, paréntesis)
    const phoneClean = telefono.replace(/[\s\-\(\)]/g, '');
    const waLink = `https://wa.me/${phoneClean}`;
    // **Simulación del código QR**
    const qrDataUrl = await QRCode.toDataURL(waLink, { width: 150 });

    // Lo añades directo
    doc.addImage(qrDataUrl, "PNG", qrX, qrY, 40, 40);
    doc.setFontSize(9);
    doc.text("Escanea para chatear por WhatsApp", qrX + 50, qrY + 20);

    // **Firma o mensaje final**
    doc.text("Firma del cliente: ____________________", 20, qrY + 60);
    doc.text(
      "Firma del vendedor: ___________________",
      pageWidth / 2,
      qrY + 60,
    );

    // **Vista previa PDF (sin descarga automática)**
    const remitoFileName = `Remito_${transaccionData.id}.pdf`
    doc.setProperties({ title: remitoFileName, subject: "Remito", creator: "Sistema" })
    deliverPdf({ doc, fileName: remitoFileName, targetWindow: null })
    const pdfDataUri = doc.output("datauristring");
    return { data: { pdfUrl: pdfDataUri } };
  };

  const enviarFacturaWhatsApp = async (idFactura, pdfBase64, phoneNumber, tipo = 'factura') => {
    try {
      const payload = {
        idFactura,
        pdfBase64,
        phoneNumber,
        tipo // 'factura' | 'presupuesto'
      };

      const response = await axios.post(
        serverURL + "/transaccionAPI/enviarWhatsAppLink", // Usar la ruta correcta
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Error enviando factura por WhatsApp:", error);
      throw error;
    }
  };

  const enviarMail = async (
    idFactura,
    pdfBase64,
    toEmail,
    tipo = "factura",
    idUbicacion = null, // sucursal de la transacción: define el NOMBRE del remitente (razón social)
  ) => {
    try {
      let payloadPdf = pdfBase64;
      if (
        typeof payloadPdf === "string" &&
        /^data:application\/pdf/i.test(payloadPdf)
      ) {
        const idx = payloadPdf.indexOf(",");
        payloadPdf = idx !== -1 ? payloadPdf.slice(idx + 1) : payloadPdf;
      }
      console.log(
        `[Email] preparing send id=${idFactura}, tipo=${tipo}, to=${toEmail}, base64Len=${payloadPdf?.length || 0}`,
      );
      const response = await axios.post(
        `${serverURL}/transaccionAPI/enviarMail`,
        {
          idFactura,
          pdfBase64: payloadPdf,
          toEmail: toEmail,
          tipo,
          idUbicacion,
        },
      );

      console.log("[Email] server response:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "[Email] Error enviando factura por Email:",
        error?.response?.status,
        error?.response?.statusText,
      );
      if (error?.response?.data) {
        console.error("[Email] server data:", error.response.data);
      }
      throw error;
    }
  };
  //Logica de usuarios

  // USUARIO / COOKIE  ************************// USUARIO / COOKIE  ************************************************************************************************************************************************
  // USUARIO / COOKIE  ************************// USUARIO / COOKIE  ************************************************************************************************************************************************
  // SE SETEAN ASI:
  // setCookie('tenant', userData.tenant);
  // EN EL BACKEND SE RECUPERAN ASI
  // req.cookies.tenant
  // EN EL FRONT END SE RECUPERAN ASI
  // erpCookies.get('tenant')
  // ASI SE ELIMINAN
  // Cookies.remove('tenant');

  const [user, setUser] = useState(leerUsuarioGuardado);
  const [tenantContext, setTenant] = useState(() => erpCookies.get("tenant") || "");
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Cambio de tenant en la misma pestaña (SPA): guardar la sesión actual y recargar.
  useEffect(() => {
    const urlTenant = getTenantFromPathname(location.pathname);
    if (!urlTenant) return;
    const { needReload } = syncSessionToTenant(urlTenant);
    if (needReload) {
      window.location.replace(`${location.pathname}${location.search}${location.hash}`);
    }
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const savedUser = localStorage.getItem("user");

    if (token && savedUser) {
      const userParsed = JSON.parse(savedUser);
      // 🔒 Asegurar que accesosFuncionalidad siempre esté inicializado
      const userWithDefaults = {
        ...userParsed,
        token,
        accesosFuncionalidad: userParsed.accesosFuncionalidad || [] // Si no existe, inicializar como array vacío
      };
      setUser(userWithDefaults);
      setToken(token);
      setTenant(erpCookies.get("tenant") || "");
      
      // 🔢 Cargar formatos (numérico y fechas) al restaurar sesión desde localStorage
      const loadFormatosGlobales = async () => {
        try {
          const resultado = await getParametrosGlobales(["formatoNumerico", "formatoFechas"]);
          const valorNumerico = resultado?.formatoNumerico;
          const valorFechas = resultado?.formatoFechas;
          
          // Formato numérico
          if (typeof valorNumerico === "string" && valorNumerico.trim() !== "") {
            setFormatoNumericoGlobal(valorNumerico.trim());
            console.log("🔢 [Restaurar sesión] Formato numérico cargado:", valorNumerico.trim());
          } else {
            setFormatoNumericoGlobal("es-AR");
            console.log("🔢 [Restaurar sesión] Formato numérico: valor por defecto (es-AR)");
          }
          
          // 📅 Formato de fechas
          if (typeof valorFechas === "string" && valorFechas.trim() !== "") {
            setFormatoFechasGlobal(valorFechas.trim());
            console.log("📅 [Restaurar sesión] Formato de fechas cargado:", valorFechas.trim());
          } else {
            setFormatoFechasGlobal('DD/MM/YYYY');
            console.log("📅 [Restaurar sesión] Formato de fechas: valor por defecto (DD/MM/YYYY)");
          }
        } catch (error) {
          console.error("Error obteniendo parámetros globales al restaurar sesión:", error);
          setFormatoNumericoGlobal("es-AR");
          setFormatoFechasGlobal('DD/MM/YYYY');
        }
      };
      loadFormatosGlobales();
    } else if (token) {
      // Si no hay "user" pero sí token, usás el token básico (sin datos extra)
      const decodedToken = jwtDecode(token);
      setUser({ ...decodedToken, token });
      setToken(token);
    }
  }, [token]);

  // Catálogos chicos: una vez por sesión, no por pantalla.
  const catalogosSesionCargadosRef = useRef(false);
  useEffect(() => {
    if (!user) {
      catalogosSesionCargadosRef.current = false;
      return;
    }
    if (catalogosSesionCargadosRef.current) return;
    catalogosSesionCargadosRef.current = true;
    getUbicacion();
    getNegocio();
    getTipoMedioDePago();
    getMedioDePago();
    getMedioDePagoConDescripcion();
    getMoneda();
    getTipoEntidad();
    getCondicionIva();
    getCategoriaTransaccion();
    getSubCategoriaTransaccion();
    getImpuestos();
    getTiposFacturas();
  }, [user]);

  // 🔒 Función para validar sesión de seguridad
  const checkSessionValidity = () => {
    const tenantCookie = erpCookies.get("tenant"); // Cookie de seguridad (24hs)
    const savedUser = localStorage.getItem("user");
    const savedToken = localStorage.getItem("token");

    // Si NO hay usuario ni token, no hay sesión activa - no validar
    if (!savedUser && !savedToken) {
      setIsSessionExpired(false);
      return true;
    }

    // Si hay usuario/token pero NO hay cookie de seguridad = sesión expirada
    // Pero solo activar si realmente hay una sesión activa (hay user o token válido)
    if ((savedUser || savedToken) && !tenantCookie) {
      // Verificar si el token JWT es válido antes de marcar como expirado
      // Puede ser que la cookie se perdió pero el token aún es válido
      if (savedToken) {
        try {
          const decodedToken = jwtDecode(savedToken);
          const currentTime = Date.now() / 1000;
          
          // Si el token JWT también expiró, entonces sí es sesión expirada
          if (decodedToken.exp && decodedToken.exp < currentTime) {
            console.warn("⚠️ Sesión de seguridad expirada (cookie tenant no existe y token JWT expirado)");
            setIsSessionExpired(true);
            return false;
          }
          // Si el token JWT es válido pero falta la cookie, puede ser un problema temporal
          // No marcar como expirado inmediatamente, solo loguear
          console.warn("⚠️ Cookie tenant no encontrada pero token JWT válido - puede ser problema temporal");
          return true; // Permitir continuar, puede ser un problema temporal de cookies
        } catch (error) {
          console.error("Error al decodificar token:", error);
          // Si no se puede decodificar el token, sí es sesión expirada
          setIsSessionExpired(true);
          return false;
        }
      } else {
        // Hay usuario pero no token ni cookie - sesión expirada
        console.warn("⚠️ Sesión de seguridad expirada (cookie tenant no existe y no hay token)");
        setIsSessionExpired(true);
        return false;
      }
    }

    // Validar expiración del JWT
    if (savedToken) {
      try {
        const decodedToken = jwtDecode(savedToken);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          console.warn("⚠️ Token JWT expirado");
          setIsSessionExpired(true);
          return false;
        }
      } catch (error) {
        console.error("Error al decodificar token:", error);
        setIsSessionExpired(true);
        return false;
      }
    }

    // Si llegamos aquí, la sesión es válida
    setIsSessionExpired(false);
    return true;
  };

  // 🔄 Validación periódica de sesión (cada 60 segundos)
  useEffect(() => {
    // Solo validar si hay usuario logueado
    if (!user) {
      setIsSessionExpired(false);
      return;
    }

    // Ejecutar con un pequeño delay para asegurar que las cookies estén establecidas
    const initialTimeout = setTimeout(() => {
      checkSessionValidity();
    }, 1000); // Esperar 1 segundo antes de la primera validación

    // Luego ejecutar cada minuto
    const interval = setInterval(() => {
      // Solo validar si hay usuario logueado
      if (user) {
        checkSessionValidity();
      }
    }, 60000); // 60 segundos

    // 🆕 Detectar cuando la página vuelve a ser visible (después de suspensión)
    let visibilityOuterTimeout = null;
    let visibilityInnerTimeout = null;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && user) {
        visibilityOuterTimeout = setTimeout(() => {
          // Si ya no hay sesión activa (logout ocurrió mientras esperábamos), no hacer nada
          if (!localStorage.getItem("token")) return;

          const tenantCookie = erpCookies.get("tenant");
          const savedUser = localStorage.getItem("user");
          const savedToken = localStorage.getItem("token");

          if (savedUser && savedToken && !tenantCookie) {
            visibilityInnerTimeout = setTimeout(() => {
              // Verificar de nuevo que la sesión no fue cerrada durante la espera
              if (!localStorage.getItem("token")) return;

              const tenantCookieRetry = erpCookies.get("tenant");
              if (!tenantCookieRetry) {
                try {
                  const decodedToken = jwtDecode(savedToken);
                  const currentTime = Date.now() / 1000;

                  if (decodedToken.exp && decodedToken.exp < currentTime) {
                    console.warn("⚠️ Sesión expirada después de suspensión: token JWT expirado");
                    setIsSessionExpired(true);
                  } else {
                    console.warn("⚠️ Cookie no disponible después de suspensión pero token válido - no expirar sesión");
                    setIsSessionExpired(false);
                  }
                } catch (error) {
                  console.error("Error al validar token después de suspensión:", error);
                  setIsSessionExpired(false);
                }
              } else {
                setIsSessionExpired(false);
              }
            }, 2000);
          } else {
            checkSessionValidity();
          }
        }, 500);
      }
    };

    // Agregar listener para cambios de visibilidad
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
      clearTimeout(visibilityOuterTimeout);
      clearTimeout(visibilityInnerTimeout);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [user]);

  const setCookie = (name, value, persistent = false) => {
    if (persistent) {
      erpCookies.set(name, value, { expires: 365 });
    } else {
      erpCookies.set(name, value, { expires: 1 });
    }
  };
  const login = async (userData) => {
    try {
      // console.log(userData)
      const response = await axios.post(
        serverURL + "/loginAPI/login",
        userData,
      ); // Ajusta la URL según tu configuración

      const user = response.data.user;

      // 🔒 Cookie de seguridad (24hs) - usada para validación en backend
      setCookie("tenant", userData.tenant, false); // COOKIE TENANT SEGURIDAD
      setCookie("usuario", userData.usuario, false); // COOKIE USUARIO
      setCookie("idUsuario", response.data.user.id, false); // ID del usuario
      setCookie("nombreUsuario", response.data.user.usuario, false); // Nombre del usuario
      setCookie("rolUsuario", "", false); // Se actualizará más adelante

      // 🌐 Cookie persistente (365 días) - usada para URLs y navegación
      setCookie("tenantURL", userData.tenant, true); // COOKIE TENANT PERSISTENTE

      setTenant(userData.tenant); // Actualizar contexto
      localStorage.setItem("token", response.data.token);

      let usuarioConRol = user;

      const rolUsuario = await getRolDeUsuario(user.rol); // Suponiendo que devuelve un objeto tipo { id: 1, descripcion: 'Administrador' }
      console.log("rolUsuario", rolUsuario);
      const accesosDelRol = await getRolAccesoByIdRol(user.rol);
      console.log("accesosDelRol", accesosDelRol);  

      // 🆕 OBTENER PERMISOS DE COMPONENTES (RolFuncionalidadAcceso)
      const accesosFuncionalidadDelRol = await getRolSectorAccesoByIdRol(user.rol);

      usuarioConRol = {
        ...user,
        rolUsuario: rolUsuario.descripcion, // agrega el rol al objeto user
        idRolUsuario: rolUsuario.id, // agrega el id del rol al objeto user
        accesos: accesosDelRol, // ← agregamos los accesos a menús
        accesosFuncionalidad: accesosFuncionalidadDelRol || [], // ← 🆕 agregamos los accesos a funcionalidades (siempre array)
      };

      console.log("usuarioConRol", usuarioConRol);
      console.log("🔒 [Login] accesosFuncionalidad cargados:", usuarioConRol.accesosFuncionalidad);

      setCookie("rolUsuario", usuarioConRol.rolUsuario, false); // Guarda el rol del usuario en la cookie (seguridad)
      localStorage.setItem("user", JSON.stringify(usuarioConRol));
      persistLiveSession(userData.tenant);
      setUser(usuarioConRol);
      setIsSessionExpired(false); // Resetear estado de sesión expirada
      
      // 🔢 Cargar formato numérico después del login exitoso
      try {
        const resultado = await getParametrosGlobales(["formatoNumerico", "formatoFechas"]);
        const valorNumerico = resultado?.formatoNumerico;
        const valorFechas = resultado?.formatoFechas;
        
        // Formato numérico
        if (typeof valorNumerico === "string" && valorNumerico.trim() !== "") {
          setFormatoNumericoGlobal(valorNumerico.trim());
          console.log("🔢 [Login] Formato numérico cargado:", valorNumerico.trim());
        } else {
          setFormatoNumericoGlobal("es-AR");
          console.log("🔢 [Login] Formato numérico: valor por defecto (es-AR)");
        }
        
        // 📅 Formato de fechas
        if (typeof valorFechas === "string" && valorFechas.trim() !== "") {
          setFormatoFechasGlobal(valorFechas.trim());
          console.log("📅 [Login] Formato de fechas cargado:", valorFechas.trim());
        } else {
          setFormatoFechasGlobal('DD/MM/YYYY'); // Valor por defecto
          console.log("📅 [Login] Formato de fechas: valor por defecto (DD/MM/YYYY)");
        }
      } catch (error) {
        console.error("Error obteniendo parámetros globales:", error);
        setFormatoNumericoGlobal("es-AR");
        setFormatoFechasGlobal('DD/MM/YYYY');
      }
    } catch (error) {
      console.error(
        "Error de inicio de sesión:",
        error.response?.data?.message || error.message,
      );
      throw error; // Lanza el error para manejarlo en el componente
    }
  };

  const getRolDeUsuario = async (idRol) => {
    try {
      const usuarioRol = await axios.get(
        serverURL + "/loginAPI/usuarioRol",
        { params: { idRol: idRol } }, // <- pasás como query param
      ); // Ajusta la URL según tu configuración

      return usuarioRol.data;
    } catch (error) {}
  };

  const logout = () => {
    const tenantForNav =
      getTenantFromPathname(location.pathname) ||
      erpCookies.get("tenant") ||
      erpCookies.get("tenantURL") ||
      "default";

    clearPersistedSession(tenantForNav);
    clearLiveSession();
    erpCookies.set("tenantURL", tenantForNav, { expires: 365 });

    setFormatoNumericoGlobal("es-AR");
    setFormatoFechasGlobal('DD/MM/YYYY');

    setUser(null);
    setToken(null);
    setTenant("");
    setIsSessionExpired(false);
    navigate(`/${tenantForNav}/login`);
  };

  // "CONSTRUCTOR" ***********************************************************************

  // ================================================================================
  // GESTIÓN DE LOTES - FUNCTIONS
  // ================================================================================

  // Crear un nuevo lote
  const postLote = async (loteData) => {
    try {
      const response = await axios.post(
        serverURL + `/itemAPI/lotes`,
        loteData
      );
      return response.data;
    } catch (error) {
      console.error("Error al crear lote:", error);
      throw error;
    }
  };

  // Obtener todos los lotes
  const getLotes = async () => {
    try {
      const response = await axios.get(serverURL + `/itemAPI/lotes`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener lotes:", error);
      throw error;
    }
  };

  // Obtener lote por ID
  const getLoteById = async (idLote) => {
    try {
      const response = await axios.get(serverURL + `/itemAPI/lotes/${idLote}`);
      return response.data;
    } catch (error) {
      console.error("Error al obtener lote:", error);
      throw error;
    }
  };

  // Obtener lotes de un item específico
  const getLotesByItem = async (idItem) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/item/${idItem}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener lotes del item:", error);
      throw error;
    }
  };

  // Actualizar un lote
  const updateLote = async (idLote, loteData) => {
    try {
      const response = await axios.put(
        serverURL + `/itemAPI/lotes/${idLote}`,
        loteData
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar lote:", error);
      throw error;
    }
  };

  // Eliminar un lote
  const deleteLote = async (idLote) => {
    try {
      const response = await axios.delete(
        serverURL + `/itemAPI/lotes/${idLote}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al eliminar lote:", error);
      throw error;
    }
  };

  // Obtener stock de un lote por ubicaciones
  const getLoteItemUbicacionStock = async (idLote) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/${idLote}/stock`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener stock de lote:", error);
      throw error;
    }
  };

  // Actualizar stock de lote en una ubicación
  const updateLoteItemUbicacionStock = async (stockData) => {
    try {
      const response = await axios.put(
        serverURL + `/itemAPI/lotes/stock`,
        stockData
      );
      return response.data;
    } catch (error) {
      console.error("Error al actualizar stock de lote:", error);
      throw error;
    }
  };

  // Obtener lote más antiguo con stock (FIFO)
  const getLoteMasAntiguoConStock = async (idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/fifo/${idItem}/${idUbicacion}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener lote FIFO:", error);
      throw error;
    }
  };

  // Descontar stock de venta (FIFO automático)
  const descontarStockVenta = async (ventaData) => {
    try {
      const response = await axios.post(
        serverURL + `/itemAPI/lotes/descontar-venta`,
        ventaData
      );
      return response.data;
    } catch (error) {
      console.error("Error al descontar stock de venta:", error);
      throw error;
    }
  };

  // Obtener lotes próximos a vencer
  const getLotesProximosVencer = async (diasAntes = 30) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/alertas/${diasAntes}`
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener alertas de lotes:", error);
      throw error;
    }
  };

  // 🆕 Obtener sugerencia FIFO de lotes para una venta
  const getSugerenciaLotesVenta = async (idItem, idUbicacion, cantidad) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/sugerencia-venta`,
        {
          params: { idItem, idUbicacion, cantidad }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener sugerencia de lotes:", error);
      throw error;
    }
  };

  // 🆕 Obtener todos los lotes disponibles para venta
  const getLotesDisponiblesVenta = async (idItem, idUbicacion) => {
    try {
      const response = await axios.get(
        serverURL + `/itemAPI/lotes/disponibles-venta`,
        {
          params: { idItem, idUbicacion }
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error al obtener lotes disponibles:", error);
      throw error;
    }
  };

  // 🔒 FUNCIÓN DE VERIFICACIÓN DE PERMISOS GRANULARES
  // Verifica si el usuario tiene acceso a una funcionalidad específica dentro de un menú
  // @param {Object} user - Objeto usuario del contexto (debe tener accesosFuncionalidad)
  // @param {string} idMenuAcceso - ID del menú (ej: 'TRANSACCIONES10', 'VENTAS1')
  // @param {string} idFuncionalidad - ID de la funcionalidad granular (ej: 'montoFinalCaja', 'precioEnVentaEditable')
  // @returns {boolean} - true si el usuario tiene acceso, false en caso contrario
  const tieneAccesoFuncionalidad = (user, idMenuAcceso, idFuncionalidad) => {
    if (!user || !user.accesosFuncionalidad || !Array.isArray(user.accesosFuncionalidad)) {
      return false;
    }
    
    return user.accesosFuncionalidad.some(
      (acceso) => 
        String(acceso.idMenuAcceso).trim() === String(idMenuAcceso).trim() &&
        String(acceso.idSector).trim() === String(idFuncionalidad).trim() &&
        acceso.eliminado === false
    );
  };

  // MODULO ECOMMERCE ***********************************************************************
  // Administración del módulo ecommerce: publicación de items, atributos y parámetros.
  // Backend: /ecommerceDomain (server/domains/ecommerceDomain/)

  // Tabla principal: items publicados en la tienda
  const getEcommerceItems = useCallback(async (pagina = 1, limite = 25, q, atributos, soloActivos, grupoDe) => {
    try {
      const params = { pagina, limite };
      if (q) params.q = q;
      if (atributos && Object.keys(atributos).length > 0) params.atributos = JSON.stringify(atributos);
      if (soloActivos) params.soloActivos = true;
      if (grupoDe) params.grupoDe = grupoDe;
      const response = await axios.get(serverURL + "/ecommerceDomain/items", { params });
      return response.data;
    } catch (error) { console.error("Error fetching ecommerce items:", error); }
  }, [serverURL]);

  // Buscador avanzado de items del ERP para pasar al ecommerce
  const getEcommerceItemsDisponibles = useCallback(async (pagina = 1, limite = 25, q, atributos, soloNoPublicados) => {
    try {
      const params = { pagina, limite };
      if (q) params.q = q;
      if (atributos && Object.keys(atributos).length > 0) params.atributos = JSON.stringify(atributos);
      if (soloNoPublicados) params.soloNoPublicados = true;
      const response = await axios.get(serverURL + "/ecommerceDomain/itemsDisponibles", { params });
      return response.data;
    } catch (error) { console.error("Error fetching items disponibles:", error); }
  }, [serverURL]);

  const publicarEcommerceItems = async (idItems) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/items/publicar", { idItems });
    return response.data;
  };

  const publicarEcommercePorFiltro = async (q, atributos) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/items/publicarPorFiltro", { q, atributos });
    return response.data;
  };

  const quitarEcommerceItems = async (idItems) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/items/quitar", { idItems });
    return response.data;
  };

  const agruparEcommerceItems = async (idRepresentante, ids) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/items/agrupar", {
      idRepresentante,
      ids,
    });
    return response.data;
  };

  const desagruparEcommerceItems = async (ids) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/items/desagrupar", { ids });
    return response.data;
  };

  // Edita campos de tienda (orden, destacado, activo, grupo, textos...)
  const putEcommerceItem = async (id, data) => {
    const response = await axios.put(serverURL + "/ecommerceDomain/items/" + id, data);
    return response.data;
  };

  // Dimensiones (cm) y peso (kg) del item, para calcular costo de envío en ecommerce
  const putEcommerceItemDimensiones = async (idItem, data) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/items/${idItem}/dimensiones`, data);
    return response.data;
  };

  // Galería de imágenes del item (máx 5, base64 → binario en el server)
  const getEcommerceImagenesItem = async (idItem) => {
    try {
      const response = await axios.get(serverURL + `/ecommerceDomain/items/${idItem}/imagenes`);
      return response.data;
    } catch (error) { console.error("Error fetching imagenes item:", error); }
  };

  // La miniatura la genera el navegador (utils/imagenes.js) junto con la imagen
  const postEcommerceItemImagen = async (idItem, imagenBase64, miniaturaBase64, extra = {}) => {
    const response = await axios.post(serverURL + `/ecommerceDomain/items/${idItem}/imagenes`, {
      imagenBase64,
      miniaturaBase64,
      ...extra,
    });
    return response.data;
  };

  const putEcommerceItemImagen = async (idImagen, data) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/imagenesItem/${idImagen}`, data);
    return response.data;
  };

  const deleteEcommerceItemImagen = async (idImagen) => {
    const response = await axios.delete(serverURL + `/ecommerceDomain/imagenesItem/${idImagen}`);
    return response.data;
  };

  // ids en el orden deseado; el primero pasa a ser la portada
  const putEcommerceImagenesOrden = async (idItem, ids) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/items/${idItem}/imagenes/orden`, { ids });
    return response.data;
  };

  // Índice de atributos publicados (imagen, orden, activo por valor)
  const getEcommerceAtributos = useCallback(async (nro) => {
    try {
      const params = nro ? { nro } : {};
      const response = await axios.get(serverURL + "/ecommerceDomain/atributos", { params });
      return response.data;
    } catch (error) { console.error("Error fetching ecommerce atributos:", error); }
  }, [serverURL]);

  const putEcommerceAtributo = async (id, data) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/atributos/${id}`, data);
    return response.data;
  };

  // Parámetros de configuración global de la tienda
  const getEcommerceParametros = useCallback(async () => {
    try {
      const response = await axios.get(serverURL + "/ecommerceDomain/parametros");
      return response.data;
    } catch (error) { console.error("Error fetching ecommerce parametros:", error); }
  }, [serverURL]);

  const putEcommerceParametro = async (clave, data) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/parametros/${clave}`, data);
    return response.data;
  };

  const putEcommerceParametros = async (cambios) => {
    const response = await axios.put(serverURL + "/ecommerceDomain/parametros", { cambios });
    return response.data;
  };

  // Slides del carrusel de la home (tabla ecommerce_banner)
  const getEcommerceBanners = async () => {
    try {
      const response = await axios.get(serverURL + "/ecommerceDomain/banners");
      return response.data;
    } catch (error) { console.error("Error fetching ecommerce banners:", error); }
  };

  const postEcommerceBanner = async (data) => {
    const response = await axios.post(serverURL + "/ecommerceDomain/banners", data);
    return response.data;
  };

  const putEcommerceBanner = async (id, data) => {
    const response = await axios.put(serverURL + `/ecommerceDomain/banners/${id}`, data);
    return response.data;
  };

  const deleteEcommerceBanner = async (id) => {
    const response = await axios.delete(serverURL + `/ecommerceDomain/banners/${id}`);
    return response.data;
  };

  // RETURN DEL CONTEXT ***********************************************************************
  // RETURN DEL CONTEXT ***********************************************************************
  // RETURN DEL CONTEXT ***********************************************************************
  return (
    <ErpContext.Provider
      value={{
        // URL del servidor
        serverURL, // este se usa para generar el link de descarga de los archivos adjuntos.
        // MODULO ECOMMERCE
        getEcommerceItems,
        getEcommerceItemsDisponibles,
        publicarEcommerceItems,
        publicarEcommercePorFiltro,
        quitarEcommerceItems,
        agruparEcommerceItems,
        desagruparEcommerceItems,
        putEcommerceItem,
        putEcommerceItemDimensiones,
        getEcommerceImagenesItem,
        postEcommerceItemImagen,
        putEcommerceItemImagen,
        deleteEcommerceItemImagen,
        putEcommerceImagenesOrden,
        getEcommerceAtributos,
        putEcommerceAtributo,
        getEcommerceParametros,
        putEcommerceParametro,
        putEcommerceParametros,
        getEcommerceBanners,
        postEcommerceBanner,
        putEcommerceBanner,
        deleteEcommerceBanner,
        ///VALUES NEGOCIOS
        ubicaciones,
        postUbicacion,
        getUbicacion,
        updateUbicacion,
        deleteUbicacion,
        buscarDireccion,
        //VALUES NEGOCIOS
        postNegocio,
        getNegocio,
        updateNegocio,
        deleteNegocio,
        negocios,
        //VALUES TIPOENTIDAD
        postTipoEntidad,
        getTipoEntidad,
        updateTipoEntidad,
        deleteTipoEntidad,
        tipoEntidades,
        //VALUES CONDICION IVA
        getCondicionIva,
        getCondicionIvaByEntidad,
        condicionIva,
        //VALUES ENTIDAD
        postEntidad,
        getEntidad,
        entidades,
        getUsuario,
        deleteUsuarioSoft,
        postUsuario,
        updateUsuario,
        usuarios,
        updateEntidadEmail,
        postMoneda,
        getMoneda,
        updateMoneda,
        deleteMoneda,
        monedas,
        getTipoMedioDePago,
        postTipoMedioDePago,
        updateTipoMedioDePago,
        deleteTipoMedioDePago,
        tipoMedioDePago,
        getMedioDePago,
        postMedioDePago,
        updateMedioDePago,
        deleteMedioDePago,
        medioDePago,
        medioDePagoConDescripcion,
        getMedioDePagoConDescripcion,
        mediosDePagoCacheByTipo,
        prefetchMediosDePagoCache,
        getCategoriaTransaccion,
        postCategoriaTransaccion,
        updateCategoriaTransaccion,
        deleteCategoriaTransaccion,
        medioDePagoIdTipoEspecifico,
        getMedioDePagoIdTipoEspecifico,
        getMediosDePagoPorTipos,
        categoriaTransaccion,
        getSubCategoriaTransaccion,
        postSubCategoriaTransaccion,
        updateSubCategoriaTransaccion,
        deleteSubCategoriaTransaccion,
        subCategoriaTransaccion,
        getTipoTransaccion,
        gestionTipoTransaccionTabla,
        gestionTipoTransaccionTablaData,
        postTipoTransaccion,
        updateTipoTransaccion,
        deleteTipoTransaccion,
        postTransaccionPago,
        postCrearPago,
        tipoTransaccion,
        deleteItem,
        transaccionItemsPostDelete,
        getTransaccionItemsByTransactionId,
        deleteTransaccionItemNoLista,
        getItem,
        postItem,
        item,
        getItemTresLetras,
        arrayItemTresLetras,
        itemTresLetras,
        arrayItemTresLetras,
        getItemSuggestions,
        itemUbicacionFilter,
        getItemUbicacionFilter,
        getItemUbicacion,
        postItemUbicacion,
        updateItemUbicacion,
        itemUbicacion,
        updateItem,
        updateItemUbicaciones,
        // Funciones de eliminación masiva
        updateItemUbicacionEliminado,
        getItemUbicacionesByItemId,
        bulkDeleteItems,
        getTransaccionItem,
        postTransaccionItem,
        transaccionItem,
        getTransaccion,
        postTransaccion,
        transaccion,
        transaccionTransformed,
        getTransaccionTransformed,
        entidadesClientesTresLetras,
        getEntidadesClientesTresLetras,
        getTransaccionTransformedVentas,
        getTransaccionTransformedVentasAllData,
        getTransaccionTransformedCompras,
        getTransaccionTransformedPresupuesto,
        getTransaccionTransformedPresupuestosAllData,
        putTransaccion,
        updateTransaccionItem,
        getTransaccionItemByTransactionAndItem,
        updateEntidad,
        getTransaccionItemID,
        generarFacturaPDF,
        getCuentaCorriente,
        getCuentaCorrienteTransformed,
        cuentaCorrienteTransformed,
        postCuentaCorriente,
        updateCuentaCorriente,
        cuentasCorrientes,
        fetchFilteredTransactions,
        getDeletedItemUbicacion,
        getTransaccionFilter,
        transaccionFilter,
        getEntidadByID,
        getItemById,
        postTransaccionDevolucion,
        validarDevolucionCanje,
        postTransaccionItemDevolucion,
        generarRemitoPDF,
        user,
        login,
        logout,
        tenantContext,
        formatoNumericoGlobal,
        formatoFechasGlobal,
        isSessionExpired,
        setIsSessionExpired,
        updateItemAtributo,
        itemAtributo,
        getItemAtributo,
        itemAtributoNoEliminados,
        getItemAtributoNoEliminados,
        updateEntidadAtributo,
        entidadAtributo,
        getEntidadAtributo,
        entidadAtributoNoEliminados,
        getEntidadAtributoNoEliminados,
        // Entidad Atributo Clasificacion
        entidadAtributoClasificacion,
        getEntidadAtributoClasificacion,
        getEntidadAtributoClasificacionByIdAtributo,
        postEntidadAtributoClasificacion,
        updateEntidadAtributoClasificacion,
        deleteEntidadAtributoClasificacion,
        impuestos,
        arrayImpuestos,
        getImpuestos,
        postImpuestos,
        postTransaccionImpuesto,
        getEntidadFilterTipoEntidad,
        postItemProveedor,
        getItemProveedor,
        updateItemProveedor,
        getListaMontosByEntidad,
        getEntidadesUnicasByFilters,
        getValoresUnicosAtributo,
        getValoresUnicosAtributoRecientes,
        formatStock,
        getEntidadByDNI,
        getEntidadByTipoEntidad,
        entidadesTipoEntidad,
        itemAndItemUbicacion,
        getItemAndItemUbicacion,
        updateEliminarEntidad,
        updateDevolverEntidad,
        updateImpuestoEstado,
        updateImpuestoContenido,
        isNavbarCollapsed,
        setIsNavbarCollapsed,
        getItemUbicacionFilterByUbicacion,
        tiposFacturas,
        getTiposFacturas,
        postTransaccionTipoFactura,
        getTransaccionFacturadaData,
        ivaHardcoded,
        getTransaccionMontoTotalByTipoTransaccion,
        enviarFacturaWhatsApp,
        getTop10ItemVentas,
        enviarMail,
        getTop3ItemsLast7Days,
        postListaMonto,
        getItemByCodigoItem,
        getItemByIdentity,
        updateAllPrices,
        updateFilteredPrices,
        updateItemPrecioListaId,
        updatePreciosListaMultiple,
        updateMargenGananciaListaId,
        updateMargenGananciaFiltrado,
        getClientesConPreciosByFiltros,
        promoverProveedorReferente,
        actualizarPreciosClientesDesdeReferente,
        getListaMontosByIdItem,
        updateListaDeMonto,
        updateListaDeMontoBatch,
        getListaMontosByIdItemIdEntidad,
        getEstadoCompra,
        postTransaccionCompraEstado,
        postTransaccionCompraItem,
        getTransaccionItemIDEnCompras,
        updateTransaccionCompraItem,
        updateTransaccionCompraEstado,
        getTransaccionItemByTipoTransaccion,
        getTransaccionItemByTipoTransaccionAllData,
        deleteTransaccionItem,
        deleteTransaccionCompraItem,
        deleteTransaccionPago,
        getLotesDeTransaccion,
        revertirLotesDeTransaccion,
        updateIncluirImpuestos,
        getIncluirImpuestos,
        getCuentaCorrienteByIdEntidad,
        postTransaccionImpuestoItem,
        updateTransaccionImpuestoItem,
        getTransaccionImpuestoItems,
        updateDeleteTransaccion,
        postTransaccionAuditoria,
        getTransaccionAuditoria,
        copiarPreciosEntreEntidades,
        enviarFacturaAfip,
        getAfipSalesPoints,
        createAfipSalesPoint,
        getCajaByMedioDePago,
        crearRecetaApi,
        getBomByIdItem,
        getRecetas,
        getFechaHoraActualClient,
        getRolUsuario,
        postRolUsuario,
        updateRolUsuario,
        getUsuariosByRol,
        deleteRolYUsuarios,
        getMenuAcceso,
        getRolAccesoByIdRol,
        actualizarRolAccesos,
        getComponenteSector,
        getComponenteSectorByMenuAcceso,
        postComponenteSector,
        updateComponenteSector,
        deleteComponenteSector,
        getRolSectorAccesoByIdRol,
        actualizarRolSectorAccesos,
        getRrhhEmpleados,
        getRrhhEmpleadoById,
        buscarEmpleadoPorDocumento,
        postRrhhEmpleado,
        updateRrhhEmpleado,
        getRrhhContratosEmpleado,
        postRrhhContratoEmpleado,
        updateRrhhContratoEmpleado,
        getRrhhTurnos,
        getRrhhTurnoById,
        postRrhhTurno,
        updateRrhhTurno,
        getRrhhAsignacionesTurnoByEmpleado,
        postRrhhAsignacionTurno,
        getRrhhFichajes,
        postRrhhFichaje,
        updateRrhhFichaje,
        deleteRrhhFichaje,
        getRrhhAsistencias,
        updateRrhhAsistencia,
        postRrhhRecalcularAsistencia,
        getRrhhLiquidaciones,
        getRrhhLiquidacionById,
        postRrhhLiquidacion,
        updateRrhhLiquidacion,
        postRrhhRecalcularLiquidacion,
        getRrhhNovedadesLiquidacion,
        postRrhhNovedadLiquidacion,
        updateRrhhNovedadLiquidacion,
        getRrhhReporteResumen,
        getRrhhPlantillas,
        getRrhhPlantillaById,
        postRrhhPlantilla,
        updateRrhhPlantilla,
        duplicateRrhhPlantilla,
        inactivateRrhhPlantilla,
        activateRrhhPlantilla,
        deleteRrhhPlantilla,
        getRrhhPlantillaEmpleados,
        postRrhhPlantillaAsignarEmpleados,
        getRrhhEmpleadoHorario,
        updateRrhhEmpleadoHorarioEspecifico,
        activarRrhhHorarioEspecifico,
        desactivarRrhhHorarioEspecifico,
        getRrhhEmpleadoAdjuntos,
        uploadRrhhEmpleadoAdjunto,
        getRrhhEmpleadoAdjuntoUrl,
        deleteRrhhEmpleadoAdjunto,
        getRrhhAccesoFichaje,
        postRrhhAccesoFichaje,
        deleteRrhhAccesoFichaje,
        getRrhhAreasSugeridas,
        getRrhhPuestosSugeridos,
        getRrhhExcepciones,
        getRrhhExcepcionById,
        postRrhhExcepcion,
        updateRrhhExcepcion,
        cancelRrhhExcepcion,
        aplicarRrhhExcepciones,
        volverRrhhExcepcionesABase,
        enviarRrhhProgramaMail,
        getRrhhPlanificacionEfectiva,
        getRrhhPlanificacionEfectivaBatch,
        getRrhhConfiguracion,
        updateRrhhConfiguracion,
        getRrhhTiposEventualidad,
        postRrhhTipoEventualidad,
        updateRrhhTipoEventualidad,
        deleteRrhhTipoEventualidad,
        getUbicacionesCheckin,
        updateToleranciaUbicacion,
        getSubCategoriaTransaccionByCategoria,
        getGastosTransacciones,
        updateTransaccionPago,
        getTransaccionesPagoFilter,
        getAndPostCajaDatos,
        getCajaAndRecalcularCaja,
        recalcularCajaCompleta,
        getParametrosGlobales,
        getParametrosGlobalesMenu,
        updateParametroGlobal,
        getLogoNavbar,
        getCanalEntidad,
        getImpuestoItem,
        updateImpuestoItem,
        getImpuestosDisponibles,
        getIvaAFIP,
        exportarPLUsBalanza,
        getCondicionIvaByIdEntidad,
        generarNotaCredito,
        guardarComprobante,
        abrirNotaCreditoAfip,
        // Funciones de gestión de lotes
        postLote,
        getLotes,
        getLoteById,
        getLotesByItem,
        updateLote,
        deleteLote,
        getLoteItemUbicacionStock,
        updateLoteItemUbicacionStock,
        getLoteMasAntiguoConStock,
        descontarStockVenta,
        getLotesProximosVencer,
        getSugerenciaLotesVenta,
        getLotesDisponiblesVenta,
        // 🔒 Permisos granulares
        tieneAccesoFuncionalidad,
        // Sesiones
        getUsuariosEnLinea,
        getSesionesUsuario,
        cerrarSesion,
        cerrarTodasSesionesUsuario,
      }}
    >
      {children}
    </ErpContext.Provider>
  );
};
